/* vind-je-motor.js - 'Vind je motor' in de part scanner (gemaakt met overdracht-vind-je-motor\maken.py, 20261018).
   Bron: vragenboom\knoppenboom\ iconen.js + logica.js + modelcodes.js + ui.js. Niet hier aanpassen, maar daar en opnieuw maken. */

/* ---- iconen.js ---- */
// iconen.js - lijnpictogrammen voor 'Vind je motor' (versie 2, 16 oktober 2026).
// Opnieuw ontworpen na onderzoek per onderwerp (workflow vind-je-motor-pictogrammen: vier ontwerpers + eindredactie;
// werkbestanden in tests\iconen_v2\). Eén motorsilhouet voor buitenboord, helmstok, trekkoord en staartlengtes (kap,
// klem over de spiegel, anti-cavitatieplaat, staartstuk, skeg, schroef; voorkant links). Staartlengtes op dezelfde
// schaal: van klem tot plaat 4,6 / 8,2 / 11,8 / 15,4 (stap 3,6, zodat het verschil in een tegel te zien is).
// Hekaandrijving en binnenboord los, zonder boot (Dieter 16 okt; workflow vind-je-motor-hek-binnenboord, tests\iconen_v3\).
// Jetaandrijving (SportJet-pomp, geen schroef) en Zeus-pod (plaat, poot, gondel, dubbele schroef) eigen pictogram
// (16 okt; workflow vind-je-motor-jet-zeus, tests\iconen_v4\samen\).
// Jet daarna opnieuw: onder de bootbodem, pomp en straal naar onder/achter (Dieter 16 okt; tests\iconen_v5\).
// Stijl: 48x48, lijn 2,5 px, ronde uiteinden, kleur = currentColor; altijd met een label erbij.
// Bronnen van overgenomen vormen: trim_hand naar Tabler Icons 'hand-grab', het stuurwiel in afstandsbediening naar
// Tabler Icons 'steering-wheel' (beide MIT-licentie, https://tabler.io/icons). Overige vormen zelf getekend.
(function (wereld) {
  "use strict";
  const svg = (binnen, vb) =>
    `<svg class="ik" viewBox="${vb || "0 0 48 48"}" fill="none" stroke="currentColor" stroke-width="2.5" ` +
    `stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${binnen}</svg>`;

  const IKOON = {
    buitenboord: svg(`<path d="M19.5 24.5C17 22.5 14.5 20 14.5 16V10C14.5 6.5 17 4 20.5 4H29C33.5 4 36.5 7 36.5 11V12.5C36.5 17 33 20.5 28.5 23.5L27.5 35.5H30.5L33 38.25L30.5 41H19.5A2.75 2.75 0 0 1 19.5 35.5C20.2 35.5 20.5 35 20.5 34Z"/><path d="M14.5 15.5H36.2"/><path d="M17 32H35.5"/><path d="M25.3 41L27 45.2H28.6L28.3 41"/><path d="M36.5 33Q39.9 38.25 36.5 43.5Q33.1 38.25 36.5 33Z"/><path d="M19.5 25H12.5V31.5"/><path d="M10.5 31.5H14.5"/>`),
    waterscooter: svg(`<path d="M43.1 23.5H38.1C37.1 23.5 36.6 23 36.1 22L35.1 19.5C34.4 18.3 33.1 17.8 31.6 17.7C27.1 17.2 23.1 17.3 19.6 18.5L17.6 20C15.6 18.5 14.1 16.5 12.6 16L4.1 22.5C6.1 27 9.6 29.5 14.6 29.5H40.1C42.1 29.5 43.1 28 43.1 26.5Z"/><path d="M13.1 16.5L15.6 10.5H18.6"/><path d="M39.6 26H8.1"/><path d="M43.6 37.5C40.1 39.7 36.6 39.7 33.1 37.5S26.1 35.3 22.6 37.5S15.6 39.7 12.1 37.5S6.6 35.9 5.1 36.7"/>`),
    ponton: svg(`<path d="M40.6 26.5H8.1C6.1 26.5 4.6 26.8 4.1 27.5C5.6 30.5 8.6 32.5 12.6 32.5H40.6A3 3 0 0 0 40.6 26.5Z"/><path d="M44.1 26.5V21H11.1C9.1 21 7.6 22.5 7.6 24.5V26.5"/><path d="M36.6 9.5L34.6 7H16.6L14.6 9.5"/><path d="M32.6 7V21M18.6 7V21"/><path d="M43.6 37.5C40.1 39.7 36.6 39.7 33.1 37.5S26.1 35.3 22.6 37.5S15.6 39.7 12.1 37.5S6.6 35.9 5.1 36.7"/>`),
    sportboot: svg(`<path d="M44.1 21H17.6L14.6 19L3.6 16.5C5.1 24 10.1 29.5 17.6 29.5H40.1C42.1 29.5 43.1 28 43.4 26Z"/><path d="M25.6 21L23.6 14H19.1L14.6 19"/><path d="M40.6 25H9.1"/><path d="M43.6 37.5C40.1 39.7 36.6 39.7 33.1 37.5S26.1 35.3 22.6 37.5S15.6 39.7 12.1 37.5S6.6 35.9 5.1 36.7"/>`),
    hekaandrijving: svg(`<path d="M5.86 7.83H8.71A1.9 1.9 0 0 1 10.6 9.73V23.51A1.9 1.9 0 0 1 8.71 25.41H5.86Z"/><path d="M10.6 12.11H15.83M10.6 18.76H16.3"/><path d="M17.25 23.03L15.83 16.86V12.11C15.83 9.07 17.73 6.88 20.1 6.88L27.23 7.83C29.6 8.21 31.12 9.54 31.7 11.63L35.11 23.03"/><path d="M15.35 23.03H41.95"/><path d="M28.56 23.03L29.91 31.58H33.2L35.92 34.58L33.2 37.6H21.17A3 3 0 0 1 21.17 31.58C21.94 31.58 22.27 31.04 22.27 29.94L20.68 23.03"/><path d="M27.51 37.6L29.37 42.18H31.12L30.78 37.6"/><path d="M39.96 28.1Q44.16 34.58 39.96 41.06Q35.76 34.58 39.96 28.1Z"/>`),
    binnenboord: svg(`<path d="M4.35 21.19V28.35M4.35 24.77H7.93"/><path d="M7.93 16.58H27.37V30.91H7.93Z"/><path d="M7.93 21.7H27.37"/><path d="M10.49 16.58V14.54A1.53 1.53 0 0 1 12.02 13H23.79A1.53 1.53 0 0 1 25.33 14.54V16.58"/><path d="M14.07 13V10.44M12.54 10.44H15.61"/><path d="M10.49 30.91L12.02 34.49H23.28L24.82 30.91"/><path d="M27.37 18.12L30.96 21.19H33A1.53 1.53 0 0 1 34.54 22.72V32.44H30.96L27.37 30.91"/><path d="M34.54 29.89L44.25 33.43"/><path d="M43.58 27.46Q45.02 33.7 39.91 37.56Q38.48 31.33 43.58 27.46Z"/>`),
    jetaandrijving: svg(`<path d="M20.05 13.95L32.11 19.32L38.33 26.96L34.58 35.41L24.73 35.89L12.67 30.53"/><path d="M32.11 19.32L24.73 35.89"/><path d="M20.05 13.95L12.67 30.53"/><path d="M24.58 22.17L25.8 26.45L21.81 28.39"/><path d="M40.92 28.48L44.13 29.91M39.17 32.4L43.49 34.32M37.43 36.31L40.64 37.74"/><path d="M12.67 30.53C3.12 26.28 7.07 21.65 6.85 13.95"/><path d="M5.2 13.95L29.4 13.95L31.38 5.7"/><path d="M10.7 13.95L10.7 17.69M14.88 13.95L14.88 17.69"/>`),
    zeuspod: svg(`<rect x="9.7" y="5.9" width="24" height="4.5" rx="1.5"/><path d="M12.7 10.4L16.7 26.4M27.7 10.4V26.4"/><path d="M29.7 26.4H9.2A4.5 4.5 0 0 0 9.2 35.4H29.7L33.2 30.9Z"/><path d="M33.2 30.9H41.7"/><path d="M35.1 23.9Q38.9 30.9 35.1 37.9Q31.3 30.9 35.1 23.9Z"/><path d="M41.7 26.15Q44.9 30.9 41.7 35.65Q38.5 30.9 41.7 26.15Z"/><path d="M15.7 35.4L21.7 42.4H24.2L25.2 35.4"/>`),
    trolling: svg(`<path d="M25.1 4.5H33.6A3.5 3.5 0 0 1 33.6 11.5H25.1A3.5 3.5 0 0 1 25.1 4.5Z"/><path d="M21.6 7.8L13.6 7.2"/><rect x="5.6" y="5" width="8" height="4.4" rx="2.2"/><path d="M29.1 11.5V34"/><path d="M29.1 15.5H22.1V24.5"/><path d="M20.1 24.5H24.1"/><path d="M35.6 34H23.1A3 3 0 0 0 23.1 40H35.6L37.6 37Z"/><path d="M28.1 40L29.6 44"/><path d="M40.6 31.5Q44.1 37 40.6 42.5Q37.1 37 40.6 31.5Z"/>`),
    helmstok: svg(`<path d="M28.4 23.9C26.35 22.26 24.3 20.21 24.3 16.93V12.01C24.3 9.14 26.35 7.09 29.22 7.09H36.19C39.88 7.09 42.34 9.55 42.34 12.83V14.06C42.34 17.75 39.47 20.62 35.78 23.08L34.96 32.92H37.42L39.47 35.17L37.42 37.43H28.4A2.25 2.25 0 0 1 28.4 32.92C28.97 32.92 29.22 32.51 29.22 31.69Z"/><path d="M24.3 16.52H42.09"/><path d="M26.35 30.05H41.52"/><path d="M33.16 37.43L34.55 40.87H35.86L35.62 37.43"/><path d="M42.34 30.87Q45.13 35.17 42.34 39.48Q39.55 35.17 42.34 30.87Z"/><path d="M28.4 24.31H22.66V29.64"/><path d="M21.02 29.64H24.3"/><path d="M26.4 18.85L14.81 17.23"/><path d="M25.49 21.75L14.4 20.2"/><path d="M15.01 15.84L8.47 14.92A2.9 2.9 8 0 0 7.66 20.66L14.2 21.58Z"/><path d="M8.67 14.95L7.86 20.69"/>`),
    afstandsbediening: svg(`<circle cx="16" cy="25" r="12.5"/><circle cx="16" cy="25" r="3.5"/><path d="M16 28.5v9M12.6 24 4 21.6M19.4 24l8.6-2.4"/><path d="M31.5 42.5c0-4 2.9-6.5 6.5-6.5s6.5 2.5 6.5 6.5z"/><path d="M38 36 34.6 13.2"/><circle cx="34.1" cy="10" r="3.2"/>`),
    trekkoord: svg(`<path d="M29.2 28.04C27.25 26.48 25.3 24.53 25.3 21.41V16.73C25.3 14 27.25 12.05 29.98 12.05H36.61C40.12 12.05 42.46 14.39 42.46 17.51V18.68C42.46 22.19 39.73 24.92 36.22 27.26L35.44 36.62H37.78L39.73 38.77L37.78 40.91H29.2A2.15 2.15 0 0 1 29.2 36.62C29.75 36.62 29.98 36.23 29.98 35.45Z"/><path d="M25.3 21.02H42.23"/><path d="M27.25 33.89H41.68"/><path d="M33.72 40.91L35.05 44.19H36.3L36.06 40.91"/><path d="M42.46 34.67Q45.11 38.77 42.46 42.86Q39.81 38.77 42.46 34.67Z"/><path d="M29.2 28.43H23.74V33.5"/><path d="M22.18 33.5H25.3"/><path d="M25.3 16.57H10.2"/><path d="M7.6 10.57A2.6 2.6 0 0 1 10.2 13.17V19.97A2.6 2.6 0 0 1 5 19.97V13.17A2.6 2.6 0 0 1 7.6 10.57Z"/><path d="M28.3 8.07H12.7M16.3 4.47L12.7 8.07L16.3 11.67"/>`),
    elektrisch: svg(`<path d="M22 9.4a9 9 0 1 0 11 0"/><path d="M27.5 5.5v9"/><circle cx="11" cy="34" r="7"/><circle cx="8.8" cy="34" r="1.7" fill="currentColor" stroke="none"/><path d="M18 34h25"/><path d="M31 34v3.5l2.5 2 2.5-2 2.5 2 2.5-2V34"/>`),
    staart_kort: svg(`<path d="M22.03 18.1C20.28 16.7 18.53 14.95 18.53 12.15V7.95C18.53 5.5 20.28 3.75 22.73 3.75H28.68C31.83 3.75 33.93 5.85 33.93 8.65V9.7C33.93 12.85 31.48 15.3 28.33 17.4L27.63 25.5H29.73L31.48 27.42L29.73 29.35H22.03A1.92 1.92 0 0 1 22.03 25.5C22.52 25.5 22.73 25.15 22.73 24.45Z"/><path d="M18.53 11.8H33.72"/><path d="M20.28 23.05H33.23"/><path d="M26.09 29.35L27.28 32.29H28.4L28.19 29.35"/><path d="M33.93 23.75Q36.31 27.42 33.93 31.1Q31.55 27.42 33.93 23.75Z"/><path d="M22.03 18.45H17.13V23.05H12.93"/>`),
    staart_lang: svg(`<path d="M22.03 18.1C20.28 16.7 18.53 14.95 18.53 12.15V7.95C18.53 5.5 20.28 3.75 22.73 3.75H28.68C31.83 3.75 33.93 5.85 33.93 8.65V9.7C33.93 12.85 31.48 15.3 28.33 17.4L27.63 29.1H29.73L31.48 31.02L29.73 32.95H22.03A1.92 1.92 0 0 1 22.03 29.1C22.52 29.1 22.73 28.75 22.73 28.05Z"/><path d="M18.53 11.8H33.72"/><path d="M20.28 26.65H33.23"/><path d="M26.09 32.95L27.28 35.89H28.4L28.19 32.95"/><path d="M33.93 27.35Q36.31 31.02 33.93 34.7Q31.55 31.02 33.93 27.35Z"/><path d="M22.03 18.45H17.13V26.65H12.93"/>`),
    staart_extra: svg(`<path d="M22.03 18.1C20.28 16.7 18.53 14.95 18.53 12.15V7.95C18.53 5.5 20.28 3.75 22.73 3.75H28.68C31.83 3.75 33.93 5.85 33.93 8.65V9.7C33.93 12.85 31.48 15.3 28.33 17.4L27.63 32.7H29.73L31.48 34.62L29.73 36.55H22.03A1.92 1.92 0 0 1 22.03 32.7C22.52 32.7 22.73 32.35 22.73 31.65Z"/><path d="M18.53 11.8H33.72"/><path d="M20.28 30.25H33.23"/><path d="M26.09 36.55L27.28 39.49H28.4L28.19 36.55"/><path d="M33.93 30.95Q36.31 34.62 33.93 38.3Q31.55 34.62 33.93 30.95Z"/><path d="M22.03 18.45H17.13V30.25H12.93"/>`),
    staart_xx: svg(`<path d="M22.03 18.1C20.28 16.7 18.53 14.95 18.53 12.15V7.95C18.53 5.5 20.28 3.75 22.73 3.75H28.68C31.83 3.75 33.93 5.85 33.93 8.65V9.7C33.93 12.85 31.48 15.3 28.33 17.4L27.63 36.3H29.73L31.48 38.23L29.73 40.15H22.03A1.92 1.92 0 0 1 22.03 36.3C22.52 36.3 22.73 35.95 22.73 35.25Z"/><path d="M18.53 11.8H33.72"/><path d="M20.28 33.85H33.23"/><path d="M26.09 40.15L27.28 43.09H28.4L28.19 40.15"/><path d="M33.93 34.55Q36.31 38.23 33.93 41.9Q31.55 38.23 33.93 34.55Z"/><path d="M22.03 18.45H17.13V33.85H12.93"/>`),
    trim_elektrisch: svg(`<rect x="13" y="4" width="22" height="40" rx="11"/><path d="M17.5 24h13"/><path d="M19.6 17.2L24 11.4l4.4 5.8z" fill="currentColor" stroke-width="1.5"/><path d="M19.6 30.8L24 36.6l4.4-5.8z" fill="currentColor" stroke-width="1.5"/>`),
    trim_hand: svg(`<path d="M22.6 21.4L22.6 15.8A2.4 2.4 0 0 1 27.4 15.8L27.4 19.8"/><path d="M27.4 19L27.4 14.2A2.4 2.4 0 0 1 32.2 14.2L32.2 19.8"/><path d="M32.2 15.8A2.4 2.4 0 0 1 37 15.8L37 19.8"/><path d="M37 19A2.4 2.4 0 0 1 41.8 19L41.8 26.2A9.6 9.6 0 0 1 32.2 35.8L29.34 35.8A9.6 9.6 0 0 1 21.32 31.48L21 31C20.5 30.23 18.74 27.18 15.74 21.83A2.4 2.4 0 0 1 16.6 18.6A2.99 2.99 0 0 1 20.25 19.05L22.6 21.4"/><path d="M5.8 25.4A20.5 20.5 0 0 1 15.8 11.2"/><path d="M11.9 10.5L15.8 11.2L14.4 15.0"/>`),
    trim_gasveer: svg(`<path d="M13.73 39.92L28.38 25.28L22.72 19.62L8.08 34.27Z"/><path d="M25.55 22.45L37.66 10.34"/><path d="M10.2 37.8L10.9 37.1"/><circle cx="8.5" cy="39.5" r="2.4"/><circle cx="39.5" cy="8.5" r="2.4"/>`),
    draai_normaal: svg(`<path d="M18.1 21.5C17.7 21.2 16.1 20.2 15.4 19.3C14.6 18.5 13.5 17.3 13.4 16.4C13.3 15.4 14 14.3 14.9 13.6C15.7 12.9 17.3 12.4 18.5 12.4C19.7 12.4 21.2 12.8 22.1 13.7C23 14.5 23.7 16.2 23.9 17.4C24.1 18.6 23.4 20.1 23.2 20.7C23 21.4 22.7 21.4 22.6 21.5"/><path d="M25.4 26.3C26 26.1 27.6 25.2 28.7 25C29.8 24.7 31.4 24.4 32.2 24.8C33.1 25.2 33.8 26.4 33.9 27.4C34.1 28.5 33.8 30.1 33.2 31.2C32.5 32.2 31.4 33.3 30.2 33.7C29.1 34 27.2 33.8 26.1 33.3C25 32.9 24 31.6 23.6 31.1C23.1 30.5 23.3 30.3 23.2 30.2"/><path d="M17.7 30.2C17.6 30.8 17.5 32.6 17.1 33.7C16.8 34.8 16.3 36.3 15.6 36.9C14.8 37.4 13.4 37.4 12.4 37C11.4 36.6 10.2 35.5 9.6 34.5C9 33.4 8.6 31.9 8.8 30.7C9.1 29.5 10.3 28 11.2 27.3C12.1 26.6 13.8 26.4 14.4 26.2C15.2 26.1 15.2 26.3 15.4 26.4"/><circle cx="20.4" cy="26" r="5"/><circle cx="20.4" cy="26" r="1.2" fill="currentColor" stroke="none"/><path d="M11.3 8.9A19.4 19.4 0 0 1 32.3 41.3"/><path d="M38.5 41.3L32.3 41.3L33.8 35.3"/>`),
    draai_tegen: svg(`<path d="M29.9 21.5C30.3 21.2 31.9 20.2 32.6 19.3C33.4 18.5 34.5 17.3 34.6 16.4C34.7 15.4 34 14.3 33.1 13.6C32.3 12.9 30.7 12.4 29.5 12.4C28.3 12.4 26.8 12.8 25.9 13.7C25 14.5 24.3 16.2 24.1 17.4C23.9 18.6 24.6 20.1 24.8 20.7C25 21.4 25.3 21.4 25.4 21.5"/><path d="M22.6 26.3C22 26.1 20.4 25.2 19.3 25C18.2 24.7 16.6 24.4 15.8 24.8C14.9 25.2 14.2 26.4 14.1 27.4C13.9 28.5 14.2 30.1 14.8 31.2C15.4 32.2 16.6 33.3 17.8 33.7C18.9 34 20.8 33.8 21.9 33.3C23 32.9 24 31.6 24.4 31.1C24.9 30.5 24.7 30.3 24.8 30.2"/><path d="M30.3 30.2C30.4 30.8 30.5 32.6 30.9 33.7C31.2 34.8 31.7 36.3 32.4 36.9C33.2 37.4 34.6 37.4 35.6 37C36.6 36.6 37.9 35.5 38.5 34.5C39 33.4 39.4 31.9 39.1 30.7C38.9 29.5 37.7 28 36.8 27.3C35.9 26.6 34.2 26.4 33.5 26.2C32.9 26.1 32.8 26.3 32.6 26.4"/><circle cx="27.6" cy="26" r="5"/><circle cx="27.6" cy="26" r="1.2" fill="currentColor" stroke="none"/><path d="M36.7 8.9A19.4 19.4 0 0 0 15.7 41.3"/><path d="M9.5 41.3L15.7 41.3L14.2 35.3"/>`),
    tweetakt: svg(`<path d="M17 4.5H36a3 3 0 0 1 3 3V40.5a3 3 0 0 1-3 3H12a3 3 0 0 1-3-3V12.5z"/><path d="M13 8.5L10.7 6.2"/><path d="M8.5 8.5L13 4"/><rect x="24" y="8.1" width="10" height="4.4" rx="2.2"/><path d="M33.3 25.7H25.2L20.9 30V34.3H33.3z"/><path d="M33.3 27.4h2.2a1.7 1.7 0 0 1 1.7 1.7v1.7a1.7 1.7 0 0 1-1.7 1.7h-2.2"/><path d="M28.4 25.7V23.2M25.9 23.2h5"/><path d="M20.9 30L14.4 26.5"/><path d="M14.4 29.3C15.2 30.9 16.6 31.7 16.6 32.4a2.2 2.2 0 0 1-4.5 0C12.2 31.7 13.6 30.9 14.4 29.3z" fill="currentColor" stroke-width="1"/>`),
    viertakt: svg(`<circle cx="30.2" cy="10.7" r="5.2"/><path d="M20.7 13.4L27.5 20.2M22 14.7L23.8 12.8L28.1 17.1L26.2 18.9"/><path d="M24.1 16.8L16.1 24.8"/><path d="M14.1 22.9L18 26.8L10.1 34.7A2.8 2.8 0 0 1 6.2 30.8z"/><path d="M11.5 25.4L15.5 29.4"/><path d="M8.8 28.1L12.8 32.1L10.1 34.7A2.8 2.8 0 0 1 6.2 30.8z" fill="currentColor"/><path d="M36 23.6c-4.7 5.8-7 8.7-7 12.2a7 7 0 0 0 14 0c0-3.4-2.3-6.4-7-12.2z"/>`),
    plaatje: svg(`<rect x="4" y="10" width="40" height="28" rx="3"/><circle cx="8.6" cy="14.6" r="1.4" fill="currentColor" stroke="none"/><circle cx="39.4" cy="14.6" r="1.4" fill="currentColor" stroke="none"/><circle cx="8.6" cy="33.4" r="1.4" fill="currentColor" stroke="none"/><circle cx="39.4" cy="33.4" r="1.4" fill="currentColor" stroke="none"/><rect x="13.5" y="14.6" width="6" height="4.2" rx="1" fill="currentColor" stroke="none"/><path d="M23 16.7h11.5"/><path d="M14 24.5h4.5M22 24.5h12.5"/><path d="M14 31.5h4.5"/><path d="M22 31.5h2.2M27.2 31.5h2.2M32.3 31.5h2.2"/>`),
    vraag: svg(`<circle cx="24" cy="24" r="18"/><path d="M19 19a5 5 0 1 1 7 4.6c-1.3.6-2 1.6-2 3V29"/><path d="M24 34.5v.5"/>`),
    terug: svg(`<path d="M29 10L15 24l14 14"/>`),
    verder: svg(`<path d="M19 10l14 14-14 14"/>`),
    filter: svg(`<path d="M8 12h20M36 12h4M8 24h6M22 24h18M8 36h22M38 36h2"/><circle cx="32" cy="12" r="4"/><circle cx="18" cy="24" r="4"/><circle cx="34" cy="36" r="4"/>`),
    vink: svg(`<path d="M10 25l9 9 19-20"/>`),
    kruis: svg(`<path d="M14 14l20 20M34 14L14 34"/>`),
    potlood: svg(`<path d="M30 9l9 9L19 38l-11 2 2-11z"/><path d="M26 13l9 9"/>`),
    lijst: svg(`<path d="M16 12h24M16 24h24M16 36h24"/><path d="M8 12h.5M8 24h.5M8 36h.5"/>`),
  };

  // Welk pictogram hoort bij welke keuze (veld + waarde, of soort).
  const BIJ = {
    soort: {
      "Buitenboordmotor": "buitenboord", "Waterscooter (WaveRunner)": "waterscooter", "Waterscooter": "waterscooter",
      "Pontonboot (Switch)": "ponton", "Sportboot (jetboot)": "sportboot",
      "Hekaandrijving (MerCruiser)": "hekaandrijving", "Binnenboordmotor": "binnenboord",
      "Elektrische trollingmotor": "trolling", "Jetaandrijving (SportJet)": "jetaandrijving",
    },
    bediening: { helmstok: "helmstok", afstandsbediening: "afstandsbediening" },
    start: { trekkoord: "trekkoord", elektrisch: "elektrisch" },
    staart: { kort: "staart_kort", lang: "staart_lang", "extra lang": "staart_extra", "XX-lang": "staart_xx" },
    trim: { elektrisch: "trim_elektrisch", "met de hand": "trim_hand", "met een gasveer of hydraulisch": "trim_gasveer" },
    takt: { tweetakt: "tweetakt", viertakt: "viertakt" },
    draairichting: { normaal: "draai_normaal", tegengesteld: "draai_tegen" },
  };
  const ikoonVoor = (veld, waarde) => { const n = (BIJ[veld] || {})[waarde]; return n ? IKOON[n] : ""; };

  wereld.IKOON = IKOON;
  wereld.ikoonVoor = ikoonVoor;
})(window);

/* ---- logica.js ---- */
// logica.js - de zoeklogica van de knoppenboom, los van de opmaak (13 oktober 2026).
//
// Een klant zonder typeplaatje kiest een merk, loopt de boom van de fabrikant door (soort, klik 1,
// eventueel een vermogensstap, klik 2) en filtert daarna de lijst op wat hij aan zijn motor ziet.
// Elke motor is "zeker" (past op alles wat de klant koos) of "misschien" (een keuze kon niet
// worden getoetst: geen pad in de boom, kenmerk onbekend, of net buiten de jaarmarge).
// Misschien gaat nooit weg: een klant mag zijn eigen motor niet kwijtraken door een gat in onze
// gegevens (meting filterknoppen_meten.py: streng filteren kost 33% van de klanten mogelijk hun motor).
//
// Bevindingen uit de klanttest van 13 okt (workflow knoppenboom-klanttest) die hier zijn opgelost:
//   - de vermogensstap toetst op het pk van de motor zelf, niet op de kop van zijn knop
//   - jaarknop en jaarfilter hebben een scheve marge: aankoopjaar J dekt modeljaar J-2 t/m J+1,
//     een jaar verder is "misschien"
//   - 'voor 1968' en '2013 of later' (lettergroepen) doen mee in de jaarmarge
//   - Sea-Doo: dezelfde serie heet per jaar soms anders; buurjaren met dezelfde serienaam = misschien
//   - getallen op knoppen en chips tellen kaarten (motoren), geen catalogusrijen
//   - een filter met een bekende waarde naast onbekende waarden wordt ook getoond
//   - het Bouwjaar-filter blijft bestaan na 'Weet ik niet' bij de jaarstap
//
// EINDLIJST 16 okt 2026 (tests/doorklik/workflow_resultaat.json: ontwerp + controle; Dieter: "12 motoren met allemaal
// verschillende afkortingen die de klant niks zegt") - een regel voor alle merken:
// KAART = WAT JE HERKENT, VERSIE = WAT ECHT ANDERS IS.
//   - een kaart = kaartnaam (m.kn uit de export: wat op de kap/romp staat) + wat je aan de motor ziet (KAART_ZICHT),
//     maar alleen voor kenmerken waarin motoren met dezelfde naam echt verschillen (bereid()). Kaarten met precies
//     dezelfde onderdelenlijsten vallen samen (kaartSleutels(): Evinrude 40 pk 1991, alle varianten 767 regels).
//   - binnen een kaart is een versie = een onderdelenlijst (m.og): codes en modeljaren met precies dezelfde
//     onderdelen zijn een keuze. Versies staan op waarschijnlijkheid (versies()).
//   - weten we het bouwjaar nog niet en blijven er na de vragen meer dan INSTELLING.keuzesGenoeg keuzes over, dan
//     vragen we het (jaarStap(): 'Welk bouwjaar?' / 'Welk jaar precies?'). Die vraag is ZACHT: buiten de marge wordt
//     een motor 'kan ook', nooit weg; het antwoord stuurt alleen zeker/kan ook en de volgorde. De tegels lopen over
//     alle motoren die nog meedoen, ook 'kan ook' (controle: de VXR van 1991 vond zijn jaar niet).
//   - een jaarantwoord is een MODELJAAR (we vragen het bouwjaar): het genoemde jaar en het jaar ervoor staan allebei
//     bovenaan, het genoemde eerst (doelJaren(); klanten noemen vaak het aankoopjaar). Ook bij de jaarstap van
//     Evinrude/Johnson/Sea-Doo (was: antwoord min een).
//
// CONTROLE2 17 okt 2026 (tests/doorklik/controle2: drie controleurs; herstel in tests/doorklik/na_herstel):
//   - ELK jaarantwoord is zacht: de jaarstap van Evinrude/Johnson/Sea-Doo (k1Sets), de tijdvakken (dec, dec2), het
//     bouwjaarfilter en 'Weet ik niet' na een tijdvak. Buiten de marge 'kan ook', nooit weg (was hard: bij 3 jaar
//     ernaast raakte 63% van de Evinrude-klanten zijn motor kwijt). '2013 of later' heeft de marge van een jaarknop 2013.
//   - jaarVan(): BRP vanaf 2013 heeft geen modeljaar, alleen een lettergroep -> '2013 of later' (was: jaar onbekend, dus
//     na '2010 of later' > Weet ik niet stonden alle E-TEC's vanaf 2013 bij 'Kan ook').
//   - pk2: een tweede vermogen (jet van voor E-TEC: blok en pomp); de pk-vragen toetsen op allebei. Bij Evinrude/Johnson
//     toetst klik 2 (de pk-tegel) ook op het pk van de motor zelf (9,9 tegenover de catalogustegel '10 pk').
//   - lijstKaarten(): de lijst zoals ui.js hem toont (de tests meten nu precies dat). Scheidt alleen het jaar een motor
//     van een zekere kaart met dezelfde naam, dan staat hij als lagere versie in die kaart in plaats van dichtgeklapt
//     onder 'Kan ook'; 'Kan ook' zelf op dezelfde naam/tegel en het dichtstbijzijnde jaar in de kaart.
//   - kaartSleutels(): kaarten met dezelfde naam die een onderdelenlijst DELEN worden een kaart (was: alleen precies
//     dezelfde verzameling; Evinrude 9,9 pk gaf 4 bijna gelijke kaarten).
//   - versies: het genoemde jaar J, J-1 en J+1 tellen alle drie als 'jouw jaar' (in die volgorde).
//   - de jaarmarge is symmetrisch: J-2 .. J+2 is zeker (was J-2 .. J+1).
//   - 'wat zie je': weinig kaarten maar veel versies (E-TEC G2 vanaf 2013: 8 kaarten, 189 versies) telt in keuzes.
//
// WATERSCOOTERVOLGORDE 17 okt 2026 (Dieter: "kunnen we bij Yamaha waverunners de volgende volgorde gebruiken? Model -> cc
// -> Jaar?"; tests/ws_volgorde): Yamaha > Waterscooter > 'Welk model?' (de romptegel: FX, GP, VX ...) > 'Welk model
// precies?' (de handelsnaam, alleen als de romp er meer heeft) > 'Hoe groot is de motor?' (alleen als de machines die over
// zijn echt in cc verschillen) > de zachte bouwjaarvraag. Was: cc-klasse > romp > handelsnaam > jaar. Zie wsStap().
// Herstel na de controle (17 okt, tests/ws_volgorde/na_herstel; twee controleurs):
//   - 'Weet ik niet' bij het model of de cc: 'Welk jaar precies?' na het tijdvak alleen voor de volgorde; zeker/kan ook op het
//     tijdvak, met een marge van 3 jaar (bij 3-4 jaar ernaast stond de eigen machine onder 'Kan ook' achter andere: 87/71/126
//     lijst fout, oud 3/5/40).
//   - eigen grens MAX_NAMEN voor naamtegels (romp, handelsnaam); meer romptegels dan dat: eerst de cc-klasse van de boom
//     (klik 1, staat in ui.js voor het model: de antwoordchips kloppen; was S.cc vooraf, met kapotte chips).
//   - romp 'Ander model': geen handelsnaamvraag (de tegels waren codes van het typeplaatje).
//   - 'Kan ook': eerst de gekozen naam, dan dezelfde romp, dan de rest (was: romp en naam even hoog); de rest (andere romp)
//     telt niet mee in het aantal en staat achter 'Toon andere waterscooters' (lijstKaarten: ookDichtbij).
//   - jaartegels: het + 1-jaar is bij waterscooters geen eigen tijdvak ('2020 of later' na '700 cc 1994 – 2019').
//
// JAREN DIRECT 18 okt 2026 (Dieter: "nu doen we voor de jaartallen een tussenstap met een range van jaren en daarna een
// kleinere lijst van jaren. maar ik wil eigenlijk die tussenstap weg en gewoon alle jaren onder elkaar/naast elkaar. dat
// scheelt een klik."; tests/jaren_direct): elke jaarvraag toont alle jaren tegelijk (ui.js groepeert ze per decennium), geen
// tijdvak meer ervoor. Weg: de stap 'dec' (Evinrude/Johnson/Sea-Doo: klik 1 toont meteen alle jaarknoppen, KB.jaarKnoppen) en
// 'jaar2' ('Welk jaar precies?' na een tijdvak); dec2 (het bouwjaar voor het model) en jaar (na de vragen) zijn nu een los jaar
// (boomJaarTegels, jaarTegels). De betekenis is gelijk: elk jaarantwoord is zacht, het genoemde jaar en het jaar ervoor staan
// bovenaan, BRP vanaf 2013 blijft de groepsknop '2013 of later'. Waar eerst het tijdvak kwam (dec2; de bouwjaarvraag bij meer
// dan MAX_GETALLEN jaren) telt het losse jaar voor zeker/kan ook precies zoals dat tijdvak toen (jaarToets, dec2Toets); het jaar
// zelf zet nu ook daar de versies van dat jaar bovenaan; het bouwjaarfilter in de lijst staat er waar het toen stond.
// Oude adressen met dec/jaar2 of een tijdvak vertaalt uitHash().
// Afgemaakt 18 okt (tweede bouwer, tests/jaren_direct/bewust_check.js): ook welke 'kan ook'-motoren als lagere versie in een
// zekere kaart staan, gaat daar weer zoals toen op het tijdvak (doelRuim); met alleen J verdwenen die uit de kaarten (Suzuki
// DF 115 2006 zonder serienummerveld). Het jaar J bepaalt dus alleen de volgorde, 'jouw jaar' en de jaarhint.
//
// Gebruik (browser): window.KB. Gebruik (node, tests): require("./logica.js").
(function (wereld) {
  "use strict";

  const MAX_LIJST = 12;            // meer tegels dan dit: eerst een makkelijke tussenvraag (ontwerp 13 okt)
  const MAX_GETALLEN = 18;         // pk-getallen op volgorde: tot zoveel tegels zonder klassevraag
  // Namen zoals ze op de romp staan, op alfabet in compacte tegels (waterscooter, 17 okt; controle: MAX_GETALLEN is voor
  // getallen): tot zoveel zonder tussenvraag. Nu 17 romptegels + 'Ander model', FX 15 handelsnamen. Een tussenvraag zou de
  // klant een woord laten kiezen dat niet op zijn romp staat; meer romptegels: eerst de cc-klasse (wsStap).
  const MAX_NAMEN = 18;
  // Controle2 17 okt: symmetrisch (het antwoord is een modeljaar, aankoopjaar of productiejaar); was [-2, 1] / [-3, 2]:
  // wie 2 jaar te vroeg noemde, kreeg zijn motor alleen onder 'Kan ook'.
  const JAAR_ZEKER = [-2, 2];      // genoemd jaar J -> modeljaar J-2 .. J+2 is zeker
  const JAAR_MISSCHIEN = [-3, 3];  // daarbuiten tot J-3 .. J+3: misschien (ook 'kan ook': alle jaarvragen zijn zacht)
  const PK_GROEP_MIN = 0.6;        // minstens dit deel van de motoren moet een pk hebben
  // Meer keuzes (kaarten x versies) dan dit en geen jaar: vraag het jaar (instelbaar voor metingen).
  const INSTELLING = { keuzesGenoeg: 4 };   // 4 = wat een kaart toont zonder "Toon alle versies"
  const KAART_ZICHT = ["bediening", "start", "staart", "trim", "takt"];   // zichtbaar = eigen kaart
  const REGIO_HIER = new Set(["Europa", "Europe", "International"]);      // uitvoering voor NL eerst

  const nl = x => (x == null ? "" : String(x).replace(".", ","));
  const normNaam = n => String(n || "").replace(/-(19|20)\d\d$/, "");
  const kaartNaam = m => m.kn || normNaam(m.n);
  // Niet van toepassing: een jet heeft geen staart (de decoder laat hem bewust leeg) - geen kaart, geen 'Onbekend'.
  const nvt = (m, v) => v === "staart" && m.k.uitvoering === "Jet";
  // Wat je ziet hoort bij de kaart - maar alleen voor kenmerken waarin motoren met dezelfde kaartnaam echt
  // verschillen (twee bekende waarden, bv. 'Evinrude 40 pk' met helmstok en met stuurwiel); daar is een onbekende
  // waarde ook een eigen kaart ('Onbekend: sturen'). Zegt de naam het kenmerk al (Honda 'BF150 XCU', Mercury-namen),
  // dan splitst een gat in onze gegevens de kaart niet. bereid() zet de sleutel per motor (m._ks).
  const naamSleutel = m => kaartNaam(m) + "|" + (m.merk_rij || "");
  function bereid(D) {
    if (D._bereid) return;
    const per = new Map();
    for (const m of D.motoren) {
      const n = naamSleutel(m);
      if (!per.has(n)) per.set(n, Object.fromEntries(KAART_ZICHT.map(v => [v, new Set()])));
      for (const v of KAART_ZICHT) if (m.k[v] != null) per.get(n)[v].add(m.k[v]);
    }
    for (const m of D.motoren) {
      const n = naamSleutel(m), velden = KAART_ZICHT.filter(v => per.get(n)[v].size > 1);
      const w = v => (nvt(m, v) ? "-" : m.k[v] == null ? "?" : m.k[v]);
      Object.defineProperty(m, "_ks", { value: n + "|" + velden.map(v => v + "=" + w(v)).join("/"), enumerable: false, configurable: true });
    }
    Object.defineProperty(D, "_bereid", { value: true, enumerable: false, configurable: true });
  }
  const kaartSleutel = m => m._ks || naamSleutel(m);
  // Een versie = een onderdelenlijst (og); zonder og (geen onderdelen, of gegevens van voor 16 okt) is elke motor
  // een eigen versie.
  const versieSleutel = m => (m.og != null ? "o" + m.og : "i" + m.id);
  // Kaarten met dezelfde naam en precies dezelfde verzameling onderdelenlijsten worden een kaart (controle 16 okt:
  // Evinrude 40 pk 1991 gaf 4 kaarten trekkoord/sleutel x kort/lang met dezelfde 767 regels; Johnson BJ25ARLEDC
  // deelt zijn lijst met J25RMLEDC). Hangt af van de rijen die meedoen -> een functie m => sleutel.
  // Controle2 17 okt: kaarten met dezelfde naam die een onderdelenlijst DELEN worden een kaart (vereniging; was: alleen
  // precies dezelfde verzameling). Evinrude 9,9 pk gaf 4 kaarten waarvan er drie per jaar dezelfde lijst hadden (E10RLECC
  // helmstok en E10RELECC stuurwiel: og 622); het verschil (helmstok/stuurwiel, staart) staat nu bij de versie.
  function kaartSleutels(rijen) {
    const per = new Map(), naam = new Map();
    for (const r of rijen) {
      const k = kaartSleutel(r.m);
      if (!per.has(k)) { per.set(k, new Set()); naam.set(k, naamSleutel(r.m)); }
      per.get(k).add(versieSleutel(r.m));
    }
    const ouder = new Map();
    const vind = k => { let x = k; while (ouder.get(x) !== x) x = ouder.get(x); ouder.set(k, x); return x; };
    for (const k of per.keys()) ouder.set(k, k);
    const eerste = new Map();                        // naam#onderdelenlijst -> eerste kaart met die lijst
    for (const [k, set] of per) for (const v of set) {
      if (v[0] !== "o") continue;                    // zonder onderdelenlijst niets samenvoegen
      const s = naam.get(k) + "#" + v;
      if (!eerste.has(s)) { eerste.set(s, k); continue; }
      const a = vind(eerste.get(s)), b = vind(k);
      if (a !== b) ouder.set(b, a);
    }
    return m => { const k = kaartSleutel(m); return ouder.has(k) ? vind(k) : k; };
  }
  // Klik 2 kan een tegel zijn die meer knoppen samenneemt (Honda: zelfde zichtbare woorden).
  const k2Set = S => (S.k2 == null ? null : new Set([].concat(S.k2)));
  const pkTekst = pk => (pk == null ? null : nl(pk) + " pk");
  const getal = s => parseFloat(String(s).replace(",", "."));
  // Vermogens van een motor: pk en eventueel pk2 (jet van voor E-TEC: blok uit de code en pomp uit de catalogus).
  const pks = m => (m.pk2 != null && m.pk != null ? [m.pk, m.pk2] : m.pk != null ? [m.pk] : []);
  // Een trollingmotor heeft geen pk (accuspanning): wie een pk noemt, heeft er geen. Niet onbekend maar n.v.t.
  const pkNvt = m => m.pk == null && /volt/i.test(String(m.k.uitvoering || ""));
  const BRP_PK = new Set(["Evinrude", "Johnson"]);       // klik 2 = de pk-tegel
  // Het jaar van een motor als bereik: modeljaar, of bij een BRP-lettergroep (geen modeljaar) 'js of later'.
  const jaarVan = m => (m.j != null ? [m.j, m.j] : m.js != null && !m.jl ? [m.js, 9999] : null);

  // Yamaha-waterscooters (17 okt): eigen volgorde, zie wsStap(). m.cc = het getal in de modelcode (export).
  const isWs = (D, S) => D.merk === "Yamaha" && /Water/.test(S.soort || "");
  // De klassen van de boom (= ws_klasse in de export): 'tot 700' en '701 – 800' samen, want de '700'-modellen hebben 701 cc.
  const CC_KLASSEN = [["tot 800 cc", 800], ["801 – 1200 cc", 1200], ["1201 cc of meer", Infinity]];
  const ccKlasse = cc => CC_KLASSEN.find(k => cc <= k[1])[0];
  const ccTekst = cc => String(cc).replace(/\B(?=(\d{3})+(?!\d))/g, ".") + " cc";      // 1050 -> '1.050 cc'
  const ccGetal = t => { const x = /^(\d[\d.]*) cc$/.exec(String(t)); return x ? Number(x[1].replace(/\./g, "")) : null; };
  const WS_ANDER = "Ander model";      // romptegel van machines zonder bekende naam (export: WS_ONBEKEND)
  // 'Weet ik niet' bij het model of bij de cc (niet: overgeslagen omdat er maar een romp of een cc is). Dan is het precieze
  // jaar alleen voor de volgorde (naBoom): het model of de cc kon de machines niet scheiden, een gok op het jaar dan ook niet.
  const wsJaarAlleenVolgorde = (D, S) => isWs(D, S) && ((S.groep2 === null && !S.auto.groep2) || (S.cc === null && !S.auto.cc));
  // (18 okt, jaren direct: daar telde het tijdvak met de ruime marge en het precieze jaar alleen voor de volgorde; dat blijft zo,
  // zie jaarToets.)

  function nieuweStaat(merk) {
    return { merk: merk || null, soort: undefined, kop1: undefined, k1: undefined, groep2: undefined,
             k2: undefined, cc: undefined, jaar: undefined, lijst: false, filters: {}, auto: {} };   // 18 okt: geen jaar2 meer
  }

  // ------------------------------------------------------------------ jaarstap (klik 1)
  // Zeker- en misschien-set van klik-1-knoppen bij een gekozen jaarknop.
  function k1Sets(D, S) {
    if (S.k1 === undefined || S.k1 === null) return null;
    const b = D.knoppen1[S.k1];
    if (!D.klik1_jaar) {
      const misschien = new Set();
      if (b.verwant) D.knoppen1.forEach((x, i) => { if (i !== S.k1 && x.verwant === b.verwant && x.kop === b.kop) misschien.add(i); });
      return { zeker: new Set([S.k1]), misschien };
    }
    const zeker = new Set(), misschien = new Set();
    if (b.groep) {                                  // '2013 of later': alle lettergroepen samen
      D.knoppen1.forEach((x, i) => { if (x.groep === b.groep) zeker.add(i); });
      // Dezelfde marge als een jaarknop 2013 (controle2: wie '2013' denkt, tikt deze tegel; 2010-2011 viel weg).
      D.knoppen1.forEach((x, i) => {
        if (x.j == null || x.groep) return;
        const d = x.j - b.j;
        if (d >= JAAR_ZEKER[0]) zeker.add(i); else if (d >= JAAR_MISSCHIEN[0]) misschien.add(i);
      });
      return { zeker, misschien };
    }
    if (b.j == null) return { zeker: new Set([S.k1]), misschien: new Set() };
    D.knoppen1.forEach((x, i) => {
      if (x.j == null) return;
      const d = x.j - b.j;
      if (d >= JAAR_ZEKER[0] && d <= JAAR_ZEKER[1]) zeker.add(i);
      else if (d >= JAAR_MISSCHIEN[0] && d <= JAAR_MISSCHIEN[1]) misschien.add(i);
    });
    return { zeker, misschien };
  }

  // De knoppen van de jaarstap: losse jaren, en samengevoegde groepen ('2013 of later') als een knop.
  function jaarKnoppen(D, telling) {
    const uit = [], groepen = new Map();
    for (const [i, n] of telling) {
      const b = D.knoppen1[i];
      if (b.groep) {
        if (!groepen.has(b.groep)) { groepen.set(b.groep, { i, tekst: b.groep, j: b.j, n: 0 }); uit.push(groepen.get(b.groep)); }
        groepen.get(b.groep).n += n;
      } else uit.push({ i, tekst: b.tekst, j: b.j, n });
    }
    return uit.sort((a, b) => (b.j || 0) - (a.j || 0));
  }

  // ------------------------------------------------------------------ vermogensstap
  // Vermogensgroepen uit het pk van de motoren zelf ("pk"-modus). Hebben te weinig motoren een pk
  // (Yamaha-waterscooters), dan de oude koppen van klikpad ("kop"-modus: rompnaam).
  function groep2Modus(rijen) {
    const met = rijen.filter(r => r.m.pk != null).length;
    return rijen.length && met / rijen.length >= PK_GROEP_MIN ? "pk" : "kop";
  }

  // Vermogensklassen (tussenvraag als er meer dan MAX_LIJST pk-waarden zijn).
  const PK_KLASSE_TEKST = ["tot 15 pk", "16 – 30 pk", "31 – 60 pk", "61 – 90 pk", "91 – 140 pk", "141 – 200 pk", "201 – 300 pk", "meer dan 300 pk"];
  const PK_KLASSE_GRENS = [[0, 15], [16, 30], [31, 60], [61, 90], [91, 140], [141, 200], [201, 300], [301, 1e9]];
  function pkKlasseTekst(pk) {
    for (let i = 0; i < PK_KLASSE_GRENS.length; i++) if (pk <= PK_KLASSE_GRENS[i][1]) return PK_KLASSE_TEKST[i];
    return PK_KLASSE_TEKST[PK_KLASSE_TEKST.length - 1];
  }

  // Tijdvakken van tien jaar; het nieuwste heet 'X of later', alles voor 1970 'voor 1970'.
  function tijdvakVan(j, nieuwste) {
    if (j == null) return null;
    if (j < 1970) return "voor 1970";
    const a = Math.floor(j / 10) * 10;
    if (nieuwste != null && a === Math.floor(nieuwste / 10) * 10) return a + " of later";
    return a + " – " + (a + 9);
  }
  function tijdvakken(jaren) {
    const js = jaren.filter(j => j != null);
    if (!js.length) return [];
    const nieuwste = Math.max(...js);
    const labels = [...new Set(js.map(j => tijdvakVan(j, nieuwste)))];
    return labels.sort((a, b) => jaarBereik(b)[0] - jaarBereik(a)[0]);
  }

  // ------------------------------------------------------------------ na de boom
  // Rij: { m, zeker, paden, jz, jo }. jz = alleen een jaarantwoord maakt hem 'kan ook' (de rest past: lijstKaarten zet
  // hem dan als lagere versie in de zekere kaart met dezelfde naam); jo = jaar onbekend bij de bouwjaarvraag na de vragen
  // (blijft zeker, staat achter de motoren met een passend jaar - controle2: jaarloze motor dichtgeklapt onder 'Kan ook').
  function naBoom(D, S) {
    bereid(D);                       // kaartsleutels per motor (een keer per merk)
    const sets = k1Sets(D, S);
    const modus2 = S.groep2 != null ? S.modus2 || "pk" : null;
    const set2 = k2Set(S);
    // BRP: de pk-tegel van klik 2 ook op het pk van de motor zelf (9,9 onder de catalogustegel '10 pk'; jets: pk2).
    const t2 = set2 && BRP_PK.has(D.merk) ? new Set([...set2].map(i => D.knoppen2[i] && D.knoppen2[i].tekst)) : null;
    const pkTegel = t2 && [...t2].every(t => / pk$/.test(String(t)));
    // (18 okt: de stap 'dec' is weg, dus ook 'tijdvak gekozen, jaar precies Weet ik niet' - zie uitHash voor oude adressen.)
    // Jaarantwoorden (18 okt, jaren direct): zeker zoals voorheen, ook waar eerst het tijdvak kwam (dec2Toets, jaarToets).
    const dec2Zeker = S.dec2 != null ? dec2Toets(D, S) : null;
    const jaarZekerVan = S.jaar != null ? jaarToets(D, S) : null;
    const uit = [];
    for (const m of D.motoren) {
      let zeker = true, jaarZeker = true, jo = false;
      if (S.soort) {
        if (m.s.length && !m.s.includes(S.soort)) continue;
        if (!m.s.length) zeker = false;
      }
      let paden = m.p;
      if (sets) {
        if (!paden.length || paden.every(p => p[0] === null)) zeker = false;
        else {
          const z = paden.filter(p => p[0] === null || sets.zeker.has(p[0]));
          const ms = paden.filter(p => p[0] !== null && sets.misschien.has(p[0]));
          if (z.length) { paden = z; if (z.every(p => p[0] === null)) zeker = false; }
          else if (ms.length) { paden = ms; if (D.klik1_jaar) jaarZeker = false; else zeker = false; }
          else if (D.klik1_jaar) jaarZeker = false;   // ZACHT (controle2): een ander bouwjaar is 'kan ook', nooit weg
          else continue;
        }
      } else if (S.kop1 != null) {
        if (!paden.length || paden.every(p => p[0] === null)) zeker = false;
        else { paden = paden.filter(p => p[0] === null || D.knoppen1[p[0]].kop === S.kop1); if (!paden.length) continue; }
      }
      // Vermogensklasse (tussenvraag): op het pk van de motor zelf (en pk2).
      if (S.pkk != null) {
        if (pkNvt(m)) continue;
        if (!pks(m).length) zeker = false;
        else if (!pks(m).some(p => pkKlasseTekst(p) === S.pkk)) continue;
      }
      // Vermogensstap: op het pk van de motor zelf (en pk2).
      if (S.groep2 != null) {
        if (modus2 === "pk") {
          if (pkNvt(m)) continue;
          if (!pks(m).length) zeker = false;
          else if (!pks(m).some(p => pkTekst(p) === S.groep2)) continue;
        } else {
          // Kop-modus (rompnaam): een andere kop is 'misschien', nooit weg (klanttest v2).
          const raak = paden.some(p => p[1] !== null && D.knoppen2[p[1]].tussenkop === S.groep2);
          if (!raak) zeker = false;
        }
      }
      // Bouwjaar voor de modelkeuze (tussenvraag bij meer dan MAX_LIJST modellen). ZACHT (controle2). Sinds 18 okt een los jaar
      // (alle jaren op een scherm; was een tijdvak); zeker zoals het tijdvak waarin het valt (dec2Toets).
      if (S.dec2 != null) {
        const jr = jaarVan(m);
        if (!jr || !dec2Zeker(jr)) jaarZeker = false;
      }
      // Klik 2 (model / serie / uitvoering).
      // Klik 2 is de laatste en moeilijkste keuze (codes, overlappende namen): een motor onder een
      // andere tegel blijft als 'kan ook de jouwe zijn' staan (klanttest v3: tegels die net niet klopten).
      if (set2) {
        if (pkTegel && pkNvt(m)) continue;
        const raak = paden.some(p => set2.has(p[1])) || (t2 && pks(m).some(p => t2.has(pkTekst(p))));
        if (!raak) zeker = false;
      }
      // Cilinderinhoud (waterscooter, 17 okt). Onbekende cc: 'kan ook', nooit weg. Een klasse ('tot 800 cc', na 'Weet ik
      // niet' bij het model) haalt een andere klasse weg, zoals de cc-klasse van de boom deed. Een precieze cc ('700 cc', na
      // het model) is zacht: ons getal komt uit de modelcode en is niet altijd de echte cilinderinhoud.
      if (S.cc != null) {
        const g = ccGetal(S.cc);
        if (m.cc == null) zeker = false;
        else if (g == null) { if (ccKlasse(m.cc) !== S.cc) continue; }
        else if (m.cc !== g) zeker = false;
      }
      // Bouwjaarvraag na de vragen (eindlijst 16 okt): ZACHT. Buiten de marge 'kan ook', nooit weg (controle: de
      // harde versie kostte bij 3 jaar te vroeg of 4 te laat 4x zoveel Suzuki-klanten hun motor). Jaar onbekend: blijft
      // zeker, achter de motoren met een passend jaar (controle2).
      if (S.jaar != null) {
        // Waterscooter, 'Weet ik niet' bij het model of de cc (controle 17 okt): toen was 'Welk jaar precies?' na het tijdvak
        // alleen voor de volgorde en zeker/kan ook op het tijdvak met de ruime marge (3 jaar, JAAR_MISSCHIEN). Met alleen de
        // cc-klasse bekend bleven er te veel machines met een ander jaar zeker: wie 3-4 jaar ernaast zat, zag zijn eigen machine
        // onder 'Kan ook' (87/71/126 lijst fout bij -3/+3/+4, oud 3/5/40); het jaar is daar het enige wat de machines scheidt
        // (SJ650 1997 bij '2000 – 2009' > 'Weet ik niet' bij de cc stond onder 'Kan ook' achter de SuperJet 700).
        // 18 okt (jaren direct): de klant tikt meteen zijn jaar; zeker/kan ook zoals voorheen (jaarToets), ook dit.
        const jr = jaarVan(m);
        if (!jr) jo = true;
        else if (!jaarZekerVan(jr)) jaarZeker = false;
      }
      uit.push({ m, zeker: zeker && jaarZeker, paden, jz: zeker && !jaarZeker, jo });
    }
    return uit;
  }

  // Tellen in kaarten (zoals de lijst ze toont), niet in catalogusrijen.
  function telKaarten(rijen) { const sl = kaartSleutels(rijen); return new Set(rijen.map(r => sl(r.m))).size; }
  // Keuzes = wat de klant uiteindelijk moet kiezen: kaarten maal versies (onderdelenlijsten).
  function telKeuzes(rijen) { const sl = kaartSleutels(rijen); return new Set(rijen.map(r => sl(r.m) + "#" + versieSleutel(r.m))).size; }

  // Tegels komen alleen van zekere motoren: een motor met een onbekend vermogen mag geen tegel
  // '2 pk' maken binnen de klasse '61 – 90 pk' (klanttest 13 okt: tegel leidde tot 'geen motor').
  function tegelBasis(rijen) { const z = rijen.filter(r => r.zeker); return z.length ? z : rijen; }

  function telSoort(rijen) {
    rijen = tegelBasis(rijen);
    const sl = kaartSleutels(rijen), t = new Map();
    for (const r of rijen) for (const s of r.m.s) { if (!t.has(s)) t.set(s, new Set()); t.get(s).add(sl(r.m)); }
    return new Map([...t].map(([s, set]) => [s, set.size]));
  }

  function telKlik(D, S, rijen, niv) {
    rijen = tegelBasis(rijen);
    const sl = kaartSleutels(rijen), t = new Map();
    for (const r of rijen) {
      const gezien = new Set();
      for (const p of r.paden) {
        if (p[niv] === null) continue;
        if (niv === 0 && S.kop1 != null && D.knoppen1[p[0]].kop !== S.kop1) continue;
        if (niv === 1 && S.groep2 != null && (S.modus2 || "pk") === "kop" && D.knoppen2[p[1]].tussenkop !== S.groep2) continue;
        gezien.add(p[niv]);
      }
      for (const g of gezien) { if (!t.has(g)) t.set(g, new Set()); t.get(g).add(sl(r.m)); }
    }
    return new Map([...t].map(([g, set]) => [g, set.size]));
  }

  function telGroep2(D, rijen, modus) {
    rijen = tegelBasis(rijen);
    const sl = kaartSleutels(rijen), t = new Map();
    for (const r of rijen) {
      const keys = new Set();
      if (modus === "pk") { for (const p of pks(r.m)) keys.add(pkTekst(p)); }
      else for (const p of r.paden) {
        const k = p[1] !== null ? D.knoppen2[p[1]].tussenkop : "";
        if (k && k !== "vermogen onbekend") keys.add(k);
      }
      for (const k of keys) { if (!t.has(k)) t.set(k, new Set()); t.get(k).add(sl(r.m)); }
    }
    const lijst = [...t].map(([k, set]) => ({ tekst: k, n: set.size }));
    const achteraan = k => (k === "Ander model" ? 1 : 0);      // waterscooter zonder bekende naam (17 okt): als laatste tegel
    return lijst.sort((a, b) => {
      if (achteraan(a.tekst) !== achteraan(b.tekst)) return achteraan(a.tekst) - achteraan(b.tekst);
      const x = getal(a.tekst), y = getal(b.tekst);
      if (isNaN(x) !== isNaN(y)) return isNaN(x) ? 1 : -1;
      return (x - y) || a.tekst.localeCompare(b.tekst, "nl");
    });
  }

  // ------------------------------------------------------------------ Yamaha-waterscooters (17 okt)
  // Dieter: "Model -> cc -> Jaar". De romptegels (groep2 in kop-modus) zijn namen die naast elkaar op de romp staan, op
  // alfabet: tot MAX_NAMEN op een scherm (nu 17 + 'Ander model'). De handelsnamen ook (FX: 15 namen die allemaal met FX
  // beginnen; een tussenvraag zou de klant een woord laten kiezen dat niet op zijn romp staat).
  // Een romp of handelsnaam die niet klopt maakt een machine 'kan ook', nooit weg (zoals voorheen).
  const zelfdeModel = (D, S) => {
    const set2 = k2Set(S);
    if (set2) return r => r.paden.some(p => set2.has(p[1]));
    if (S.groep2 != null && S.modus2 === "kop") return r => r.paden.some(p => p[1] !== null && D.knoppen2[p[1]].tussenkop === S.groep2);
    return null;
  };
  // De cc-tegels: na het model de cc-waarden van de machines die over zijn (met hun periode), alleen als die echt verschillen;
  // zonder model (of meer dan MAX_GETALLEN waarden) de klassen van de boom. -> [{ tekst, n, van, tot }] (minder dan 2 = niet vragen)
  function ccTegels(D, S, rijen) {
    const basis = tegelBasis(rijen).filter(r => r.m.cc != null);
    if (!basis.length) return [];
    const sl = kaartSleutels(basis), per = new Map();
    const precies = S.groep2 != null && new Set(basis.map(r => r.m.cc)).size <= MAX_GETALLEN;
    for (const r of basis) {
      const k = precies ? r.m.cc : ccKlasse(r.m.cc);
      if (!per.has(k)) per.set(k, { kaarten: new Set(), jaren: [] });
      per.get(k).kaarten.add(sl(r.m));
      if (r.m.j != null) per.get(k).jaren.push(r.m.j);
    }
    const uit = [...per].map(([k, x]) => ({ tekst: precies ? ccTekst(k) : k, cc: precies ? k : null, n: x.kaarten.size,
      van: x.jaren.length ? Math.min(...x.jaren) : null, tot: x.jaren.length ? Math.max(...x.jaren) : null }));
    const volg = t => (t.cc != null ? t.cc : CC_KLASSEN.findIndex(k => k[0] === t.tekst));
    return uit.length >= 2 ? uit.sort((a, b) => volg(a) - volg(b)) : [];
  }
  // -> "k1" | "cc" | "groep2" | "k2" | null (dan 'wat zie je' en het bouwjaar, zoals bij de andere merken)
  function wsStap(D, S, rijen) {
    if (S.k1 === undefined) {
      // De cc-klasse van de boom (klik 1) komt niet meer eerst. Alleen bij meer rompnamen dan op een scherm passen (komt nu
      // niet voor): eerst die klasse, zoals voorheen. Controle 17 okt: dat was S.cc vooraf, maar cc staat in ui.js (chips,
      // terugNaar) na het model: de chips gaven verkeerde schermen en het klasse-antwoord viel stil weg. Klik 1 staat ervoor.
      if (telGroep2(D, rijen, "kop").length > MAX_NAMEN && telKlik(D, S, rijen, 0).size >= 2) return "k1";
      S.k1 = null; S.auto.k1 = true;
    }
    if (S.groep2 === undefined) {
      if (telGroep2(D, rijen, "kop").length >= 2) { S.modus2 = "kop"; return "groep2"; }
      S.groep2 = null; S.auto.groep2 = true;
    }
    if (S.k2 === undefined) {
      // 'Weet ik niet' bij het model: geen handelsnaam, meteen de cc (de klant weet het model niet). Romp 'Ander model'
      // ('naam staat er niet bij', controle 17 okt): ook niet - de tegels waren codes van het typeplaatje (J70KN, M-CRAFT).
      const n = S.groep2 != null && S.groep2 !== WS_ANDER ? telKlik(D, S, rijen, 1).size : 0;
      if (n >= 2 && n <= MAX_NAMEN) return "k2";
      S.k2 = null; S.auto.k2 = true;
    }
    if (S.cc === undefined) {
      if (ccTegels(D, S, rijen).length) return "cc";
      S.cc = null; S.auto.cc = true;
    }
    return null;
  }

  // Welke stap komt nu? -> "soort" | "kop1" | "k1" | "groep2" | "k2" | "cc" | null (lijst)
  function volgendeStap(D, S, rijen) {
    if (D.soortvraag && S.soort === undefined) {
      if (telSoort(rijen).size >= 2) return "soort";
      S.soort = null; S.auto.soort = true;
    }
    if (isWs(D, S)) return wsStap(D, S, rijen);     // Yamaha-waterscooter: model, cc, jaar (17 okt)
    if (S.k1 === undefined) {
      const t = telKlik(D, S, rijen, 0);
      if (t.size >= 2) {
        const koppen = new Set([...t.keys()].map(i => D.knoppen1[i].kop).filter(Boolean));
        if (koppen.size >= 2 && S.kop1 === undefined) return "kop1";
        // Jaarstap (klik1_jaar): alle jaarknoppen op een scherm (18 okt; was eerst 'dec', het tijdvak, bij meer dan MAX_LIJST).
        return "k1";
      }
      S.k1 = null; S.auto.k1 = true;
    }
    if (S.k2 === undefined) {
      const t = telKlik(D, S, rijen, 1);
      if (t.size >= 2) {
        if (t.size > MAX_LIJST && S.groep2 === undefined) {
          const modus = S.modus2 || groep2Modus(rijen);
          const groepen = telGroep2(D, rijen, modus);
          // Getallen op volgorde zijn makkelijk te overzien: de klassevraag pas bij meer dan
          // MAX_GETALLEN pk-waarden, en alleen als hij echt splitst (3+ klassen; anders vraagt
          // Yamaha na '31 – 90 pk' nog eens '31 – 60 of 61 – 90').
          const nKlassen = new Set(tegelBasis(rijen).filter(r => r.m.pk != null).map(r => pkKlasseTekst(r.m.pk))).size;
          if (modus === "pk" && groepen.length > MAX_GETALLEN && nKlassen >= 3 && S.pkk === undefined) { S.modus2 = modus; return "pkk"; }
          // magKop is sinds 17 okt altijd onwaar: Yamaha-waterscooters komen hier niet meer (wsStap)
          const magKop = D.merk === "Yamaha" && /Water/.test(S.soort || "") && groepen.length <= MAX_GETALLEN;
          if (groepen.length >= 2 && S.pkk !== null && (modus === "pk" || magKop)) { S.modus2 = modus; return "groep2"; }
        }
        const jaarAlGevraagd = D.klik1_jaar && S.k1 !== undefined && !S.auto.k1;
        // Het bouwjaar voor het model (dec2): sinds 18 okt alle jaren op een scherm (boomJaarTegels), was eerst het tijdvak.
        // Gevraagd onder dezelfde voorwaarde als toen: de motoren beslaan minstens twee tijdvakken van tien jaar.
        const vakken = () => tijdvakken(tegelBasis(rijen).map(r => r.m.j)).length >= 2;
        const yamahaBuiten = D.merk === "Yamaha" && !/Water/.test(S.soort || "");
        if (yamahaBuiten) {
          // Modelcodes staan op het typeplaatje, niet op de kap: niet vragen. Wel het bouwjaar als de
          // lijst anders lang wordt (klanttest v3: 21 van 43 pk-routes eindigden in > 12 kaarten).
          if (S.dec2 === undefined && telKaarten(tegelBasis(rijen)) > MAX_LIJST && vakken()) return "dec2";
          S.k2 = null; S.auto.k2 = true; return null;
        }
        if (t.size > MAX_LIJST && S.dec2 === undefined && !jaarAlGevraagd && vakken()) return "dec2";
        // Nog steeds een muur van modellen (tussenvragen overgeslagen): niet tonen, de lijst met
        // 'wat zie je'-vragen en filters doet de rest (ontwerp: nooit meer dan MAX_LIJST tegels).
        if (t.size > MAX_LIJST) { S.k2 = null; S.auto.k2 = true; return null; }
        return "k2";
      }
      S.k2 = null; S.auto.k2 = true;
    }
    return null;
  }

  // ------------------------------------------------------------------ bouwjaarvraag na de vragen (eindlijst)
  // Voor elk merk hetzelfde: weet de zoeker het bouwjaar nog niet (geen jaarstap in de boom, geen bouwjaar voor het model,
  // geen bouwjaarfilter) en zijn er meer dan INSTELLING.keuzesGenoeg keuzes over, dan 'Welk bouwjaar?'. Sinds 18 okt (jaren
  // direct) altijd alle jaren op een scherm; was: losse jaren tot MAX_GETALLEN, anders eerst het tijdvak en dan 'Welk jaar
  // precies?'. Het antwoord is zacht (naBoom); 'Weet ik niet' = geen antwoord.
  const isVak = t => t != null && !/^\d{4}$/.test(String(t));
  function jaarAlBekend(D, S) {
    if (D.klik1_jaar && S.k1 !== undefined && !S.auto.k1) return true;    // jaarstap van de boom (ook 'Weet ik niet')
    if (S.dec2 !== undefined) return true;                                 // bouwjaar voor het model al gevraagd
    return !!(S.filters.jaar && S.filters.jaar.size);
  }
  // Alle jaren van de laagste tot de hoogste, nieuwste eerst (18 okt: geen tijdvakken meer). + 1: wie toch zijn aankoopjaar
  // noemt, kan een jaar na het nieuwste modeljaar zitten (nooit na dit jaar). Ook jaren zonder motor: wie zijn eigen jaar
  // ziet, tikt dat (zacht: de motoren ernaast staan binnen de marge).
  function alleJaren(js) {
    js = js.filter(j => j != null);
    if (!js.length) return [];
    const hoog = Math.max(...js), lo = Math.min(...js), hi = Math.max(hoog, Math.min(hoog + 1, new Date().getFullYear()));
    const uit = [];
    for (let j = hi; j >= lo; j--) uit.push(String(j));
    return uit;
  }
  // De tegels van het bouwjaar voor het model (dec2; was het tijdvak van dezelfde motoren).
  function boomJaarTegels(D, S, rijen) { return alleJaren(tegelBasis(rijen).map(r => r.m.j)); }
  function zekerNu(S, rijen) {
    const kl = klassen(rijen);
    return rijen.filter(r => toets(r, S.filters, kl, null) === "zeker");
  }
  // De tegels lopen over ALLE motoren die nog meedoen, ook 'kan ook' (controle 16 okt: met alleen de zekere
  // motoren zag een klant met een VXR van 1991 zijn jaar niet en tikte het dichtstbijzijnde).
  // Waterscooter (17 okt): romp, handelsnaam en cc zijn zacht, dus 'alle' is de hele catalogus (tegels 1980 – 1989 voor een
  // FX Cruiser SVHO, 1990 – 1999 na 'SuperJet 1.050 cc'). Dan de jaren van de machines die op model en cc passen (de cc-tegel
  // toont hun periode al), anders die met het gekozen model. Het jaar is zacht: wie zijn jaar niet ziet, verliest niets.
  function jaarBasis(D, S, rijen) {             // de modeljaren waar de tegels over lopen (18 okt: los van jaarTegels)
    const kl = klassen(rijen);
    let mee = rijen.filter(r => toets(r, S.filters, kl, null));
    if (isWs(D, S)) {
      const z = mee.filter(r => toets(r, S.filters, kl, null) === "zeker"), zm = zelfdeModel(D, S);
      if (z.length) mee = z; else if (zm && mee.some(zm)) mee = mee.filter(zm);
    }
    return mee.map(r => r.m.j).filter(j => j != null);
  }
  function jaarTegels(D, S, rijen) {
    return alleJaren(jaarBasis(D, S, rijen));   // 18 okt: alle jaren (was: eerst het tijdvak bij meer dan MAX_GETALLEN)
  }

  // ------------------------------------------------------------------ jaren direct: het jaar telt zoals het tijdvak van toen
  // 18 okt: de klant tikt meteen zijn jaar J. Waar eerst het tijdvak kwam, telt J voor zeker/kan ook precies zoals het tijdvak
  // waarin het valt toen telde - en, als de zoeker na dat tijdvak nog 'Welk jaar precies?' vroeg, ook zoals dat jaar. J zelf
  // zet de versies van dat jaar bovenaan (doelJaren). Zo blijft de betekenis gelijk; alleen de periodestap is weg.
  // Gemeten (tests/jaren_direct/werk): J met de gewone marge (2 jaar) gaf veel meer 'kan ook, lijst fout' (Yamaha bij -3/+3/+4
  // 2443/2459/2768, grens 446/478/1539). Een vaste ruime marge (4 jaar) haalde de grens, maar een Suzuki DF 115 van 2006 (de
  // generatie 2001 – 2011 staat in de gegevens onder 2001) kwam dan onder 'Kan ook' met het serienummerveld dicht
  // (tests/serienummer_inbouw/scherm.py, df115_2006); met het tijdvak '2000 – 2009' is hij zeker, zoals voorheen.
  // Het tijdvak van toen: dat waarin J valt, anders het dichtstbijzijnde (zoals het harnas toen koos).
  function kiesVak(labels, J) {
    let best = null, bd = 1e9;
    for (const l of labels) {
      const [a, b] = jaarBereik(l);
      if (J >= a && J <= b) return l;
      const d = J < a ? a - J : J - Math.min(b, 3000);
      if (d < bd) { bd = d; best = l; }
    }
    return best;
  }
  // Antwoorden op de 'wat zie je'-vragen (die kwamen voor de jaarvraag); filters uit de lijst tellen hier niet.
  const zietFilters = S => Object.fromEntries(Object.entries(S.filters || {}).filter(([v]) => S.gevraagd && S.gevraagd[v]));
  // Bouwjaar voor het model (dec2): het tijdvak van de motoren op dat scherm (tegelBasis, zoals toen zonder + 1); er kwam
  // daarna geen precies jaar meer. -> jr => zeker?
  // dec2Vak: dat tijdvak (18 okt, tweede bouwer: los, want lijstKaarten heeft het ook nodig - doelRuim); een keer per staat.
  let _vak2 = { D: null, k: null, v: null };
  function dec2Vak(D, S) {
    if (isVak(S.dec2)) return S.dec2;                                            // tijdvak uit een oud adres
    const S0 = Object.assign({}, S, { dec2: undefined, k2: undefined, k2tekst: undefined, cc: undefined, jaar: undefined, filters: {},
                                      gevraagd: {}, lijst: false });
    const k = naarHash(S0) + "|" + S.dec2;
    if (_vak2.D === D && _vak2.k === k) return _vak2.v;
    const labels = tijdvakken(tegelBasis(naBoom(D, S0)).map(r => r.m.j));
    const vak = labels.length ? kiesVak(labels, Number(S.dec2)) : S.dec2;
    _vak2 = { D, k, v: vak };
    return vak;
  }
  function dec2Toets(D, S) {
    const vak = dec2Vak(D, S);
    return jr => jaarPast(jr, [vak]) === "zeker";
  }
  // Bouwjaarvraag na de vragen (jaar): een korte lijst (hooguit MAX_GETALLEN jaren) was al een los jaar. Bij een lange kwam eerst
  // het tijdvak (labels zoals de oude jaarTegels: tot het nieuwste jaar + 1, bij de waterscooter zonder eigen tijdvak voor dat
  // + 1-jaar), en alleen bij meer dan INSTELLING.keuzesGenoeg keuzes daarna nog het jaar zelf (het dichtstbijzijnde binnen het
  // tijdvak). Waterscooter na 'Weet ik niet' bij het model of de cc: het tijdvak met de ruime marge ('misschien' telt als
  // zeker), het jaar alleen voor de volgorde (controle 17 okt). -> jr => zeker?
  // Hoe telde dit antwoord toen? -> null (korte lijst: een los jaar) | { vak, J2 } (J2 = het jaar dat daarna nog gevraagd werd,
  // of null als de zoeker bij het tijdvak stopte). Een keer per staat uitgerekend (naBoom en velden vragen het allebei).
  let _toen = { D: null, k: null, v: null };
  function jaarVanToen(D, S) {
    if (isVak(S.jaar)) return { vak: S.jaar, J2: null };                        // tijdvak uit een oud adres
    const f = zietFilters(S), k = naarHash(Object.assign({}, S, { filters: f, gevraagd: {}, lijst: false }));
    if (_toen.D === D && _toen.k === k) return _toen.v;
    const J = Number(S.jaar), S0 = Object.assign({}, S, { jaar: undefined, filters: f });
    const js = jaarBasis(D, S0, naBoom(D, S0)), lijst = alleJaren(js);
    let v = null;
    if (lijst.length > MAX_GETALLEN) {
      const hi = Number(lijst[0]), lo = Number(lijst[lijst.length - 1]), labels = [];
      for (let j = isWs(D, S) ? Math.max(...js) : hi; j >= lo; j--) { const t = tijdvakVan(j, hi); if (!labels.includes(t)) labels.push(t); }
      const vak = kiesVak(labels, J), [a, b] = jaarBereik(vak);
      const Sv = Object.assign({}, S, { jaar: vak, filters: f }), rv = naBoom(D, Sv);
      const t2 = alleJaren(jaarBasis(D, Sv, rv)).map(Number).filter(j => j >= a && j <= b);
      const gevraagd = t2.length >= 2 && telKeuzes(zekerNu(Sv, rv)) > INSTELLING.keuzesGenoeg;
      v = { vak, J2: gevraagd ? String(t2.reduce((x, y) => (Math.abs(y - J) < Math.abs(x - J) ? y : x))) : null };
    }
    _toen = { D, k, v };
    return v;
  }
  function jaarToets(D, S) {
    const ws = wsJaarAlleenVolgorde(D, S);
    const past = (jr, w) => { const p = jaarPast(jr, [w]); return p === "zeker" || (ws && isVak(w) && p === "misschien"); };
    const t = jaarVanToen(D, S);
    if (!t) return jr => jaarPast(jr, [S.jaar]) === "zeker";
    if (!t.J2 || ws) return jr => past(jr, t.vak);
    return jr => past(jr, t.vak) && jaarPast(jr, [t.J2]) === "zeker";
  }
  // -> "jaar" | null (18 okt: geen 'jaar2' meer, 'Welk jaar precies?' na een tijdvak)
  function jaarStap(D, S, rijen) {
    if (S.jaar !== undefined) return null;
    if (jaarAlBekend(D, S)) return null;
    if (telKeuzes(zekerNu(S, rijen)) <= INSTELLING.keuzesGenoeg) return null;
    return jaarTegels(D, S, rijen).length >= 2 ? "jaar" : null;
  }

  // Het jaar waar de klant aan denkt, als MODELJAAR (eindlijst 16 okt: we vragen het bouwjaar, de controle zag bij
  // 'antwoord min een' het verkeerde modeljaar bovenaan). Een los jaar J: J en J-1 allebei bovenaan, J eerst (klanten
  // noemen vaak het aankoopjaar). Een tijdvak of jaarklasse: het hele vak.
  // -> null | { van, tot, jaar (het genoemde jaar of null), midden (voor de volgorde van de kaarten) }
  // Controle2 17 okt: J-1, J en J+1 zijn alle drie afstand 0 (aankoopjaar, modeljaar, productiejaar), J eerst, dan J-1.
  // '2013 of later' telt ook als doel. (18 okt: geen jaar2 en geen 'Weet ik niet' na een tijdvak meer; een tijdvak in jaar
  // of dec2 kan nog uit een oud adres komen: dan het hele vak.)
  const uitTekst = t => {                       // 18 okt: buiten doelJaren gezet (ook voor doelRuim)
    const [a, b] = jaarBereik(t);
    if (a === b) return { van: a - 1, tot: a + 1, jaar: a, midden: a - 0.5 };
    if (b > 3000) return { van: a, tot: 9999, jaar: null, midden: a };
    return { van: a, tot: b, jaar: null, midden: a === 0 ? b : (a + b) / 2 };
  };
  function doelJaren(D, S) {
    const f = S.filters && S.filters.jaar && [...S.filters.jaar][0];
    if (f) return uitTekst(f);
    if (S.jaar != null) return uitTekst(S.jaar);
    const b1 = S.k1 != null && D.klik1_jaar ? D.knoppen1[S.k1] : null;
    if (b1 && /^\d{4}$/.test(b1.tekst)) return uitTekst(b1.tekst);
    if (b1 && b1.groep) return uitTekst(b1.j + " of later");
    if (S.dec2) return uitTekst(S.dec2);
    return null;
  }
  // Het doel voor 'lagere versie in de zekere kaart' (lijstKaarten: tot JAAR_RUIM jaar ernaast). 18 okt (jaren direct, tweede
  // bouwer): waar de oude zoeker bij het TIJDVAK stopte (het bouwjaar voor het model; een lange jaarlijst zonder 'Welk jaar
  // precies?'), telde dat tijdvak hier ook. Met alleen het jaar J (J-1 .. J+1) vielen die lagere versies naar 'Kan ook': de
  // Suzuki DF 115 van 2006 kreeg 'DF 115 · 2001' zonder serienummerveld en tip (was 'DF 115 · 2001–2012' met veld;
  // tests/serienummer_inbouw/scherm.py df115_2006_*), Yamaha 40 pk 2004 verloor 14 lagere versies (1997, 2012) uit zijn kaarten
  // (tests/jaren_direct/bewust_check.js). Nu weer zoals toen; J zelf zet alleen de volgorde, 'jouw jaar' en de jaarhint.
  function doelRuim(D, S, dj) {
    if (!dj || (S.filters && S.filters.jaar && S.filters.jaar.size)) return dj;   // bouwjaarfilter: dat telt, zoals toen
    if (S.jaar != null) {
      if (isVak(S.jaar)) return dj;
      const t = jaarVanToen(D, S);
      return t && !t.J2 ? uitTekst(t.vak) : dj;
    }
    if (S.k1 != null && D.klik1_jaar) return dj;                                   // jaarknop van de boom: ongewijzigd
    if (S.dec2 != null && !isVak(S.dec2)) return uitTekst(dec2Vak(D, S));
    return dj;
  }
  // Afstand van een motor tot het doel in jaren (0 = binnen het doel; jaar onbekend = 99; geen doel = 0).
  function jaarAfstand(m, doel) {
    if (!doel) return 0;
    const jr = jaarVan(m);
    if (!jr) return 99;
    return jr[1] < doel.van ? doel.van - jr[1] : jr[0] > doel.tot ? jr[0] - doel.tot : 0;
  }

  // ------------------------------------------------------------------ versies in een kaart
  // Versies = onderdelenlijsten (zelfde og = een keuze), op waarschijnlijkheid: het modeljaar binnen of het dichtst
  // bij het doel (doelJaren), normaal draaiend voor tegengesteld, het genoemde jaar voor het jaar ervoor, de
  // uitvoering voor Europa (B-codes) bij gelijke stand voor andere markten, dan de lijst die de meeste codes delen
  // (zonder jaar: de nieuwste eerst). Een versie is een lijst rijen; de eerste rij is de waarschijnlijkste code.
  function versies(groep, doel) {
    const per = new Map();
    for (const r of groep) { const k = versieSleutel(r.m); if (!per.has(k)) per.set(k, []); per.get(k).push(r); }
    const af = r => jaarAfstand(r.m, doel);
    // het genoemde jaar eerst, dan het jaar ervoor (aankoopjaar), dan het jaar erna (productiejaar)
    const isGenoemd = r => { if (!doel || doel.jaar == null || r.m.j == null) return 3; const d = r.m.j - doel.jaar; return d === 0 ? 0 : d === -1 ? 1 : d === 1 ? 2 : 3; };
    const marktR = r => (REGIO_HIER.has(r.m.k.regio) ? 0 : r.m.k.regio == null ? 1 : 2);
    const afstand = v => Math.min(...v.map(af));
    const genoemd = v => Math.min(...v.map(isGenoemd));
    const tegen = v => (v.every(r => r.m.k.draairichting === "tegengesteld") ? 1 : 0);
    const markt = v => Math.min(...v.map(marktR));
    const nieuwste = v => Math.max(...v.map(r => r.m.j || 0));
    // Zonder jaar de nieuwste eerst (een lijst op volgorde, zoals voorheen); met een jaar bij gelijke afstand de lijst
    // die de meeste codes delen.
    const score = v => [v.some(r => r.m.jl) && v.every(r => r.m.jl) ? 1 : 0, afstand(v), tegen(v), genoemd(v), markt(v),
                        doel ? -v.length : -nieuwste(v), doel ? -nieuwste(v) : -v.length];
    const binnen = (a, b) => (af(a) - af(b)) || (isGenoemd(a) - isGenoemd(b)) || (marktR(a) - marktR(b))
      || (doel ? 0 : (b.m.j || 0) - (a.m.j || 0)) || String(a.m.n).localeCompare(String(b.m.n), "nl", { numeric: true });
    return [...per.values()].map(v => v.slice().sort(binnen)).sort((a, b) => {
      const x = score(a), y = score(b);
      for (let i = 0; i < x.length; i++) if (x[i] !== y[i]) return x[i] - y[i];
      return 0;
    });
  }

  // ------------------------------------------------------------------ filters in de lijst
  const PK_KLASSEN = [[0, 15], [16, 30], [31, 60], [61, 90], [91, 140], [141, 200], [201, 300], [301, 9999]];
  function klassen(rijen) {
    const pks = new Set(rijen.map(r => r.m.pk).filter(x => x != null));
    const jaren = new Set(rijen.map(r => r.m.j).filter(x => x != null));
    return { pkFijn: pks.size <= 12, jaarFijn: jaren.size <= 12 };
  }
  function pkKlasse(pk, fijn) {
    if (fijn) return pkTekst(pk);
    for (const [a, b] of PK_KLASSEN) if (pk <= b) return b > 9000 ? "meer dan 300 pk" : `${a}–${b} pk`;
  }
  function jaarKlasse(j, fijn) {
    if (fijn) return String(j);
    const a = Math.floor(j / 5) * 5; return `${a}–${a + 4}`;
  }
  function jaarBereik(klasse) {          // '1995–1999' / '1990 – 1999' / '2010 of later' / 'voor 1970' / '2004'
    const t = String(klasse);
    let m = t.match(/^(\d{4}) of later$/); if (m) return [Number(m[1]), 9999];
    m = t.match(/^voor (\d{4})$/); if (m) return [0, Number(m[1]) - 1];
    const d = t.split("–").map(x => Number(x.trim()));
    return [d[0], d.length > 1 ? d[1] : d[0]];
  }

  function waarde(m, veld, kl) {
    if (veld === "pk") return m.pk == null ? undefined : pkKlasse(m.pk, kl.pkFijn);
    if (veld === "jaar") return m.j == null ? undefined : jaarKlasse(m.j, kl.jaarFijn);
    const w = m.k[veld];
    return w == null ? undefined : String(w);
  }

  // Een bouwjaarchip is 'ongeveer': aankoopjaar valt vaak 1-2 jaar na het modeljaar. j = een jaar of een bereik
  // [van, tot] (jaarVan: BRP-lettergroep = [2013, 9999]).
  function jaarPast(j, gekozen) {
    const [lo, hi] = Array.isArray(j) ? j : [j, j];
    let st = false;
    for (const klasse of gekozen) {
      const [a, b] = jaarBereik(klasse);
      if (hi >= a + JAAR_ZEKER[0] && lo <= b + JAAR_ZEKER[1]) return "zeker";
      if (hi >= a + JAAR_MISSCHIEN[0] && lo <= b + JAAR_MISSCHIEN[1]) st = "misschien";
    }
    return st;
  }

  // Past rij r op alle filters (behalve 'behalve')? -> "zeker" | "misschien" | false
  function toets(r, filters, kl, behalve) {
    let st = r.zeker ? "zeker" : "misschien";
    for (const [veld, set] of Object.entries(filters)) {
      if (veld === behalve || !set.size) continue;
      if (veld === "jaar") {
        // ZACHT (controle2 17 okt): een bouwjaar is een schatting; buiten de marge 'kan ook', nooit weg.
        const jr = jaarVan(r.m);
        if (!jr || jaarPast(jr, set) !== "zeker") st = "misschien";
        continue;
      }
      const w = waarde(r.m, veld, kl);
      if (w === undefined) st = "misschien";
      else if (!set.has(w)) {
        if (veld === "pk" && r.m.pk2 != null && set.has(pkKlasse(r.m.pk2, kl.pkFijn))) continue;   // jet: pomp
        return false;
      }
    }
    return st;
  }

  // Filtergroepen voor de lijst: per veld de waarden met het aantal kaarten dat ZEKER overblijft.
  function filterGroepen(D, S, rijen, kl, velden) {
    const uit = [];
    for (const veld of velden) {
      const tel = new Map(); let onbekend = 0;
      const actief = S.filters[veld] && S.filters[veld].size;
      const mee = rijen.filter(r => toets(r, S.filters, kl, veld));
      const basis = mee.filter(r => toets(r, S.filters, kl, veld) === "zeker");
      const sl = kaartSleutels(basis);
      for (const r of mee) { const w = waarde(r.m, veld, kl); if (w !== undefined && !tel.has(w)) tel.set(w, new Set()); }
      for (const r of basis) {
        const w = waarde(r.m, veld, kl);
        if (w === undefined) { onbekend++; continue; }
        tel.get(w).add(sl(r.m));
      }
      // Bouwjaar: een chip telt ook de motoren binnen de marge.
      if (veld === "jaar") for (const w of tel.keys()) {
        const set = new Set();
        for (const r of basis) if (jaarVan(r.m) && jaarPast(jaarVan(r.m), [w]) === "zeker") set.add(sl(r.m));
        tel.set(w, set);
      }
      const ws = [...tel.keys()];
      const zinvol = ws.length >= 2 || (ws.length === 1 && onbekend > 0);
      if (!zinvol && !actief) continue;
      if (ws.length > 30 && !actief) continue;      // te versnipperd voor knoppen
      const tellen = new Map([...tel].map(([w, s]) => [w, s.size]));
      const totaal = telKaarten(basis);
      const nuttig = [...tellen.values()].some(n => n > 0 && n < totaal);
      const allesNul = [...tellen.values()].every(n => n === 0);
      if (allesNul && !actief) continue;
      uit.push({ veld, ws, tel: tellen, eenWaarde: ws.length < 2, nuttig: !!nuttig, actief: !!actief });
    }
    return uit;
  }

  function velden(D, S, alle) {
    let uit = alle.filter(v => !(D.verborgen_filters || []).includes(v));
    // Jaar is alleen overbodig als de klant bij klik 1 echt een jaar koos.
    const b = S.k1 != null ? D.knoppen1[S.k1] : null;
    if (D.klik1_jaar && b && !b.groep && /^\d{4}$/.test(b.tekst)) uit = uit.filter(v => v !== "jaar");
    // jaar al gegeven. 18 okt (jaren direct): alleen waar het jaar ook toen als los jaar telde; telde het tijdvak (het bouwjaar
    // voor het model; een lange lijst zonder 'Welk jaar precies?'), dan blijft het bouwjaarfilter in de lijst, zoals toen
    // (zonder dat filter werden de lijsten langer: Yamaha kaarten over mediaan 9 -> 11, p90 45 -> 55).
    if (S.jaar != null && !isVak(S.jaar)) { const t = jaarVanToen(D, S); if (!t || t.J2) uit = uit.filter(v => v !== "jaar"); }
    return uit;
  }

  // Groepeer rijen tot kaarten: zelfde kaartsleutel, en kaarten met dezelfde onderdelenlijsten samen.
  function groepeer(rijen) {
    const sl = kaartSleutels(rijen), g = new Map();
    for (const r of rijen) { const k = sl(r.m); if (!g.has(k)) g.set(k, []); g.get(k).push(r); }
    return [...g.values()];
  }

  // Kenmerken die alle uitvoeringen van een kaart delen.
  function gedeeld(groep) {
    const uit = Object.assign({}, groep[0].m.k);
    for (const r of groep.slice(1)) for (const v of Object.keys(uit)) if (r.m.k[v] !== uit[v]) delete uit[v];
    return uit;
  }

  // ------------------------------------------------------------------ 'wat zie je aan je motor?'
  // Na de boom, zolang er meer dan 'genoeg' kaarten zijn: een vraag tegelijk, over het kenmerk dat
  // de kaarten het gelijkst verdeelt. Alleen als minstens 2 waarden elk 20% of meer dekken; hooguit
  // 'max' vragen achter elkaar (ontwerp knoppenboom-opmaak).
  // Controle2 17 okt: weinig kaarten maar veel versies (E-TEC G2 200 pk vanaf 2013: 8 kaarten, 189 versies, 65 in een
  // kaart) -> dan tellen de KEUZES (kaart x versie), en alleen velden die we bij hooguit 20% niet weten (anders wordt een
  // groot deel 'kan ook'). 'streng' = velden die altijd die eis hebben (draairichting, besturing, kleur bij BRP).
  function volgendeZietVraag(D, S, rijen, velden, genoeg, max, streng) {
    const kl = klassen(rijen);
    const zeker = rijen.filter(r => toets(r, S.filters, kl, null) === "zeker");
    const kaarten = telKaarten(zeker);
    const opKeuzes = kaarten <= genoeg;
    const totaal = opKeuzes ? telKeuzes(zeker) : kaarten;
    if (totaal <= genoeg) return null;
    const gevraagd = S.gevraagd || {};
    if (Object.keys(gevraagd).length >= max) return null;
    const open = velden.filter(v => !gevraagd[v] && !(S.filters[v] && S.filters[v].size));
    const sl = kaartSleutels(zeker);
    let beste = null;
    for (const g of filterGroepen(D, S, rijen, kl, open)) {
      let tel = g.tel;
      if (opKeuzes || (streng && streng.has(g.veld))) {
        // per waarde de keuzes (of kaarten) waarin hij voorkomt; onbekend apart
        const per = new Map(), onb = new Set(), alle = new Set();
        for (const r of zeker) {
          const k = sl(r.m) + (opKeuzes ? "#" + versieSleutel(r.m) : ""), w = waarde(r.m, g.veld, kl);
          alle.add(k);
          if (w === undefined) { onb.add(k); continue; }
          if (!per.has(w)) per.set(w, new Set());
          per.get(w).add(k);
        }
        if (onb.size > 0.2 * alle.size) continue;
        tel = new Map([...per].map(([w, s]) => [w, s.size]));
        if (opKeuzes) g.tel = tel;
      }
      if (!tel.size) continue;
      const groot = [...tel.values()].filter(n => n >= 0.2 * totaal);
      if (groot.length < 2) continue;
      const score = totaal - Math.max(...tel.values());     // wat er minstens afvalt
      // alleen tegels met minstens een zekere keuze (een tegel met 0 gaf 'Geen motor past')
      if (!beste || score > beste.score) beste = Object.assign({ score }, g, { ws: g.ws.filter(w => (tel.get(w) || 0) > 0) });
    }
    return beste;
  }

  // ------------------------------------------------------------------ de lijst (controle2 17 okt)
  // Zoals ui.js hem toont, zodat de tests precies dat meten. -> { gZ, gO, dj, ookDichtbij } (kaarten = lijsten rijen).
  //   gZ  zekere kaarten. Een 'kan ook'-motor die alleen door een jaarantwoord niet zeker is (r.jz, of buiten het
  //       bouwjaarfilter) en hooguit JAAR_RUIM jaar naast het doel zit, staat als lagere versie in de zekere kaart met
  //       dezelfde naam (zelfde kaartsleutel of zelfde onderdelenlijst) - controle2: bij 2 jaar ernaast stond de eigen
  //       motor dichtgeklapt onder 'Kan ook', met erboven dezelfde kaartnaam met alleen andere onderdelenlijsten.
  //       Volgorde: pk, dan het dichtstbijzijnde jaar BINNEN de kaart (was: het nieuwste jaar), Europa, minst onbekend.
  //   gO  'Kan ook de jouwe zijn': eerst kaarten met een naam of tegel die de klant koos (controle2: de eigen kaart stond
  //       op plek 37 achter 'Toon 20 meer'), dan het dichtstbijzijnde jaar in de kaart, dan pk.
  const JAAR_RUIM = 3;
  function lijstKaarten(D, S, rijen, kl) {
    kl = kl || klassen(rijen);
    const dj = doelJaren(D, S), doel = dj ? dj.midden : null;
    const djR = doelRuim(D, S, dj);          // 18 okt (jaren direct): lagere versies zoals toen, zie doelRuim
    const zeker = [], ook = [];
    for (const r of rijen) { const st = toets(r, S.filters, kl, null); if (st === "zeker") zeker.push(r); else if (st) ook.push(r); }
    const slZ = kaartSleutels(zeker), per = new Map();
    for (const r of zeker) { const k = slZ(r.m); if (!per.has(k)) per.set(k, []); per.get(k).push(r); }
    const viaSleutel = new Map(), viaOg = new Map();
    for (const [k, g] of per) for (const r of g) {
      viaSleutel.set(kaartSleutel(r.m), k);
      if (r.m.og != null) viaOg.set(naamSleutel(r.m) + "#" + r.m.og, k);
    }
    const rest = [];
    for (const r of ook) {
      let k;
      if (dj && (r.zeker || r.jz) && jaarAfstand(r.m, djR) <= JAAR_RUIM
          && toets(Object.assign({}, r, { zeker: true }), S.filters, kl, "jaar") === "zeker")
        k = viaSleutel.get(kaartSleutel(r.m)) || (r.m.og != null ? viaOg.get(naamSleutel(r.m) + "#" + r.m.og) : undefined);
      if (k) per.get(k).push(r); else rest.push(r);
    }
    // 'Kan ook': dezelfde naam als een zekere kaart, of de gekozen tegel (klik 2 of het pk) -> eerst.
    const namen = new Set(zeker.map(r => naamSleutel(r.m)));
    const set2 = k2Set(S);
    const t2 = set2 ? new Set([...set2].map(i => D.knoppen2[i] && D.knoppen2[i].tekst)) : null;
    const zelfde = r => namen.has(naamSleutel(r.m)) || (set2 && r.m.p.some(p => p[1] !== null && (set2.has(p[1]) || t2.has(D.knoppen2[p[1]].tekst))))
      || (S.groep2 != null && pks(r.m).some(p => pkTekst(p) === S.groep2));
    // Waterscooter (17 okt): daarna de gekozen romp, in een eigen laag (controle 17 okt: romp en handelsnaam stonden even
    // hoog, en de eigen VX Cruiser zakte op het nieuwste jaar achter VX, VX Deluxe, VX Limited ... naar plek 7).
    const romp = S.groep2 != null && S.modus2 === "kop";
    const zelfdeRomp = r => romp && r.m.p.some(p => p[1] !== null && D.knoppen2[p[1]].tussenkop === S.groep2);
    // sorteersleutels een keer per kaart (de 'Kan ook'-lijst kan duizenden kaarten hebben)
    // gn: heeft de kaart het genoemde jaar (0), het jaar ervoor (1) of erna (2) - zoals de versies
    const gnR = r => { if (!dj || dj.jaar == null || r.m.j == null) return 3; const d = r.m.j - dj.jaar; return d === 0 ? 0 : d === -1 ? 1 : d === 1 ? 2 : 3; };
    const sleutels = g => {
      const jm = Math.max(...g.map(r => r.m.js || 0));
      return { g, pk: g[0].m.pk ?? 1e9, jaf: Math.min(...g.map(r => jaarAfstand(r.m, dj))), jm, gn: Math.min(...g.map(gnR)),
               jd: doel != null ? Math.abs(jm - doel) : 0,
               markt: g.some(r => REGIO_HIER.has(r.m.k.regio)) ? 0 : g.every(r => r.m.k.regio != null) ? 2 : 1,
               onb: KAART_ZICHT.filter(v => g.every(r => r.m.k[v] == null && !nvt(r.m, v))).length, naam: kaartNaam(g[0].m) };
    };
    const jaarV = (x, y) => (doel != null ? (x.jaf - y.jaf) || (x.gn - y.gn) || (x.jd - y.jd) : y.jm - x.jm);
    const rest_ = (x, y) => x.markt - y.markt || x.onb - y.onb || x.naam.localeCompare(y.naam, "nl", { numeric: true });
    const gZ = [...per.values()].map(sleutels).sort((x, y) => (x.pk - y.pk) || jaarV(x, y) || rest_(x, y)).map(x => x.g);
    const gOs = groepeer(rest).map(g => Object.assign(sleutels(g), { eerst: g.some(zelfde) ? 0 : g.some(zelfdeRomp) ? 1 : 2 }))
      .sort((x, y) => (x.eerst - y.eerst) || (doel != null ? x.jaf - y.jaf : 0) || (x.pk - y.pk) || jaarV(x, y) || rest_(x, y));
    const gO = gOs.map(x => x.g);
    // ookDichtbij (waterscooter met een gekozen romp, controle 17 okt): zoveel 'Kan ook'-kaarten hebben de gekozen naam of romp;
    // de rest zijn alle andere Yamaha-waterscooters (romp en naam zijn zacht: 'Kan ook de jouwe zijn (91)' op elke lijst). Die
    // telt ui.js niet mee en zet hij achter 'Toon andere waterscooters'. Ze blijven in gO: nooit weg. null = alles tonen.
    const ookDichtbij = romp && isWs(D, S) ? gOs.filter(x => x.eerst < 2).length : null;
    return { gZ, gO, dj, ookDichtbij };
  }

  // ------------------------------------------------------------------ staat <-> adres
  // cc: 17 okt; dec en jaar2 weg (18 okt, jaren direct: oude adressen zie uitHash)
  const STAP_SLEUTELS = ["soort", "kop1", "k1", "pkk", "groep2", "modus2", "dec2", "k2", "k2tekst", "cc", "jaar"];
  // Voor de terugknop van de browser: de staat als korte tekst in de hash.
  function naarHash(S) {
    if (!S.merk) return "";
    const d = { m: S.merk };
    for (const k of STAP_SLEUTELS) if (S[k] !== undefined) d[k] = S[k];
    if (S.gevraagd && Object.keys(S.gevraagd).length) d.g = S.gevraagd;
    if (S.lijst) d.l = 1;
    const f = {}; for (const [v, set] of Object.entries(S.filters)) if (set.size) f[v] = [...set];
    if (Object.keys(f).length) d.f = f;
    if (Object.keys(S.auto).length) d.a = S.auto;
    return "#vjm=" + encodeURIComponent(JSON.stringify(d));     // eigen voorvoegsel: de zoeker deelt de pagina met de scanner
  }
  function uitHash(hash) {
    try {
      const h = String(hash || "");
      if (!h.startsWith("#vjm=")) return null;
      const d = JSON.parse(decodeURIComponent(h.slice(5)));
      const S = nieuweStaat(d.m);
      for (const k of STAP_SLEUTELS) if (k in d) S[k] = d[k];
      // Oude adressen (van voor 18 okt, jaren direct) - niet laten vastlopen:
      //   dec   (tijdvak voor de jaarknop) bestaat niet meer en blijft weg: stond de klant op 'Welk jaar precies?', dan ziet hij
      //         nu alle jaren; 'Weet ik niet' daar telt als 'Weet ik niet' bij het jaar.
      //   jaar2 (het jaar binnen het tijdvak in jaar) wordt jaar. Een tijdvak in jaar of dec2 zonder jaar blijft een zacht
      //         antwoord (naBoom, doelJaren en jaarPast kennen tijdvakken nog).
      if (d.jaar2 != null && !isVak(d.jaar2)) S.jaar = d.jaar2;
      S.lijst = !!d.l; S.auto = d.a || {}; S.gevraagd = d.g || {};
      for (const [v, ws] of Object.entries(d.f || {})) S.filters[v] = new Set(ws);
      return S;
    } catch (e) { return null; }
  }

  const KB = { tegelBasis, kaartNaam, k2Set, MAX_LIJST, JAAR_ZEKER, JAAR_MISSCHIEN, PK_KLASSE_TEKST, pkKlasseTekst, tijdvakVan, tijdvakken, jaarBereik,
               volgendeZietVraag, STAP_SLEUTELS, nl, normNaam, kaartSleutel, pkTekst, nieuweStaat,
               k1Sets, jaarKnoppen, naBoom, telKaarten, telSoort, telKlik, telGroep2, volgendeStap,
               klassen, waarde, jaarPast, toets, filterGroepen, velden, groepeer, gedeeld, naarHash, uitHash,
               // eindlijst 16 okt
               KAART_ZICHT, REGIO_HIER, INSTELLING, nvt, bereid, versieSleutel, kaartSleutels, telKeuzes, versies,
               jaarStap, jaarTegels, isVak, doelJaren,
               // controle2 17 okt
               pks, pkNvt, jaarVan, jaarAfstand, lijstKaarten, naamSleutel, JAAR_RUIM,
               // waterscootervolgorde 17 okt
               isWs, CC_KLASSEN, ccKlasse, ccTekst, ccGetal, ccTegels, wsStap, MAX_GETALLEN,
               // herstel na de controle 17 okt
               MAX_NAMEN, WS_ANDER, wsJaarAlleenVolgorde,
               // jaren direct 18 okt
               alleJaren, boomJaarTegels, jaarBasis, kiesVak, dec2Toets, jaarToets, jaarVanToen,
               // herstel jaren direct 18 okt (lagere versies zoals toen)
               dec2Vak, doelRuim };
  if (typeof module !== "undefined" && module.exports) module.exports = KB;
  else wereld.KB = KB;
})(typeof window !== "undefined" ? window : globalThis);

/* ---- modelcodes.js ---- */
// modelcodes.js - uitleg van de modelafkortingen per merk (gemaakt door maak_modelcodes.py, niet hier aanpassen).
// Gecontroleerd in officiele bronnen en tegen onze data (workflow 16 okt 2026; tests\modelcodes\).
window.MODELCODES = {
 "Mercury": {
  "voorbeeld": {
   "naam": "350 MAG. ALPHA (4 BBL.) GM 350 V-8",
   "delen": [
    [
     "350",
     "cilinderinhoud in kubieke inch, niet het pk"
    ],
    [
     "MAG.",
     "Magnum (naam van de uitvoering)"
    ],
    [
     "ALPHA",
     "Alpha-hekaandrijving (staartstuk)"
    ],
    [
     "(4 BBL.)",
     "carburateur met 4 kelen"
    ],
    [
     "GM 350",
     "GM-motorblok, 350 kubieke inch"
    ],
    [
     "V-8",
     "8 cilinders in V-vorm"
    ]
   ]
  },
  "codes": [
   [
    "HP",
    "pk (vermogen)",
    "na het pk-getal: 115 HP"
   ],
   [
    "CYL",
    "aantal cilinders",
    "na het aantal cilinders: 2 CYL"
   ],
   [
    "Carb",
    "carburateur",
    "na HP of na de liters"
   ],
   [
    "EFI",
    "elektronische brandstofinjectie",
    "na HP of het pk-getal, of na de liters of MAG"
   ],
   [
    "MPI",
    "injectie per cilinder",
    "na de liters of na MAG (hek- en binnenboordmotoren)"
   ],
   [
    "BBL",
    "carburateur met 2/4 kelen",
    "tussen haakjes: (2 BBL.), (4 BBL.)"
   ],
   [
    "L",
    "cilinderinhoud in liters",
    "na een getal met punt: 4.3L"
   ],
   [
    "V-8 · L4",
    "cilinders in V of lijn",
    "achteraan; V-150 vooraan is het pk-getal"
   ],
   [
    "GM",
    "GM-blok, inhoud in kubieke inch",
    "achteraan: GM 350 = 350 kubieke inch"
   ],
   [
    "ALPHA / BRAVO",
    "type hekaandrijving (staartstuk)",
    "na het motortype"
   ],
   [
    "MIE",
    "binnenboordmotor, geen hekaandrijving",
    "na de liters of het getal"
   ],
   [
    "EI / ES",
    "binnenboord of hekaandrijving",
    "bij diesels: I = binnenboord, S = hekaandrijving"
   ],
   [
    "M / H / XL",
    "trekkoord · helmstok · extra lang",
    "direct na het pk-getal: 40 MXL"
   ]
  ]
 },
 "Yamaha": {
  "voorbeeld": {
   "naam": "FT9.9LEPL",
   "delen": [
    [
     "FT",
     "High Thrust: extra trekkracht"
    ],
    [
     "9.9",
     "9,9 pk"
    ],
    [
     "L",
     "generatie (modelversie L)"
    ],
    [
     "E",
     "elektrische start"
    ],
    [
     "P",
     "elektrisch kantelen (power tilt)"
    ],
    [
     "L",
     "lange staart (20 inch)"
    ],
    [
     "(geen H)",
     "afstandsbediening, geen helmstok"
    ]
   ]
  },
  "codes": [
   [
    "F",
    "viertakt",
    "vooraan, voor het pk-getal"
   ],
   [
    "FT / T",
    "High Thrust (extra trekkracht)",
    "vooraan, voor het pk-getal"
   ],
   [
    "L / LF / FL",
    "tegengesteld draaiend (linksom)",
    "vooraan, voor het pk-getal"
   ],
   [
    "A, B, C …",
    "generatie (modelversie)",
    "na het pk-getal of als laatste letter"
   ],
   [
    "E",
    "elektrische start",
    "na het pk-getal; E vooraan = Enduro"
   ],
   [
    "M",
    "trekkoord (handstart)",
    "voor de H (F15CMHS)"
   ],
   [
    "H",
    "helmstok (stuurknuppel)",
    "na de startletter"
   ],
   [
    "R",
    "afstandsbediening",
    "na de staartletter, alleen in Amerikaanse namen"
   ],
   [
    "T",
    "elektrische trim en kantelen",
    "na de startletter; T vooraan = High Thrust"
   ],
   [
    "P",
    "elektrisch kantelen (power tilt)",
    "na de startletter; P vooraan = Pro"
   ],
   [
    "S / L / X / U",
    "staart kort/lang/extra lang/XX-lang",
    "15, 20, 25 of 30 inch; meestal de laatste letter"
   ],
   [
    "P … D (laatste)",
    "bouwjaar (Amerikaanse namen)",
    "laatste letter na R of H: P = 1991 … Z = 2001, A = 2002 … D = 2005"
   ]
  ]
 },
 "Honda": {
  "voorbeeld": {
   "naam": "BF20D3-SHSU",
   "delen": [
    [
     "BF",
     "Honda buitenboordmotor"
    ],
    [
     "20",
     "20 pk"
    ],
    [
     "D3",
     "D-reeks, 2003 (niet op de kaart)"
    ],
    [
     "S",
     "korte staart (15 inch)"
    ],
    [
     "H",
     "helmstok"
    ],
    [
     "S",
     "elektrische start"
    ],
    [
     "U",
     "verkoopmarkt (land of regio)"
    ]
   ]
  },
  "codes": [
   [
    "BFP",
    "Power Thrust (extra duwkracht)",
    "voor het pk-getal (BFP in plaats van BF)"
   ],
   [
    "S",
    "korte staart (15 inch)",
    "eerste letter na de spatie"
   ],
   [
    "L",
    "lange staart (20 inch)",
    "eerste letter na de spatie"
   ],
   [
    "X",
    "extra lange staart (25 inch)",
    "eerste letter na de spatie"
   ],
   [
    "XX of U",
    "XX-lange staart (30 inch)",
    "begin van de code, vanaf 200 pk"
   ],
   [
    "H",
    "helmstok (stuurarm)",
    "na de staartletter (bv. LHTU), bij BF2 na C (SCHU)"
   ],
   [
    "R",
    "afstandsbediening",
    "na de staartletter, of na C (bv. LRTU, XCRU)"
   ],
   [
    "S",
    "elektrische start",
    "na H, R of A (SHSU, XRSU)"
   ],
   [
    "T",
    "elektrische trim",
    "na H of R (bv. LRTU, LHTU)"
   ],
   [
    "G",
    "kantelhulp met gasveer",
    "na H of R (bv. LHGU, LRGU)"
   ],
   [
    "C",
    "tegengestelde draairichting",
    "na de staartletter, alleen vanaf 115 pk (bv. LCU, XCU, XXCU)"
   ],
   [
    "U",
    "verkoopmarkt (land of regio)",
    "laatste letter van de code"
   ]
  ]
 },
 "Suzuki": {
  "voorbeeld": {
   "naam": "DF 140",
   "delen": [
    [
     "DF",
     "viertakt"
    ],
    [
     "140",
     "140 pk"
    ],
    [
     "B",
     "versie (alleen op het typeplaatje)"
    ],
    [
     "T",
     "elektrische trim en start"
    ],
    [
     "L",
     "lange staart (20 inch)"
    ]
   ]
  },
  "codes": [
   [
    "DF",
    "viertakt",
    "voor het pk-getal"
   ],
   [
    "DT",
    "tweetakt",
    "voor het pk-getal"
   ],
   [
    "A / B",
    "versie van het model",
    "na het pk-getal, op het typeplaatje"
   ],
   [
    "AP",
    "omschakelbare draairichting",
    "na het pk-getal (DF200AP)"
   ],
   [
    "T",
    "elektrische trim en start",
    "na de versieletter op het typeplaatje (DF20ATL)"
   ],
   [
    "H",
    "helmstok (stuurarm)",
    "na T of Q, voor de staartletter (typeplaatje)"
   ],
   [
    "E",
    "elektrische start, helmstok",
    "na de versieletter (typeplaatje)"
   ],
   [
    "R",
    "stuurwiel, elektrische start",
    "na de versieletter (typeplaatje)"
   ],
   [
    "S",
    "korte staart (15 inch)",
    "achteraan (typeplaatje)"
   ],
   [
    "L",
    "lange staart (20 inch)",
    "achteraan (typeplaatje)"
   ],
   [
    "X / XX",
    "extra lange staart (25/30 inch)",
    "achteraan (typeplaatje)"
   ],
   [
    "Z",
    "tegengesteld draaiende schroef",
    "op het typeplaatje (DF140AZL)"
   ]
  ]
 },
 "Johnson": {
  "voorbeeld": {
   "naam": "BJ40TLEDS",
   "delen": [
    [
     "B",
     "Europese uitvoering"
    ],
    [
     "J",
     "merk Johnson"
    ],
    [
     "40",
     "40 pk"
    ],
    [
     "T",
     "elektrische trim en start (t/m 1998)"
    ],
    [
     "L",
     "lange staart, 20 inch (51 cm)"
    ],
    [
     "ED",
     "modeljaar 1996 (E = jaren 90, D = 6)"
    ],
    [
     "S",
     "productieserie"
    ]
   ]
  },
  "codes": [
   [
    "B",
    "Europese uitvoering",
    "helemaal vooraan, vóór de J (BJ...)"
   ],
   [
    "getal",
    "vermogen in pk (afgerond)",
    "direct na de J; 10 = 9,9 pk"
   ],
   [
    "R",
    "starten met trekkoord",
    "na het pk-getal; vanaf 1999 ook helmstok"
   ],
   [
    "E",
    "elektrische start",
    "na het pk-getal; vanaf 1999 ook stuurwiel"
   ],
   [
    "TE",
    "helmstok met elektrische start",
    "direct na het pk-getal"
   ],
   [
    "T / P",
    "elektrische trim (trim & tilt)",
    "na het pk-getal; T t/m 1998, P vanaf 1999"
   ],
   [
    "L / X / Z",
    "staartlengte 20/25/30 inch",
    "20, 25 of 30 inch; geen letter = kort (onder 100 pk)"
   ],
   [
    "C / N",
    "tegengesteld draaiend",
    "na het pk-getal, vanaf 100 pk"
   ],
   [
    "4",
    "viertakt",
    "vlak vóór de jaarcode"
   ],
   [
    "ET, SU …",
    "bouwjaar (1980–2012)",
    "1e letter: C = jaren 80, E = 90, S = 2000, I = 2010; 2e letter: I=1 N=2 T=3 R=4 O=5 D=6 U=7 C=8 E=9 S=0"
   ],
   [
    "69 … 79",
    "bouwjaar 1969 t/m 1979",
    "twee cijfers voor de laatste letter"
   ],
   [
    "laatste letter",
    "productieserie",
    "helemaal achteraan, na de jaarcode"
   ]
  ]
 },
 "Evinrude": {
  "voorbeeld": {
   "naam": "E25DTELINA",
   "delen": [
    [
     "E",
     "merk Evinrude"
    ],
    [
     "25",
     "25 pk"
    ],
    [
     "D",
     "Evinrude E-TEC"
    ],
    [
     "TE",
     "helmstok met elektrische start"
    ],
    [
     "L",
     "lange staart, 20 inch (51 cm)"
    ],
    [
     "IN",
     "modeljaar 2012 (I = vanaf 2010, N = 2)"
    ],
    [
     "A",
     "productieserie"
    ]
   ]
  },
  "codes": [
   [
    "B",
    "Europese uitvoering",
    "helemaal vooraan, vóór de E (BE...)"
   ],
   [
    "getal",
    "vermogen in pk (afgerond)",
    "direct na de E; 10 = 9,9 of 9,8 pk"
   ],
   [
    "R",
    "starten met trekkoord",
    "na het pk-getal; vanaf 1999 ook helmstok"
   ],
   [
    "E / TE",
    "elektrische start (TE: helmstok)",
    "na het pk-getal; E = stuurwiel, TE = helmstok"
   ],
   [
    "T / P",
    "elektrische trim (trim & tilt)",
    "na het pk-getal; T t/m 1998, P 1999–2012"
   ],
   [
    "L / X / Z",
    "staartlengte 20/25/30 inch",
    "20, 25 of 30 inch; geen letter = kort (onder 100 pk)"
   ],
   [
    "C / N",
    "tegengesteld draaiend",
    "na het pk-getal, vanaf 100 pk"
   ],
   [
    "4",
    "viertakt",
    "vlak vóór de jaar- of versiecode"
   ],
   [
    "D",
    "Evinrude E-TEC",
    "direct na het pk-getal, vanaf 2004"
   ],
   [
    "H",
    "High Output (H.O.)",
    "na het pk-getal of de D, vanaf 2005"
   ],
   [
    "ET, IN …",
    "bouwjaar (1980–2012)",
    "1e letter: C = jaren 80, E = 90, S = 2000, I = 2010; 2e letter: I=1 N=2 T=3 R=4 O=5 D=6 U=7 C=8 E=9 S=0"
   ],
   [
    "AA … AK",
    "versiecode, geen bouwjaar",
    "laatste letters, motoren vanaf 2012"
   ]
  ]
 },
 "Sea-Doo": {
  "voorbeeld": {
   "naam": "Spark 900 HO ACE",
   "delen": [
    [
     "Spark",
     "kleinste en lichtste Sea-Doo"
    ],
    [
     "900",
     "cilinderinhoud (cc), niet het vermogen"
    ],
    [
     "HO",
     "High Output: 90 pk (zonder HO 60 pk)"
    ],
    [
     "ACE",
     "Rotax-viertaktmotor"
    ]
   ]
  },
  "codes": [
   [
    "60 … 325",
    "vermogen in pk",
    "achter de serienaam: GTX Limited 300"
   ],
   [
    "150 … 230",
    "bootlengte (150 ≈ 15 voet)",
    "voor de bootnaam: 150 Speedster"
   ],
   [
    "310 … 520",
    "pk van twee motoren samen",
    "achteraan bij boten met twee motoren"
   ],
   [
    "16 · 18 · 21",
    "bootlengte in voet",
    "bij de Switch"
   ],
   [
    "SE",
    "uitgebreidere uitvoering, meer comfort",
    "na de serienaam (GTI SE 170)"
   ],
   [
    "LTD / Limited",
    "luxe topuitvoering",
    "na de serienaam"
   ],
   [
    "X",
    "sportieve race-uitvoering (X-pakket)",
    "na RXP, RXT of GTR, vaak met streepje (RXP-X)"
   ],
   [
    "HO",
    "High Output",
    "na 900, 1503 of het pk-getal"
   ],
   [
    "4-TEC / ACE",
    "Rotax-viertaktmotor",
    "na de serienaam of de cilinderinhoud"
   ],
   [
    "SC · SCIC",
    "motor met compressor",
    "achter het pk-getal, achter 4-TEC of achter 1503"
   ],
   [
    "iS · aS · S",
    "vering tussen romp en bovendek",
    "na GTX of RXT (2009-2015), voor het pk-getal"
   ],
   [
    "1UP · 2UP · 3UP",
    "aantal zitplaatsen",
    "bij de Spark, achteraan of tussen haakjes"
   ]
  ]
 }
};

/* ---- ui.js ---- */
// ui.js - schermen van 'Vind je motor' (knoppenboom zonder typeplaatje), voor het prototype en het thema.
// Gemaakt met maak_ui_js.py uit index.html (16 okt 2026); logica in logica.js, pictogrammen in iconen.js.
// Eindlijst 16 okt 2026 (tests/doorklik/workflow_resultaat.json): kaart = wat de klant herkent, versie = wat echt
// anders is; zachte bouwjaarvraag na de vragen; codes van een versie als losse links. Zie 'lijst' hieronder.
// Controle2 17 okt 2026 (tests/doorklik/controle2, herstel in tests/doorklik/na_herstel): de lijst uit KB.lijstKaarten;
// 'Weet ik niet' na een tijdvak is zacht; de jaarhint een keer boven de lijst; 'jouw jaar' bij de versie; de naam als
// titel als hij geen code is; knoppen met 0 weg; geen dubbele code; Sea-Doo-modelnummers; 'Verder met je motor' met
// modeljaar en code; Evinrude/Johnson ook 'Hoe draait de schroef?', besturing en kleur als 'wat zie je'-vraag.
// Waterscootervolgorde 17 okt 2026 (Dieter: "Model -> cc -> Jaar"; tests/ws_volgorde): Yamaha-waterscooter eerst 'Welk
// model?' (romp) en 'Welk model precies?' (handelsnaam), dan 'Hoe groot is de motor?' (S.cc, KB.ccTegels), dan het jaar.
// Herstel na de controle (17 okt 2026, tests/ws_volgorde/na_herstel): de periode onder elke handelsnaamtegel (FX SHO 2008 – 2015
// tegenover FX SVHO 2014 – 2027), '(2-zits)' als regel eronder en haakjes niet afgebroken; 'Toon deze waterscooter' bij een
// kaart (was 'Toon alle 1 waterscooter'); 'Kan ook' telt alleen de gekozen naam en romp, de andere waterscooters achter een
// knop; een lijst zonder kenmerken en code-uitleg zonder lege linkerkolom.
// Serienummer 17 okt 2026 (Suzuki; tests/serienummer_inbouw): per versie het nummer zoals op de motor (11503F-71 _ _ _ _) met
// de jaarcode gemarkeerd, in de kaart het veld 'Heb je het serienummer?' (ook alleen de 6 cijfers van het ronde plaatje) en
// een tip met een eigen tekening waar het nummer zit. Was: blokjes 'Serienummer begint met' (snBegins/snBlokjes). Zie
// 'serienummer' en 'tip' hieronder.
// Serienummer Mercury en Honda 18 okt 2026 (tests/serienummer_mh): dezelfde aanpak als Suzuki (veld, korte reeks per versie,
// tip met een eigen tekening, WhatsApp-uitweg) met de koppelregels uit het onderzoek; zie 'serienummer Mercury en Honda'.
// Jaren direct 18 okt 2026 (Dieter: "die tussenstap weg en gewoon alle jaren onder elkaar/naast elkaar. dat scheelt een klik";
// tests/jaren_direct): elke jaarvraag toont alle jaren tegelijk, per decennium (jarenHtml); geen tijdvakstap ('dec') en geen
// 'Welk jaar precies?' ('jaar2') meer. Het bouwjaar voor het model (dec2) is een los jaar en staat altijd als chip.
(function () {
"use strict";
const CFG = window.VIND_JE_MOTOR || {};
const INGEBED = !!CFG.ingebed;
const DATA = CFG.data || "data/";
// Merken alfabetisch, Sea-Doo (waterscooters en boten) apart onderaan (ontwerp).
const MERKEN = ["Evinrude", "Honda", "Johnson", "Mercury", "Suzuki", "Yamaha"];
// Merkpagina (collectie met sjabloon onderdelen-merk, 22 okt): de zoeker start met dit merk al gekozen.
const START_MERK = MERKEN.includes(CFG.merk) ? CFG.merk : null;
// Naar de motor in de onderdelenzoeker met de klikbare tekeningen, in hetzelfde tabblad.
// THEMA_KOPIE = de themakopie "Copy of Live|theme v3|Oct 2026|ExplodedViews" (Dieter 13 okt);
// leeg maken zodra de tekeningen in het live thema staan.
const WINKEL = "https://bouwmeesterwatersport.nl/pages/buitenboordmotor-onderdelen";
const THEMA_KOPIE = CFG.themaKopie !== undefined ? CFG.themaKopie : (INGEBED ? "" : "205290307925");
const GENOEG = 8;              // 'wat zie je'-vragen tot er zoveel motoren over zijn
const ZIET_MAX = 3;            // en hooguit zoveel vragen achter elkaar
const TOON_ALLE_MAX = 50;      // 'Toon alle N motoren' alleen als het er niet meer zijn
const ZIET_VELDEN = ["model", "bediening", "start", "staart", "trim", "takt"];
// Evinrude/Johnson: ook wat de versies splitst en wat je kunt zien of weet (controle2 17 okt: E-TEC G2 vanaf 2013 had tot
// 65 versies op een kaart). Alleen gevraagd als we het bij hooguit 20% niet weten (KB.volgendeZietVraag, 'streng').
const ZIET_EXTRA = { Evinrude: ["draairichting", "pakket", "kleur"], Johnson: ["draairichting", "kleur"] };
const zietVelden = () => ZIET_VELDEN.concat(ZIET_EXTRA[D.merk] || []);
const zietStreng = () => new Set(ZIET_EXTRA[D.merk] || []);
// Bij elke jaarvraag (eindlijst 16 okt: niet meer 'Gok gerust' - een gok zet de verkeerde versie bovenaan).
// Controle2 17 okt: alle jaarvragen zijn nu zacht (een ander jaar is 'Kan ook de jouwe zijn', nooit weg).
const ONZEKER = "Weet je het niet zeker? Kies Weet ik niet";

const VELDEN = {
  model: { titel: "Naam op de kap", vraag: "Welke naam staat op de kap?",
           labels: { "E-TEC": "E-TEC", "E-TEC G2": "E-TEC G2", FICHT: "FICHT", "geen E-TEC": "Alleen Evinrude" } },
  bediening: { titel: "Sturen", vraag: "Hoe stuur je de motor?", labels: { helmstok: "Helmstok", afstandsbediening: "Stuurwiel" } },
  start: { titel: "Starten", vraag: "Hoe start je de motor?", labels: { trekkoord: "Trekkoord", elektrisch: "Sleutel of knop" },
           onder: { elektrisch: "ook met reservekoord" } },
  staart: { titel: "Staart", vraag: "Hoe lang is de staart?", hint: "Van de klem tot de plaat boven de schroef",
            labels: { kort: "Kort", lang: "Lang", "extra lang": "Extra lang", "XX-lang": "XX-lang" },
            onder: { kort: '38 cm · 15"', lang: '51 cm · 20"', "extra lang": '64 cm · 25"', "XX-lang": '76 cm · 30"' },
            volgorde: ["kort", "lang", "extra lang", "XX-lang"] },
  trim: { titel: "Kantelen", vraag: "Hoe kantel je de motor?",
          labels: { elektrisch: "Elektrische trim", "met de hand": "Zelf optillen", "met een gasveer of hydraulisch": "Met gasveer" } },
  takt: { titel: "Tweetakt of viertakt", vraag: "Tweetakt of viertakt?", labels: { tweetakt: "Tweetakt", viertakt: "Viertakt" },
          onder: { tweetakt: "olie bij de benzine", viertakt: "peilstok onder de kap" } },
  jaar: { titel: "Bouwjaar" },
  pk: { titel: "Vermogen" },
  injectie: { titel: "Brandstof", labels: { carburateur: "Carburateur", injectie: "Injectie", "directe injectie": "Directe injectie" } },
  cilinders: { titel: "Cilinders" },
  draairichting: { titel: "Draairichting", vraag: "Hoe draait de schroef?", labels: { normaal: "Normaal", tegengesteld: "Tegengesteld" },
                   onder: { normaal: "de meeste motoren", tegengesteld: "vaak de tweede van twee motoren" } },
  kleur: { titel: "Kleur", vraag: "Welke kleur heeft de kap?", labels: { wit: "Wit", grijs: "Grijs" } },
  // alleen als 'wat zie je'-vraag (Evinrude E-TEC); in de lijst staat het bij de versies
  pakket: { titel: "Besturing", vraag: "Welke besturing heb je?",
            labels: { "kabel of losse cilinder": "Kabel", "Dynamic Power Steering (DPS)": "Stuurbekrachtiging", "geïntegreerd hydraulisch (IHS)": "Hydraulisch" },
            onder: { "kabel of losse cilinder": "of een losse cilinder", "Dynamic Power Steering (DPS)": "DPS, met een stekker", "geïntegreerd hydraulisch (IHS)": "IHS, in de motorbeugel" } },
};
// geen fabriek, markt, pakket of uitvoering: die staan bij de versies
const ALLE_VELDEN = Object.keys(VELDEN).filter(v => v !== "pakket");
const OPEN_GROEPEN = 5;

const wortel = document.querySelector(CFG.wortel || ".bm-vjm");
if (!wortel) return;
const app = wortel.querySelector(".bm-vjm__app");
// De filterlade hangt aan <body>: in het thema heeft elke sectie een eigen stapelvolgorde (isolate),
// een vaste laag binnen de sectie zou onder de kopbalk van de winkel vallen.
const lade = document.createElement("div");
lade.className = "bm-vjm-lade"; lade.hidden = true;
lade.setAttribute("role", "dialog"); lade.setAttribute("aria-modal", "true"); lade.setAttribute("aria-labelledby", "bm-vjm-ladetitel");
document.body.appendChild(lade);
const zetTitel = t => { if (!INGEBED) document.title = t; };
const esc = s => String(s ?? "").replace(/[&<>"]/g, c => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]));
const nl = KB.nl;
const ik = (naam, cls) => (IKOON[naam] || "").replace('class="ik"', `class="ik${cls ? " " + cls : ""}"`);
const label = (veld, w) => ((VELDEN[veld] || {}).labels || {})[w] || w;
let D = null, S = KB.nieuweStaat(), getekendOp = 0, scherm = "";
const cache = {};

// Mercury-namen leesbaar (klanttest v2: 'Engelse catalogusnamen'): '25 HP Carb 2 CYL (International)'
// -> '25 pk carburateur 2 cil.'; '9.9' -> '9,9'; (EXPORT) en (PRODUCT OF USA) weg.
function toonNaam(n) {
  let t = String(n);
  if (D && D.merk === "Mercury")
    t = t.replace(/\s*\((International|EXPORT|PRODUCT OF U\.?S\.?A\.?)\)/gi, "").replace(/\bHP\b/g, "pk")
         .replace(/\bH\.P\./g, "pk").replace(/\bCarb\b/gi, "carburateur").replace(/\b(V?\d+)\s?CYL\b/gi, "$1 cil.")
         .replace(/\bONLY\b/g, "alleen").replace(/(\d)\.(\d)/g, "$1,$2");
  // Sea-Doo-catalogusregels eindigen soms op een komma ('3D RFI,'); trollingmotor 'Intruder 44F*'
  return t.replace(/\s+/g, " ").replace(/[\s,*]+$/, "").trim();
}
const snTekst = sn => String(sn || "").replaceAll(" t/m ", " – ").replace(/\s*&\s*Up\b/gi, " en hoger");
// ------------------------------------------------------------------ serienummer (Suzuki), 17 okt 2026
// Dieter 17 okt: "de serienummers moeten er wel bij staan, de controle is belangrijk" en over de blokjes ('Serienummer begint
// met [11503F-71]'): "hoe kunnen we die serienummers het beste opschrijven". Gekozen ontwerp (tests/serienummer_proef:
// ontwerp d, jury_resultaat.json, tip_resultaat.json), opnieuw ingebouwd op de actuele ui.js (tests/serienummer_inbouw):
//   - per versie het nummer zoals het op de motor staat: 11503F-71 _ _ _ _ (de open plekken verschillen per motor). Licht
//     goud gemarkeerd wat de regel onderscheidt: altijd de jaarcode, bij twee versies met die jaarcode ook het blok of de P.
//   - in de kaart het veld 'Heb je het serienummer?': het hele nummer, alleen de 6 cijfers van het ronde plaatje op het
//     blok, of dat plaatje overgetypt ('2016 710031 OCT'). De versie die past staat bovenaan in navy met 'Bekijk onderdelen'.
//   - een tip met een eigen lijntekening waar het nummer zit (snTipHtml; Dieters keuze 'Compact, altijd zichtbaar').
// Bron: m.sn, reeksen gescheiden door komma's ('11503F-710001 t/m 11503F-71XXXX'). Een begin als 151001 (2001-2004)
// betekent nummers vanaf 1001. Mercury en Honda: zie 'serienummer Mercury en Honda' (18 okt).
// Herstel na de controle (17 okt, tests/serienummer_inbouw/na_herstel): een generatie staat in de bron alleen onder haar
// eerste jaar (DF 115 '11501F-15' = 2001; de volgende DF 115 is van 2012). Echte nummers uit de jaren ertussen
// (11501F-68 = 2006) werden 'kennen we niet'. Nu dekt zo'n reeks de jaarcodes tot de volgende motor met dezelfde naam
// (snDekking); de jaarcode per jaar komt uit de gegevens van het merk zelf (2006 = 68, 2016 = 61, 2021 = 14).
const SN_DEEL = /^(\d{5})([A-Z])-(\d)(\d)(\d*)/;
// Reeksen met een ander voorstuk aan begin en eind (bronfout). export_knoppenboom.py zet ze recht (suzuki_serie_rechtzetten),
// maar staat er nog een oude suzuki.js (cache van een uur, of de upload is nog niet gedaan), dan toont de zoeker toch het
// goede voorstuk (controle regressie 17 okt). Zelfde 5 paren als in de export; een ander paar: beide voorstukken.
const SN_RECHT = { "11503F>11503Z": "11503Z", "11505F>11505Z": "11505Z", "15003Z>15002Z": "15003Z", "30003P>30002P": "30002P",
                   "00403F>00603F": "00603F" };
// Per merk (D) een keer: de jaarcode per modeljaar (de meest gebruikte; DF 115 2025 '11506F-44' en DF 140 2024/2025
// '14004F-34' wijken af) en per modelnaam de jaren waarin een motor staat.
let SN_JAAR = null, SN_JAAR_VAN = null;
function snJaren() {
  if (SN_JAAR && SN_JAAR_VAN === D) return SN_JAAR;
  const tel = new Map(), per = new Map();
  for (const m of (D && D.motoren) || []) {
    if (m.j == null) continue;
    if (!per.has(m.n)) per.set(m.n, new Set());
    per.get(m.n).add(m.j);
    for (const x of String(m.sn || "").match(/\d{5}[A-Z]-\d{2}/g) || []) {
      const t = tel.get(m.j) || new Map(), jj = x.slice(-2);
      t.set(jj, (t.get(jj) || 0) + 1); tel.set(m.j, t);
    }
  }
  const jj = new Map([...tel].map(([j, t]) => [j, [...t].sort((a, b) => b[1] - a[1])[0][0]]));
  const jaren = new Map([...per].map(([n, s]) => [n, [...s].sort((a, b) => a - b)]));
  SN_JAAR_VAN = D; SN_JAAR = { jj, jaren };
  return SN_JAAR;
}
// Welke jaarcodes een reeks dekt (s.jjs) en bij welk modeljaar elke code hoort (s.jaar):
//   - een generatie: past de jaarcode bij het jaar van de motor en staat de volgende motor met dezelfde naam pas jaren later,
//     dan ook de jaren ertussen (DF 115 2001 'blok 11501': 2001 t/m 2011; s.van/s.tot);
//   - een jaarcode die niet bij het modeljaar past (DF 115 2025 '11506F-44'): ook de code van dat jaar (54). Of het een
//     tikfout in de bron is, weten we niet; zo wordt '11506F-54...' geen 'kennen we niet' en geeft '541234' geen stellige
//     treffer bij 11505F (controle 17 okt: 'navragen bij een dealer'). De jaarcode wordt bij zo'n regel niet gemarkeerd.
function snDekking(s) {
  const { jj, jaren } = snJaren(), m = s.m, eigen = m.j != null ? jj.get(m.j) : null;
  s.jjs = new Set([s.jj]); s.jaar = new Map([[s.jj, m.j]]);
  if (eigen && eigen !== s.jj) { s.jjs.add(eigen); s.jaar.set(eigen, m.j); s.twijfel = true; }
  else if (eigen) {
    const volgend = (jaren.get(m.n) || []).find(j => j > m.j);
    if (volgend && volgend - 1 > m.j) {
      for (let y = m.j + 1; y < volgend; y++) { const c = jj.get(y); if (c && !s.jjs.has(c)) { s.jjs.add(c); s.jaar.set(c, y); } }
      s.gen = true; s.van = m.j; s.tot = volgend - 1;
    }
  }
  return s;
}
function snReeksen(rs) {
  const uit = new Map();
  const zet = (r, blok, letter, jj, start) => {
    const sl = blok + letter + jj;
    if (!uit.has(sl)) uit.set(sl, snDekking({ blok, letter, jj, start, m: r.m }));
  };
  const begin = p => (/^\d{4}$/.test(p[5]) ? Number(p[3] + p[4] + p[5]) : 0);
  for (const r of rs) for (const d of String(r.m.sn || "").split(/\s*(?:,|<br\s*\/?>)\s*/i)) {
    const [a, b] = d.trim().split(/\s+t\/m\s+/i);
    const pa = SN_DEEL.exec(String(a || "").trim()), pb = SN_DEEL.exec(String(b || "").trim());
    const goed = pa && pb && pa[1] + pa[2] !== pb[1] + pb[2] ? SN_RECHT[pa[1] + pa[2] + ">" + pb[1] + pb[2]] : null;
    if (goed) { zet(r, goed.slice(0, 5), goed.slice(5), pa[3] + pa[4], begin(pa)); continue; }
    if (pa) zet(r, pa[1], pa[2], pa[3] + pa[4], begin(pa));
    if (pb) zet(r, pb[1], pb[2], pb[3] + pb[4], 0);
  }
  return [...uit.values()].sort((x, y) => (x.blok + x.letter).localeCompare(y.blok + y.letter) || x.jj.localeCompare(y.jj));
}
// Een generatie of twijfelreeks met de jaarcode die de klant typte: zo staat zijn eigen nummer in de treffer (11501F-68 1234)
// en weten we zijn modeljaar (s.mj); s.bereik = de jaren van de generatie (voor 'Modeljaar 2001 – 2011').
function snEcht(s, jj) {
  if (!jj || jj.length !== 2 || jj === s.jj || !s.jjs.has(jj)) return s;
  return Object.assign({}, s, { jj, gen: false, twijfel: false, mj: s.jaar.get(jj), bereik: s.gen ? [s.van, s.tot] : null });
}
const snJaarVan = (s, jj) => s.mj || (s.jaar && s.jaar.get(jj)) || s.m.j;
// De notatie: vast deel vet, de vier vrije cijfers als open plekken; 'eigen' = de cijfers die de klant typte; typ = wat er
// getypt is (een notatie die niet meer kan, wordt grijs, zonder markering); mk = markering van de kaart (snMarkeer).
// Een generatie: de jaarcode ook open, met de jaren erachter (11501F- _ _ _ _ _ _ 2001 – 2011).
const SN_SL = s => s.blok + s.letter + "-" + s.jj;
const snMk = (aan, x) => (aan ? `<mark>${esc(x)}</mark>` : esc(x));
const snNotatie = (s, eigen = "", typ = null, mk = null) => {
  const uit = !!(typ && !snKan(s, typ)), m = mk && !uit ? (mk.get(SN_SL(s)) || {}) : {};
  if (s.gen && !eigen)
    return `<span class="snn${uit ? " uit" : ""}"><b>${snMk(m.blok, s.blok)}${snMk(m.letter, s.letter)}-</b>`
      + `<span class="vrij" aria-hidden="true">${"<i></i>".repeat(6)}</span><span class="vh"> en dan 6 cijfers,</span>`
      + `<span class="snbereik">${esc(s.van)} – ${esc(s.tot)}</span></span>`;
  return `<span class="snn${uit ? " uit" : ""}"><b>${snMk(m.blok, s.blok)}${snMk(m.letter, s.letter)}-${snMk(mk && !uit && m.jj !== false, s.jj)}</b>`
    + (eigen ? `<span class="eigen">${esc(eigen)}</span>` : "")
    + `<span class="vrij" aria-hidden="true">${"<i></i>".repeat(Math.max(0, 4 - eigen.length))}</span>`
    + `<span class="vh">${eigen.length < 4 ? ` en dan ${4 - eigen.length} ${eigen.length === 3 ? "cijfer" : "cijfers"}` : ""}</span></span>`;
};
const snRij = (rs, eigen, typ, mk) => `<span class="snrij">${rs.map(s => snNotatie(s, eigen, typ, mk)).join("")}</span>`;
// Markering per kaart: de jaarcode altijd (niet bij een generatie of een jaarcode die niet bij het modeljaar past); het blok
// als geen andere versie met dezelfde jaarcode dat blok heeft; anders de letter als geen andere versie met die jaarcode
// hetzelfde blok met die letter heeft. Staat er bij dat blok een P tegenover F en Z, dan alleen de P (DF 150: 15003F/Z
// tegenover 15003P). Versies met precies dezelfde nummers tellen niet mee (daar beslist het nummer niet: DF 140 2023-2025
// met 14004F-34).
function snMarkeer(teksten) {
  const mk = new Map(), sl = t => t.reeksen.map(SN_SL).sort().join(",");
  teksten.forEach((t, i) => {
    for (const s of t.reeksen) {
      const ander = teksten.filter((x, j) => j !== i && x.reeksen.length && sl(x) !== sl(t)).flatMap(x => x.reeksen).filter(o => o.jj === s.jj);
      const blok = ander.length > 0 && !ander.some(o => o.blok === s.blok);
      const zelfdeBlok = ander.filter(o => o.blok === s.blok);
      const letter = !blok && zelfdeBlok.length > 0 && !zelfdeBlok.some(o => o.letter === s.letter)
        && (s.letter === "P" || !zelfdeBlok.some(o => o.letter === "P"));
      const oud = mk.get(SN_SL(s)) || { blok: false, letter: false, jj: true };
      mk.set(SN_SL(s), { blok: oud.blok || blok, letter: oud.letter || letter, jj: oud.jj && !s.twijfel && !s.gen });
    }
  });
  return mk;
}

// Het ronde plaatje op het blok heeft waarschijnlijk drie regels: bouwjaar, volgnummer en maand ('2016 / 710031 / OCT.';
// controle 17 okt, tip_resultaat.json). Wie dat overtypt ('2016 710031 OCT', '2016710031', '710031 OCT') krijgt de 6
// cijfers; het bouwjaar bewaren we voor de uitleg (gebouwd in oktober 2016 kan modeljaar 2017 zijn).
const SN_MAAND = /^(JAN|FEB|MAR|MRT|APR|MAY|MEI|JUN|JUL|AUG|SEP|SEPT|OCT|OKT|NOV|DEC)$/;
const SN_BOUWJAAR = /^(19[89]\d|20[0-4]\d)$/;
function snPlaatje(tekst) {
  const t = String(tekst || "").toUpperCase().match(/\d+|[A-Z]+/g) || [];
  const maand = t.some(x => SN_MAAND.test(x)), rest = t.filter(x => !SN_MAAND.test(x));
  if (!rest.length || !rest.every(x => /^\d+$/.test(x))) return null;
  if (rest.length === 2 && SN_BOUWJAAR.test(rest[0]) && rest[1].length <= 6) return { cijfers: rest[1], bouwjaar: Number(rest[0]) };
  if (rest.length === 2 && SN_BOUWJAAR.test(rest[1]) && rest[0].length === 6) return { cijfers: rest[0], bouwjaar: Number(rest[1]) };
  if (rest.length !== 1) return null;
  const r = rest[0];
  if (/^\d{10}$/.test(r) && SN_BOUWJAAR.test(r.slice(0, 4)) && (maand || !snBlokken().has(r.slice(0, 5))))
    return { cijfers: r.slice(4), bouwjaar: Number(r.slice(0, 4)) };
  if (maand && SN_BOUWJAAR.test(r)) return { cijfers: "", bouwjaar: Number(r) };      // alleen jaar en maand
  if (maand && r.length <= 6) return { cijfers: r, bouwjaar: null };
  return null;
}
// Wat de klant typte: hoofdletters, zonder streepjes en spaties. Op de cijferplekken wordt O/Q 0, I/L 1, S 5 en B 8 (ll503F,
// 71234S); op de letterplek (zesde teken, F, Z of P) wordt een 2 een Z (115032-712345: een ingeslagen Z lijkt op een 2).
// Het streepje of de spatie die de klant typte, zegt waar het voorstuk ophoudt. Ook zonder letter ('11503-712345'), met
// alleen het eerste stuk ('11503F'), zonder voorloopnullen ('603F' = 00603F als dat blok bestaat) en met de modelnaam van
// het plaatje ervoor ('DF115A 11503F-712345'). fout: 'model', 'vorm' of 'letter' (een letter die geen Suzuki-letter is).
// cijfers: alleen cijfers en hooguit zes = misschien (het begin van) het volgnummer zonder motorblok ervoor.
const SN_CIJ = { O: "0", Q: "0", I: "1", L: "1", S: "5", B: "8" };
const snCij = x => x.replace(/[OQILSB]/g, c => SN_CIJ[c]);
function snLees(tekst) {
  const pl = snPlaatje(tekst);
  if (pl) return Object.assign(pl.cijfers ? snLees(pl.cijfers) : { blok: "", letter: "", rest: "", cijfers: "" }, { bouwjaar: pl.bouwjaar, plaatje: true });
  let ruw = String(tekst || "").toUpperCase().trim();
  const mn = /^D[FT]\s*\d{1,3}(?:[.,]\d)?[A-Z]{0,3}[\s:,\-–—]+(?=[0-9OIL])/.exec(ruw);
  if (mn) ruw = ruw.slice(mn[0].length);
  const delen = ruw.split(/[\s\-–—.\/_]+/).filter(Boolean);
  if (!delen.length) return { leeg: true };
  const s = delen.join(""), voor = delen.length > 1 ? delen[0] : "";
  if (/^D[FT]/.test(s)) return { fout: "model" };
  let blok, letter = "", rest;
  if (voor.length === 6 && /^[0-9OQILSB]{5}$/.test(voor.slice(0, 5))) {
    blok = voor.slice(0, 5); letter = voor[5]; rest = delen.slice(1).join("");
  } else if (/^[0-9OQILSB]{3,4}[A-Z]$/.test(voor) && !SN_CIJ[voor.slice(-1)]) {
    blok = voor.slice(0, -1); letter = voor.slice(-1); rest = delen.slice(1).join("");
  } else {
    const p = /^([0-9OQILSB]{1,5})([A-Z]?)(.*)$/.exec(s);
    if (!p) return { fout: "vorm" };
    [, blok, letter, rest] = p;
    // twaalf cijfers aan elkaar: het zesde is de letter, als cijfer gelezen
    if (!letter && delen.length === 1 && p[1].length === 5 && /^\d{7}$/.test(snCij(rest))) { letter = rest[0]; rest = rest.slice(1); }
  }
  if (!/^[0-9OQILSB]*$/.test(rest)) return { fout: "vorm" };
  blok = snCij(blok); rest = snCij(rest);
  if (letter === "2") letter = "Z";
  if (letter && blok.length < 5 && blok.length >= 3 && snBlokken().has(blok.padStart(5, "0"))) blok = blok.padStart(5, "0");
  if (letter && blok.length < 5) return { fout: "vorm" };
  if (letter && !snLetters().has(letter)) return { fout: "letter", blok };
  return { blok, letter, rest, zeker: blok.length === 5 && rest.length >= 2, te: rest.length > 6,
           cijfers: !letter && /^\d{1,6}$/.test(blok + rest) ? blok + rest : "" };
}
// Volgnummer (of het begin ervan) zonder motorblok: de jaarcode beslist (s.jjs: ook de jaren van een generatie). Bij zes
// cijfers met de eigen jaarcode ook de ondergrens (151001).
const snJjKan = (s, b) => [...s.jjs].some(j => j.startsWith(b));
const snVolgKan = (s, c) => snJjKan(s, c.slice(0, 2));
const snVolgPast = (s, c) => s.jjs.has(c.slice(0, 2)) && (c.slice(0, 2) !== s.jj || Number(c) >= s.start);
// Kan deze reeks nog, met wat er tot nu toe getypt is? (ook bij minder dan vijf cijfers; alleen cijfers = motorblok of volgnummer)
function snKan(s, t) {
  if (t.cijfers && snVolgKan(s, t.cijfers)) return true;
  if (!s.blok.startsWith(t.blok)) return false;
  return t.blok.length < 5 ? true : snPast(s, t);
}
function snPast(s, t) {
  if (!t.blok || t.blok.length < 5 || t.blok !== s.blok || (t.letter && t.letter !== s.letter)) return false;
  if (t.rest && !snJjKan(s, t.rest.slice(0, 2))) return false;
  if (t.rest.length === 6 && t.rest.slice(0, 2) === s.jj && Number(t.rest) < s.start) return false;
  return !t.te;
}
// Per kaart (sleutel = id van de eerste motor) de versieteksten, zodat het veld de lijst opnieuw kan tekenen; en wat er
// getypt is (blijft staan na een filter of terug).
const SN_KAART = new Map(), SN_INVOER = new Map();

// ------------------------------------------------------------------ gegevens
// Als <script>, niet via fetch(): zo werkt de pagina ook als los bestand (file://).
function laad(merk) {
  if (cache[merk]) return Promise.resolve(cache[merk]);
  return new Promise((ok, fout) => {
    const tag = document.createElement("script");
    tag.src = DATA + merk.toLowerCase() + ".js" + (CFG.versie ? "?v=" + encodeURIComponent(CFG.versie) : "");
    tag.onload = () => { const d = (window.KNOPPENBOOM || {})[merk]; d ? ok(cache[merk] = d) : fout(new Error("geen gegevens")); };
    tag.onerror = () => fout(new Error("kan de gegevens niet laden"));
    document.head.appendChild(tag);
  });
}
const urlVoor = (id, merk, naam) => `${WINKEL}?engine_id=${encodeURIComponent(id)}&merk=${encodeURIComponent(merk)}` +
                                    `&model=${encodeURIComponent(naam)}` + (THEMA_KOPIE ? `&preview_theme_id=${THEMA_KOPIE}` : "");
const motorUrl = m => urlVoor(m.id, m.merk_rij || D.merk, m.n);

// Laatst bekeken motor (dit apparaat).
function laatste() { try { return JSON.parse(localStorage.getItem("bm-laatste-motor") || "null"); } catch (e) { return null; } }
// n = de modelcode (zoals motorUrl), t = de kaartnaam die de klant herkende ('E-TEC 115 pk H.O.'), j en c = het
// modeljaar en de code van de gekozen versie (controle2: 'Verder met je motor' zei niet welke versie).
function onthoud(m) {
  const c = codeVan(m);
  try { localStorage.setItem("bm-laatste-motor", JSON.stringify({ id: m.id, merk: D.merk, merk_rij: m.merk_rij, n: m.n, t: toonNaam(KB.kaartNaam(m)), pk: m.pk,
                                                                  j: m.j || null, c: isCode(c) ? c : null })); }
  catch (e) { /* geen opslag: niet erg */ }
}

// ------------------------------------------------------------------ navigatie
// Altijd het volledige adres: een <base> in de pagina (proef) zou een los '#...' naar een ander domein laten wijzen.
const adres = n => location.href.split("#")[0] + (KB.naarHash(n) || "");
// In een afgeschermd kader (gedeelde prototypepagina) kan de browser het adres weigeren: dan werkt alles,
// alleen de terugknop van de browser niet.
const zet = (f, n) => { try { history[f](null, "", adres(n)); } catch (e) { /* adres niet toegestaan */ } };
function verder(n) { zet("pushState", n); S = n; teken(true); }
function vervang(n) { zet("replaceState", n); S = n; teken(false); }
window.addEventListener("popstate", async () => {
  if (INGEBED && !location.hash.startsWith("#vjm=") && !S.merk) return;   // niet van ons
  const n = KB.uitHash(location.hash) || KB.nieuweStaat(START_MERK);
  if (n.merk && n.merk !== (D && D.merk)) { try { D = await laad(n.merk); } catch (e) { return toonFout(); } }
  S = n; teken(true);
});
function kopie() {
  const n = Object.assign({}, S, { auto: Object.assign({}, S.auto), gevraagd: Object.assign({}, S.gevraagd || {}), filters: {} });
  for (const [v, s] of Object.entries(S.filters)) n.filters[v] = new Set(s);
  delete n.toon; delete n.toonOok; delete n.meer; delete n.toonAndere;
  return n;
}

// ------------------------------------------------------------------ tekenen
function teken(nieuweStap) {
  sluitLade();
  if (!S.merk) tekenMerk();
  else {
    const rijen = KB.naBoom(D, S);
    const stap = S.lijst ? null : KB.volgendeStap(D, S, rijen);
    const ziet = !stap && !S.lijst ? KB.volgendeZietVraag(D, S, rijen, KB.velden(D, S, zietVelden()), GENOEG, ZIET_MAX, zietStreng()) : null;
    // Eerst wat je ziet (zeker), daarna pas het bouwjaar (een gok) - alleen als er nog veel keuzes zijn.
    const jaar = !stap && !ziet && !S.lijst ? KB.jaarStap(D, S, rijen) : null;
    if (stap) { scherm = "vraag"; tekenStap(stap, rijen); }
    else if (ziet) { scherm = "ziet"; tekenZietVraag(ziet, rijen); }
    else if (jaar) { scherm = "vraag"; tekenStap(jaar, rijen); }
    else { scherm = "lijst"; tekenLijst(rijen); }
  }
  getekendOp = Date.now();
  if (nieuweStap) { naarBoven(); const h = app.querySelector(".bm-vjm-vraag"); if (h) h.focus({ preventScroll: true }); }
}
// Na een nieuwe stap: prototype naar de bovenkant van de pagina; in het thema alleen naar het blok
// als dat boven beeld staat (de scanner staat erboven).
function naarBoven() {
  if (!INGEBED) return window.scrollTo(0, 0);
  const r = wortel.getBoundingClientRect();
  if (r.top < 0) wortel.scrollIntoView({ block: "start" });
}
function toonFout() {
  app.classList.remove("lijstscherm");
  app.innerHTML = `<h2 class="bm-vjm-vraag" tabindex="-1">Dat lukte niet</h2><button class="knop" data-actie="opnieuw">Opnieuw proberen</button>`;
}

const tegel = (attr, inhoud, cls) => `<button class="tegel${cls ? " " + cls : ""}" ${attr}>${inhoud}</button>`;
const tekst = (t, onder) => `<span>${esc(t)}${onder ? `<small>${esc(onder)}</small>` : ""}</span>`;

// '< Terug' en de antwoorden tot nu toe (tik = die vraag opnieuw).
function antwoorden() {
  const a = [];
  const b1 = S.k1 != null ? D.knoppen1[S.k1] : null;
  a.push(["merk", S.merk]);
  if (S.soort != null && !S.auto.soort) a.push(["soort", SOORT_KORT[S.soort] || S.soort]);
  if (S.kop1 != null) a.push(["kop1", S.kop1]);
  if (b1 && !S.auto.k1) a.push(["k1", b1.groep || kortK1(b1.tekst)]);
  if (S.pkk != null && S.groep2 == null) a.push(["pkk", S.pkk]);
  if (S.groep2 != null) a.push(["groep2", S.groep2]);
  if (S.dec2 != null) a.push(["dec2", S.dec2]);                    // 18 okt: een los jaar, altijd als chip (was alleen zonder model)
  if (S.k2 != null && !S.auto.k2) {
    const t = String(D.knoppen2[[].concat(S.k2)[0]].tekst);
    a.push(["k2", D.merk === "Honda" ? (S.k2tekst || t.split(" – ")[0]) : toonNaam(t.split(" – ")[0])]);
  }
  if (S.cc != null && !S.auto.cc) a.push(["cc", S.cc]);            // waterscooter: na het model (17 okt)
  if (S.jaar != null) a.push(["jaar", S.jaar]);                    // bouwjaarvraag na de vragen (18 okt: geen jaar2 meer)
  return a;
}
// Korte chiptekst voor een gekozen kenmerk: 'Stuurwiel', 'Tweetakt', 'Staart lang', 'Bouwjaar 1990 – 1999'.
function chipTekst(veld, w) {
  if (["bediening", "start", "trim", "takt", "model"].includes(veld)) return label(veld, w);
  if (veld === "staart") return "Staart " + label(veld, w).toLowerCase();
  if (veld === "jaar") return "Bouwjaar " + w;
  if (veld === "pk") return w;
  return (VELDEN[veld] ? VELDEN[veld].titel + " " : "") + label(veld, w).toLowerCase();
}
const kortK1 = t => String(t).replace(/\s*\((viertakt|tweetakt)\)/i, "");
function navHtml(metFilters) {
  const chips = antwoorden().map(([k, t]) => `<button class="chip" data-terug="${k}" aria-label="Wijzig: ${esc(t)}">${esc(t)}${ik("potlood")}</button>`);
  if (metFilters) {
    for (const [veld, set] of Object.entries(S.filters)) for (const w of set)
      chips.push(`<button class="chip" data-filter="${veld}" data-waarde="${esc(w)}" aria-label="Haal weg: ${esc(chipTekst(veld, w))}">${esc(chipTekst(veld, w))}${ik("kruis")}</button>`);
    if (Object.values(S.filters).some(s => s.size)) chips.push(`<button class="chip wis" data-actie="wis">Wis alles</button>`);
  }
  return `<button class="terug" data-actie="terug">${ik("terug")}Terug</button><div class="chips">${chips.join("")}</div>`;
}

// Terug zonder adresgeschiedenis: naar de laatst beantwoorde vraag (of het merkscherm).
function stapTerug() {
  if (S.lijst) { const n = kopie(); n.lijst = false; return verder(n); }
  const a = antwoorden();
  return a.length > 1 ? terugNaar(a[a.length - 1][0]) : verder(KB.nieuweStaat());
}
function terugNaar(stap) {
  // De bouwjaarvraag komt na de 'wat zie je'-vragen: terug naar het jaar houdt die antwoorden.
  if (stap === "jaar") { const n = kopie(); n.lijst = false; delete n.jaar; return verder(n); }
  // cc: waterscooter (17 okt); geen 'dec' meer (18 okt). Een ander jaar (k1, dec2) vraagt alles daarna opnieuw.
  const volg = ["merk", "soort", "kop1", "k1", "pkk", "groep2", "dec2", "k2", "cc"];
  const i = volg.indexOf(stap);
  if (i <= 0) return verder(KB.nieuweStaat());
  const n = KB.nieuweStaat(S.merk);
  for (const v of volg.slice(1, i)) { n[v] = S[v]; if (S.auto[v]) n.auto[v] = true; }
  if (i > volg.indexOf("pkk")) n.modus2 = S.modus2;
  verder(n);
}

// ---------------------------------------------------------- merk
function tekenMerk() {
  zetTitel("Vind je motor");
  app.classList.remove("lijstscherm");
  const l = laatste();
  // Controle2 17 okt: het merk niet twee keer ('Johnson Johnson 15 pk'), en welke versie (modeljaar, code).
  const lNaam = l ? (l.t || l.n) : "", lMet = l && String(lNaam).startsWith(l.merk) ? "" : (l ? l.merk + " " : "");
  const lPk = l && l.pk != null && !/\bpk\b/.test(lNaam) ? nl(l.pk) + " pk · " : "";
  const lVersie = l ? [l.j ? "Modeljaar " + l.j : "", l.c && l.c !== lNaam ? l.c : ""].filter(Boolean).join(" · ") : "";
  app.innerHTML = `
    ${l ? `<div class="tegels breed" style="margin-top:4px"><a class="tegel verder vol" data-laatste="1" href="${esc(urlVoor(l.id, l.merk_rij || l.merk, l.n))}">
      ${ik("buitenboord")}<span><small style="margin:0">Verder met je motor</small>${esc(lMet + lPk + lNaam)}${lVersie ? `<small>${esc(lVersie)}</small>` : ""}</span>${ik("verder", "rechts")}</a></div>` : ""}
    <h2 class="bm-vjm-vraag" tabindex="-1">Welk merk?</h2>${INGEBED ? "" : `<p class="hint">Vind onderdelen voor jouw motor, ook zonder typeplaatje</p>`}
    <div class="paneel"><div class="tegels">${MERKEN.map(m => tegel(`data-merk="${m}"`, esc(m), "merk")).join("")}
      ${tegel(`data-merk="Sea-Doo"`, `${ik("waterscooter")}<span>Sea-Doo</span>`, "merk vol")}</div>
    ${INGEBED ? "" : `<div class="of">of</div>
    <div class="tegels breed"><a class="tegel" href="${WINKEL}${THEMA_KOPIE ? "?preview_theme_id=" + THEMA_KOPIE : ""}">${ik("plaatje")}${tekst("Ik heb het typeplaatje")}${ik("verder", "rechts")}</a></div>`}</div>`;
}

// ---------------------------------------------------------- vraagschermen
const SOORT_IK = { "Buitenboordmotor": "buitenboord", "Waterscooter (WaveRunner)": "waterscooter", "Waterscooter": "waterscooter",
                   "Pontonboot (Switch)": "ponton", "Sportboot (jetboot)": "sportboot", "Hekaandrijving": "hekaandrijving",
                   "Binnenboordmotor": "binnenboord", "Trollingmotor": "trolling", "Jetaandrijving": "jetaandrijving",
                   "Revisiemotor": "buitenboord", "Zeus-pod": "zeuspod" };
const SOORT_KORT = { "Waterscooter (WaveRunner)": "Waterscooter", "Pontonboot (Switch)": "Pontonboot", "Sportboot (jetboot)": "Jetboot",
                     "Binnenboordmotor": "Binnenboord" };   // past op een smalle telefoon in een tegel

// 'motoren' of 'waterscooters' (controle2: 'Toon alle 44 motoren' op een waterscooterscherm).
const alleenWs = rijen => rijen.length && rijen.every(r => (r.m.s || []).some(x => /Waterscooter/.test(x)));
const motorenWoord = (rijen, n) => (alleenWs(rijen) ? (n === 1 ? "waterscooter" : "waterscooters") : (n === 1 ? "motor" : "motoren"));
// 'Toon alle 1 waterscooter' las raar (controle 17 okt; de cc-vraag kan versies van een kaart splitsen): 'Toon deze ...'.
// Bij alle merken (ook 'Toon alle 1 motoren' op een 'wat zie je'-vraag); verder dezelfde tekst als voorheen.
const toonAlleTekst = (rijen, n) => (n === 1 ? `Toon deze ${motorenWoord(rijen, 1)}` : `Toon alle ${n} ${motorenWoord(rijen, n)}`);
function vraagScherm(kop, hint, tegelsHtml, rijen, stap, raster) {
  zetTitel(kop + " – Vind je motor");
  app.classList.remove("lijstscherm");
  // de zekere motoren (wat de lijst als 'passen' telt); sinds de zachte jaarvragen doet bijna alles als 'kan ook' mee
  const basis = KB.tegelBasis(rijen), n = KB.telKaarten(basis);
  app.innerHTML = `${navHtml(false)}
    <h2 class="bm-vjm-vraag" tabindex="-1">${esc(kop)}</h2>${hint ? `<p class="hint">${esc(hint)}</p>` : ""}
    <div class="paneel"><div class="tegels ${raster || ""}">${tegelsHtml}</div>
    <div class="of">of</div>
    <div class="tegels breed">${tegel(`data-weetniet="${stap}"`, `${ik("vraag", "klein")}<span>Weet ik niet</span>`, "weetniet")}</div>
    ${n <= TOON_ALLE_MAX ? `<button class="stil" data-actie="lijst">${toonAlleTekst(basis, n)}</button>` : ""}</div>`;
}
// Getal en eenheid niet uit elkaar op een smalle telefoon ('SuperJet (650' / 'cc)').
const tegelTekst = t => esc(t).replace(/(\d) (cc|pk)\b/g, "$1 $2");
// Handelsnaamtegel van een waterscooter (controle 17 okt): '(2-zits)' staat niet op de romp en brak af ('JetBlaster (2-' /
// 'zits)') -> '2 zitplaatsen' als regel eronder; andere haakjes niet afbreken; de periode van de machines onder de tegel
// eronder (namen die op elkaar lijken: FX SHO 2008 – 2015 tegenover FX SVHO 2014 – 2027).
function wsNaamTegel(t, periode) {
  const z = /^(.*) \((\d)-zits\)$/.exec(t);
  const naam = z ? z[1] : t, onder = [z ? z[2] + " zitplaatsen" : "", periode].filter(Boolean);   // elk een eigen regel
  const hoofd = tegelTekst(naam).replace(/\(([^()]{1,14})\)/g, '<span class="nw">($1)</span>');
  return `<span>${hoofd}${onder.map(x => `<small>${esc(x)}</small>`).join("")}</span>`;
}

// ------------------------------------------------------------------ jaren direct (18 okt 2026)
// Dieter 18 okt: "ik wil eigenlijk die tussenstap weg en gewoon alle jaren onder elkaar/naast elkaar. dat scheelt een klik".
// Elke jaarvraag toont alle jaren tegelijk als compacte getaltegels: per decennium een blok met een klein kopje (geen knop),
// nieuwste bovenaan; telefoon 5 per rij, computer 10 (een decennium = een rij). Een groepsknop ('2013 of later', 'voor 1968')
// is een brede tegel in zijn decennium. Was: eerst een tijdvak ('2010 – 2019'), dan 'Welk jaar precies?' (tests/jaren_direct).
// items: [{ attr, tekst, j }] in de volgorde van tonen (nieuwste eerst); j = het jaar dat het decennium bepaalt.
function jarenHtml(items) {
  const blokken = new Map();
  for (const it of items) {
    const d = it.j == null ? -1 : Math.floor(it.j / 10) * 10;
    if (!blokken.has(d)) blokken.set(d, []);
    blokken.get(d).push(it);
  }
  const ds = [...blokken.keys()].sort((a, b) => b - a);
  // het nieuwste decennium 'vanaf 2020' (geen 2029 als het 2026 is); met maar een decennium geen kopjes
  const kop = d => (ds.length < 2 ? "" : d < 0 ? "Overig" : d === ds[0] ? `vanaf ${d}` : `${d} – ${d + 9}`);
  return ds.map(d => (kop(d) ? `<div class="jaarkop">${esc(kop(d))}</div>` : "")
    + blokken.get(d).map(it => tegel(it.attr, esc(it.tekst), /^\d{4}$/.test(String(it.tekst)) ? "" : "jgroep")).join("")).join("");
}
const jaarItems = (tegels, sleutel) => tegels.map(t => ({ attr: `data-${sleutel}="${esc(t)}"`, tekst: t, j: KB.jaarBereik(t)[0] || null }));

function tekenStap(stap, rijen) {
  if (stap === "soort") {
    const tg = [...KB.telSoort(rijen).keys()].map(s => tegel(`data-soort="${esc(s)}"`, `${ik(SOORT_IK[s])}<span>${esc(SOORT_KORT[s] || s)}</span>`, "beeld")).join("");
    return vraagScherm("Wat heb je?", "", tg, rijen, "soort");
  }
  if (stap === "kop1") {
    const koppen = [...new Set([...KB.telKlik(D, S, rijen, 0).keys()].map(i => D.knoppen1[i].kop))];
    koppen.sort((a, b) => (a === "Buitenboordmotor" ? -1 : b === "Buitenboordmotor" ? 1 : a.localeCompare(b, "nl", { numeric: true })));
    const metBeeld = koppen.every(k => SOORT_IK[k]);
    const tg = koppen.map(k => tegel(`data-kop1="${esc(k)}"`, metBeeld ? `${ik(SOORT_IK[k])}<span>${esc(SOORT_KORT[k] || k)}</span>` : esc(k), metBeeld ? "beeld" : "")).join("");
    return D.merk === "Honda" ? vraagScherm("Hoeveel pk ongeveer?", "Staat groot op de kap", tg, rijen, "kop1")
                              : vraagScherm("Wat voor motor?", "", tg, rijen, "kop1");
  }
  if (stap === "k1") {
    const t = KB.telKlik(D, S, rijen, 0);
    if (D.klik1_jaar) {
      // 18 okt (jaren direct): alle jaarknoppen op een scherm, per decennium; '2013 of later' en 'voor 1968' als brede tegel
      const tg = jarenHtml(KB.jaarKnoppen(D, t).map(k => ({ attr: `data-k1="${k.i}"`, tekst: k.tekst, j: k.j })));
      return vraagScherm("Welk bouwjaar?", ONZEKER, tg, rijen, "k1", "jaren");
    }
    let ids = [...t.keys()];
    if (D.merk === "Mercury") ids.sort((a, b) => ((D.knoppen1[a].v ?? 99) - (D.knoppen1[b].v ?? 99)) || D.knoppen1[a].tekst.localeCompare(D.knoppen1[b].tekst, "nl"));
    else {
      const sk = t => /^tot\b/.test(t) ? -1 : (parseFloat((String(t).match(/\d+(?:[.,]\d+)?/) || ["1e9"])[0].replace(",", ".")));
      ids.sort((a, b) => (sk(D.knoppen1[a].tekst) - sk(D.knoppen1[b].tekst)) || D.knoppen1[a].tekst.localeCompare(D.knoppen1[b].tekst, "nl", { numeric: true }));
    }
    if (D.merk === "Suzuki") {
      const tg = ids.map(i => { const v = /viertakt/i.test(D.knoppen1[i].tekst);
        return tegel(`data-k1="${i}"`, `<span class="groot">${esc(kortK1(D.knoppen1[i].tekst))}</span><span class="woorden"><span>${ik(v ? "viertakt" : "tweetakt")}${v ? "Viertakt" : "Tweetakt"}</span></span>`, "beeld"); }).join("");
      return vraagScherm("DF of DT op de kap?", "", tg, rijen, "k1");
    }
    const tg = ids.map(i => tegel(`data-k1="${i}"`, D.knoppen1[i].onder ? tekst(D.knoppen1[i].tekst, D.knoppen1[i].onder) : tegelTekst(D.knoppen1[i].tekst))).join("");
    if (D.merk === "Mercury") return vraagScherm("Welk type motor?", "Staat vaak op de kap", tg, rijen, "k1");
    if (D.merk === "Yamaha") return S.soort && /Waterscooter/.test(S.soort)
      ? vraagScherm("Hoe groot is de motor?", "", tg, rijen, "k1") : vraagScherm("Hoeveel pk ongeveer?", "Staat groot op de kap", tg, rijen, "k1");
    if (D.merk === "Honda") return vraagScherm("Welk model?", "Staat op de kap", tg, rijen, "k1", ids.length > 6 ? "getal" : "");
    return vraagScherm("Welk type?", "", tg, rijen, "k1");
  }
  if (stap === "pkk") {
    const aanwezig = new Set(KB.tegelBasis(rijen).flatMap(r => KB.pks(r.m)).map(KB.pkKlasseTekst));
    const tg = KB.PK_KLASSE_TEKST.filter(k => aanwezig.has(k)).map(k => tegel(`data-pkk="${esc(k)}"`, esc(k))).join("");
    return vraagScherm("Hoeveel pk ongeveer?", "Staat groot op de kap", tg, rijen, "pkk");
  }
  if (stap === "groep2") {
    const groepen = KB.telGroep2(D, rijen, S.modus2);
    if (S.modus2 === "kop") {
      // Waterscooter (17 okt): het model eerst. De romptegel 'WaveRunner' is alleen de oude machines met die naam (Yamaha
      // noemt al zijn waterscooters WaveRunner, dus ook een FX- of VX-rijder kan dit woord lezen): daarom 'oude modellen, tot ...'.
      const onder = g => {
        if (g.tekst === "Ander model") return "naam staat er niet bij";     // machines zonder bekende naam (17 okt)
        if (g.tekst !== "WaveRunner") return "";
        const js = KB.tegelBasis(rijen).filter(r => r.paden.some(p => p[1] !== null && D.knoppen2[p[1]].tussenkop === g.tekst)).map(r => r.m.j).filter(Boolean);
        return js.length ? "oude modellen, tot " + Math.max(...js) : "";
      };
      const tg = groepen.map(g => tegel(`data-groep2="${esc(g.tekst)}"`, onder(g) ? tekst(g.tekst, onder(g)) : tegelTekst(g.tekst), "midden")).join("");
      return vraagScherm("Welk model?", "Staat groot op de romp", tg, rijen, "groep2", "namen");
    }
    const tg = groepen.map(g => tegel(`data-groep2="${esc(g.tekst)}"`, `<span>${esc(g.tekst.replace(/ pk$/, ""))}<span class="pk">pk</span></span>`, "midden")).join("");
    return vraagScherm("Hoeveel pk?", "Staat groot op de kap", tg, rijen, "groep2", "getal");
  }
  // Cilinderinhoud (waterscooter, 17 okt): na het model de cc-waarden van de machines die over zijn, met hun periode (het
  // getal komt uit de modelcode); zonder model de klassen ('tot 800 cc': de '700'-modellen hebben 701 cc).
  if (stap === "cc") {
    const tg = KB.ccTegels(D, S, rijen).map(t => tegel(`data-cc="${esc(t.tekst)}"`,
      t.cc != null && t.van ? `<span>${tegelTekst(t.tekst)}<small>${esc(t.van === t.tot ? String(t.van) : t.van + " – " + t.tot)}</small></span>` : tegelTekst(t.tekst), "midden")).join("");
    return vraagScherm("Hoe groot is de motor?", ONZEKER, tg, rijen, "cc");
  }
  // Bouwjaar voor het model (dec2) en de bouwjaarvraag na de vragen (jaar): alle jaren op een scherm (18 okt; was eerst het
  // tijdvak, en na de vragen dan 'Welk jaar precies?'). Zacht: een ander jaar zet een motor bij 'Kan ook de jouwe zijn', nooit weg.
  if (stap === "dec2") return vraagScherm("Welk bouwjaar?", ONZEKER, jarenHtml(jaarItems(KB.boomJaarTegels(D, S, rijen), "dec2")), rijen, "dec2", "jaren");
  if (stap === "jaar") return vraagScherm("Welk bouwjaar?", ONZEKER, jarenHtml(jaarItems(KB.jaarTegels(D, S, rijen), "jaar")), rijen, "jaar", "jaren");
  if (stap === "k2") {
    const ids = [...KB.telKlik(D, S, rijen, 1).keys()].sort((a, b) => D.knoppen2[a].tekst.localeCompare(D.knoppen2[b].tekst, "nl", { numeric: true }));
    if (D.merk === "Honda") return vraagScherm("Welke uitvoering?", "", hondaTegels(ids), rijen, "k2", "breed");
    const getal = D.merk === "Evinrude" || D.merk === "Johnson";
    // Tegels met dezelfde tekst worden een tegel (klanttest v3: twee keer '4 pk 1 cil.' na het opschonen).
    // Sea-Doo: meer dan 12 series -> per eerste woord (GTI, GTX, GS ...).
    const sleutelVan = i => {
      const t = getal ? D.knoppen2[i].tekst : toonNaam(D.knoppen2[i].tekst);
      return D.merk === "Sea-Doo" && new Set(ids.map(j => D.knoppen2[j].tekst)).size > KB.MAX_LIJST ? t.split(/[\s\/-]/)[0] : t;
    };
    const groepen = new Map();
    for (const i of ids) { const k = sleutelVan(i); if (!groepen.has(k)) groepen.set(k, []); groepen.get(k).push(i); }
    // waterscooter: de periode van de machines onder de tegel (KB.tegelBasis: de machines met de gekozen romp)
    const periodeVan = is => {
      const set = new Set(is), js = KB.tegelBasis(rijen).filter(r => r.paden.some(p => set.has(p[1]))).map(r => r.m.j).filter(Boolean);
      return !js.length ? "" : Math.min(...js) === Math.max(...js) ? String(js[0]) : Math.min(...js) + " – " + Math.max(...js);
    };
    // Evinrude/Johnson: een tegel zonder ' pk' (trollingmotor '12 volt (elektrisch)') zonder het woordje pk erachter.
    const tg = [...groepen].map(([t, is]) => getal && / pk$/.test(t)
      ? tegel(`data-k2="${is.join(",")}"`, `<span>${esc(t.replace(/ pk$/, ""))}<span class="pk">pk</span></span>`, "midden")
      : KB.isWs(D, S) ? tegel(`data-k2="${is.join(",")}"`, wsNaamTegel(t, periodeVan(is)), "midden")
      : tegel(`data-k2="${is.join(",")}"`, tegelTekst(t), getal ? "midden" : "")).join("");
    if (getal) return vraagScherm("Hoeveel pk?", "Staat groot op de kap", tg, rijen, "k2", "getal");
    if (D.merk === "Sea-Doo") return vraagScherm("Welke serie?", "Staat op de zijkant", tg, rijen, "k2");
    // Waterscooter: de tegels zijn de handelsnamen van de romp (eindlijst 16 okt), geen codes meer. Sinds 17 okt na de
    // romptegel: 'Welk model precies?', compact (FX heeft er 17).
    if (KB.isWs(D, S)) return vraagScherm("Welk model precies?", "Staat op de romp", tg, rijen, "k2", "namen");
    return vraagScherm("Welk model?", D.merk === "Suzuki" ? "Staat op de kap" : /Waterscooter/.test(S.soort || "") ? "Staat op de romp" : "", tg, rijen, "k2");
  }
}

// Honda-uitvoering: 'LRT – staart lang, bediening afstandsbediening, start elektrisch, trim elektrisch'.
// Per tegel de zichtbare woorden die NIET op alle tegels gelijk zijn; tegels met dezelfde woorden worden
// een tegel (klanttest v2: gelijke tegels, verkeerde gekozen = motor weg).
const HONDA_W = [[/staart XX-lang/i, "staart_xx", "XX-lang"], [/staart extra lang/, "staart_extra", "Extra lang"], [/staart lang/, "staart_lang", "Lang"], [/staart kort/, "staart_kort", "Kort"],
                 [/trim met een gasveer|hydraulisch/, "trim_gasveer", "Met gasveer"], [/\bjet\b/i, "", "Jet"],
                 [/bediening helmstok/, "helmstok", "Helmstok"], [/bediening afstandsbediening/, "afstandsbediening", "Stuurwiel"],
                 [/start trekkoord/, "trekkoord", "Trekkoord"], [/start elektrisch/, "elektrisch", "Sleutel"],
                 [/trim elektrisch/, "trim_elektrisch", "Elektrische trim"], [/trim (met de hand|handmatig)/, "trim_hand", "Zelf optillen"],
                 [/draairichting tegengesteld/, "draai_tegen", "Tegengesteld draaiend"]];
function hondaWoorden(t) {
  const r = String(t).split(" – ")[1] || "";
  const uit = [];
  for (const [re, i, w] of HONDA_W) {
    if (!re.test(r)) continue;
    if (w === "Lang" && /staart (extra|XX-)lang/i.test(r)) continue;
    if (w === "Extra lang" && /staart XX-lang/i.test(r)) continue;
    uit.push([i, w]);
  }
  return uit;
}
function hondaTegels(ids) {
  const per = ids.map(i => ({ i, code: String(D.knoppen2[i].tekst).split(" – ")[0], w: hondaWoorden(D.knoppen2[i].tekst) }));
  const overal = new Set(per[0] ? per[0].w.map(x => x[1]) : []);
  for (const x of per) for (const w of [...overal]) if (!x.w.some(y => y[1] === w)) overal.delete(w);
  const samen = new Map();
  for (const x of per) {
    const w = x.w.filter(y => !overal.has(y[1]));     // leeg = de code staat op de tegel
    const sleutel = w.map(y => y[1]).join(" · ");
    if (!samen.has(sleutel)) samen.set(sleutel, { w, ids: [], codes: [] });
    samen.get(sleutel).ids.push(x.i); samen.get(sleutel).codes.push(x.code);
  }
  return [...samen.entries()].map(([sleutel, g]) => tegel(`data-k2="${g.ids.join(",")}" data-k2tekst="${esc(sleutel || g.codes[0])}"`,
    `<span><span class="woorden">${g.w.length ? g.w.map(([i, w]) => `<span>${ik(i)}${esc(w)}</span>`).join("") : esc(g.codes[0])}</span>` +
    `<small>${esc([...new Set(g.codes)].join(", "))}</small></span>`, "vol")).join("");
}

// ---------------------------------------------------------- 'wat zie je aan je motor?'
function tekenZietVraag(g, rijen) {
  const V = VELDEN[g.veld];
  const ws = V.volgorde ? g.ws.slice().sort((a, b) => V.volgorde.indexOf(a) - V.volgorde.indexOf(b)) : g.ws.slice().sort();
  const tg = ws.map(w => {
    const p = ikoonVoor(g.veld, w);
    return tegel(`data-zie="${g.veld}" data-waarde="${esc(w)}"`, `${p}${tekst(label(g.veld, w), (V.onder || {})[w])}`, p ? "beeld" : "");
  }).join("");
  const kl = KB.klassen(rijen);
  const n = KB.telKaarten(rijen.filter(r => KB.toets(r, S.filters, kl, null) === "zeker"));
  zetTitel(V.vraag + " – Vind je motor");
  app.classList.remove("lijstscherm");
  app.innerHTML = `${navHtml(true)}
    <h2 class="bm-vjm-vraag" tabindex="-1">${esc(V.vraag)}</h2>${V.hint ? `<p class="hint">${esc(V.hint)}</p>` : ""}
    <div class="paneel"><div class="tegels ${ws.length === 4 ? "vier" : ""}">${tg}</div>
    <div class="of">of</div>
    <div class="tegels breed">${tegel(`data-zieniet="${g.veld}"`, `${ik("vraag", "klein")}<span>Weet ik niet</span>`, "weetniet")}</div>
    ${n <= TOON_ALLE_MAX ? `<button class="stil" data-actie="lijst">${toonAlleTekst(rijen.filter(r => KB.toets(r, S.filters, kl, null) === "zeker"), n)}</button>` : ""}</div>`;
}

// ---------------------------------------------------------- lijst
// Eindlijst 16 okt 2026 - een kaart voor alle merken (Dieter: "12 motoren met afkortingen die de klant niks zegt"):
//   regel 1 groot   de naam die de klant op de kap/romp leest (m.kn: 'E-TEC 115 pk H.O.', 'FX Cruiser SVHO',
//                   'GTX 155'); zonder kaartnaam zoals voorheen 'pk · jaren'
//   regel 2         de periode vet, dan wat je ziet als pictogram + woord (alleen wat tussen de kaarten verschilt), en
//                   grijs 'Onbekend: sturen' als we het bij ALLE motoren van de kaart niet weten en een andere kaart wel
//                   (gemengd = niets; 'Standaard uitvoering' nooit; bij een jet nooit de staart)
//   regel 3 klein   de code van het typeplaatje (als het er een is)
//   versies         een per onderdelenlijst (KB.versies): codes met dezelfde onderdelen zijn een keuze; de
//                   waarschijnlijkste bovenaan; in woorden ('Modeljaar 1993 · Tegengesteld draaiend'). Heeft een
//                   versie meer codes (of modeljaren), dan staan die eronder als losse links: de klant tikt zijn eigen
//                   code en opent precies die motor (controle: tekeningtitels/refnummers kunnen per code verschillen).
const jaren = groep => { const j = [...new Set(groep.map(r => r.m.j).filter(Boolean))].sort(); return j.length ? (j.length > 1 ? j[0] + "–" + j[j.length - 1] : String(j[0])) : ""; };
const cap = t => String(t).charAt(0).toUpperCase() + String(t).slice(1);
// Periode van een kaart of versie, ook voor rijen zonder jaar (BRP-lettergroepen: '2013 of later').
function periode(rs) {
  const delen = [];
  const j = jaren(rs); if (j) delen.push(j.replace("–", " – "));
  const later = rs.filter(r => r.m.j == null && r.m.js && !r.m.jl).map(r => r.m.js);
  if (later.length) delen.push(Math.min(...later) + " of later");
  if (rs.some(r => r.m.jl)) delen.push("alle modeljaren");
  return delen.join(" en ");
}

// Kenmerken op de kaart: wat je ziet (in de kaartsleutel) en daarna wat BRP/Sea-Doo-kaarten verder onderscheidt.
const KAART_VELDEN = ["model", "bediening", "start", "staart", "trim", "takt", "draairichting", "uitvoering", "pakket", "kleur", "regio"];
const VERSIE_VELDEN = ["uitvoering", "draairichting", "pakket", "kleur", "regio", "bediening", "start", "staart", "trim", "takt"];
const toonNiet = (v, w) => v === "uitvoering" && w === "standaard";   // 'Standaard uitvoering' zegt de klant niets
const EXTRA_LABEL = {
  draairichting: { tegengesteld: "Tegengesteld draaiend", normaal: "Normaal draaiend" },
  pakket: { "kabel of losse cilinder": "Kabelbesturing", "Dynamic Power Steering (DPS)": "Stuurbekrachtiging",
            "geïntegreerd hydraulisch (IHS)": "Hydraulische besturing" },
  regio: { "North America": "Noord-Amerika", International: "Internationaal", "Latin America": "Latijns-Amerika", Asia: "Azië" },
  staart: { kort: "Korte staart", lang: "Lange staart", "extra lang": "Extra lange staart", "XX-lang": "XX-lange staart" },
};
// Kleuren in het Nederlands (Sea-Doo), woord voor woord; Sea-Doo-uitvoering '18' = lengte in voet.
const KLEUR_NL = { blue: "blauw", yellow: "geel", red: "rood", white: "wit", black: "zwart", grey: "grijs", gray: "grijs",
  green: "groen", orange: "oranje", navy: "marineblauw", mint: "mint", silver: "zilver", teal: "petrol", bright: "helder",
  dark: "donker", light: "licht", dusty: "", sunrise: "", abyss: "diep", ice: "ijs", metal: "metallic", neo: "", lime: "limoen" };
function kaartLabel(v, w) {
  if (v === "kleur") return String(w).split(/\s+/).map(x => KLEUR_NL[x.toLowerCase()] ?? x).filter(Boolean).join(" ") || w;
  if (v === "uitvoering" && D && D.merk === "Sea-Doo" && /^\d+$/.test(w)) return "Lengte " + w + " voet";
  return (EXTRA_LABEL[v] || {})[w] || label(v, w);
}
function versieWoord(v, w) {
  if (v === "regio") return KB.REGIO_HIER.has(w) ? (w === "International" ? "Internationaal" : "Voor Europa") : "Voor " + ((EXTRA_LABEL.regio || {})[w] || w);
  if (v === "kleur") return "Kleur " + kaartLabel(v, w).toLowerCase();
  return cap(kaartLabel(v, w));
}
// De code van het typeplaatje (m.c = code zonder jaarletter, anders de naam) - alleen als het echt een code is.
const codeVan = m => m.c || KB.normNaam(m.n);
const isCode = c => /^[A-Z0-9][A-Z0-9.\-]{2,15}$/i.test(c);
function codesTekst(rs, max = 3) {
  const c = [...new Set(rs.map(r => codeVan(r.m)))];
  if (!c.length || !c.every(isCode)) return "";
  return c.slice(0, max).join(", ") + (c.length > max ? ` +${c.length - max}` : "");
}
// Losse links binnen een versie: per code, of (zelfde code over meer jaren, bv. waterscooters) per modeljaar.
function kiesLinks(v) {
  if (v.length < 2) return null;
  const per = new Map();
  if (v.every(r => isCode(codeVan(r.m)))) for (const r of v) { const c = codeVan(r.m); if (!per.has(c)) per.set(c, r); }
  if (per.size >= 2) return { titel: "Kies je code", items: [...per].sort((a, b) => a[0].localeCompare(b[0], "nl", { numeric: true })) };
  per.clear();
  if (v.every(r => r.m.j != null)) for (const r of v) { const j = String(r.m.j); if (!per.has(j)) per.set(j, r); }
  if (per.size >= 2) return { titel: "Kies je modeljaar", items: [...per].sort((a, b) => Number(a[0]) - Number(b[0])) };
  return null;
}
// Tot KIES_OPEN links staan ze er meteen; meer (Evinrude 40 pk 1991: 13 codes met dezelfde onderdelen) achter
// 'Kies je code (13)', anders wordt de versielijst een muur van codes.
const KIES_OPEN = 6;
function kiesHtml(k) {
  const links = k.items.map(([t, r]) => `<a class="kieslink" href="${esc(motorUrl(r.m))}" data-motor="${r.m.id}">${esc(t)}</a>`).join("");
  return k.items.length <= KIES_OPEN ? `<div class="kies"><span>${esc(k.titel)}</span>${links}</div>`
    : `<details class="kies-meer"><summary>${esc(k.titel)} (${k.items.length})</summary><div class="kies">${links}</div></details>`;
}

// kaartVerschil.woord: velden met twee bekende waarden tussen de kaarten (woord op de kaart);
// kaartVerschil.onbekend: zichtbare velden die de ene kaart bij alle motoren niet weet en een andere wel (grijze regel
// op die ene kaart; het woord 'Tweetakt' op alle andere kaarten zou niets onderscheiden).
function kenmerkenHtml(groep, kaartVerschil, st, kl, titel) {
  const k = KB.gedeeld(groep), uit = [];
  if (titel) { const p = periode(groep); if (p && !titel.includes(p)) uit.push(`<span class="periode">${esc(p)}</span>`); }
  let n = 0;
  for (const v of KAART_VELDEN) {
    if (k[v] == null || toonNiet(v, k[v]) || !kaartVerschil.woord.has(v)) continue;
    if (titel && (v === "model" || titel.toLowerCase().includes(String(k[v]).toLowerCase()))) continue;   // staat al in de titel
    uit.push(`<span>${ikoonVoor(v, k[v])}${esc(v === "regio" ? versieWoord(v, k[v]) : cap(kaartLabel(v, k[v])))}</span>`);   // 'Voor Europa'
    if (++n >= 5) break;
  }
  // 'Onbekend' alleen als het veld bij ALLE motoren van de kaart leeg is (gemengd = niets), nooit de staart van een jet.
  const onb = KB.KAART_ZICHT.filter(v => kaartVerschil.onbekend.has(v) && groep.every(r => r.m.k[v] == null && !KB.nvt(r.m, v)))
    .map(v => VELDEN[v].titel.toLowerCase());
  if (onb.length) uit.push(`<span class="onbekend">Onbekend: ${esc(onb.join(", "))}</span>`);
  if (st === "misschien") {
    // niet bij een jet zijn staart (n.v.t., geen onbekend gegeven)
    const onz = Object.keys(S.filters).filter(v => S.filters[v].size && KB.waarde(groep[0].m, v, kl) === undefined && !KB.nvt(groep[0].m, v))
      .map(v => VELDEN[v] ? VELDEN[v].titel.toLowerCase() : v);
    uit.push(`<span class="onzeker">? Niet zeker${onz.length ? ": " + esc(onz.join(", ")) : ""}</span>`);
  }
  return uit.length ? `<div class="kenm">${uit.join("")}</div>` : "";
}

// Uitleg onder de versies: waar de klant het onderscheid kan vinden (per merk of soort).
function uitlegVoor(vs) {
  const m = vs[0][0].m;
  if ((D.merk === "Mercury" || D.merk === "Suzuki") && vs.some(v => v.some(r => r.m.sn)))
    return ["Waar staat het serienummer?", "Op het typeplaatje aan de klem waarmee de motor aan de boot hangt, en vaak ook op het motorblok."];
  if (D.merk === "Honda") return ["Waar staat het framenummer?", "Op het typeplaatje aan de klem waarmee de motor aan de boot hangt."];
  if (D.merk === "Evinrude" || D.merk === "Johnson") return ["Waar staat de code?", "Op het typeplaatje aan de klem waarmee de motor aan de boot hangt, achter MOD. NO."];
  if ((m.s || []).some(s => /Waterscooter|boot/i.test(s)) || D.merk === "Sea-Doo")
    return ["Waar staat het modeljaar?", "Achterop de romp staat het rompnummer. De laatste twee cijfers zijn het modeljaar."];
  return null;
}

// Sea-Doo-modelnummers uit de catalogusregel ('00023CA00 00023CB00' -> '23CA, 23CB'): die staan op de romp (controle2:
// twee versies van 2012 verschilden alleen in '635 onderdelen' tegenover '650 onderdelen').
function seadooNummers(v) {
  const s = new Set();
  for (const r of v) for (const x of String(r.m.n).match(/\b0[0-9A-Z]{6}00\b/g) || []) if (/[A-Z]/.test(x)) s.add(x.replace(/^0+/, "").replace(/00$/, ""));
  const a = [...s].sort();
  return a.length ? a.slice(0, 4).join(", ") + (a.length > 4 ? ` +${a.length - 4}` : "") : "";
}
// dj = KB.doelJaren: het jaar dat de klant noemde krijgt 'jouw jaar' (controle2: 2016, 2015, 2017 leek willekeurig).
function versieTeksten(vs, metNaam, dj) {
  const jaarVan = v => (v.every(r => r.m.jl) ? "Alle modeljaren" : (periode(v) ? "Modeljaar " + periode(v) : ""));
  const jarenVerschillen = new Set(vs.map(jaarVan)).size > 1;
  const jouw = v => dj && dj.jaar != null && v.some(r => r.m.j === dj.jaar);
  const gd = vs.map(v => KB.gedeeld(v));
  const verborgen = D.verborgen_filters || [];
  const zelfdeCodes = new Set(vs.map(v => codesTekst(v))).size === 1;      // dan staat de code al op de kaart
  const uit = vs.map((v, i) => {
    const m = v[0].m, delen = [], kies = kiesLinks(v);
    if (jarenVerschillen) delen.push(jaarVan(v) + (jouw(v) ? " · jouw jaar" : ""));
    for (const veld of VERSIE_VELDEN) {
      const w = gd[i][veld];
      // alleen als een andere versie een andere BEKENDE waarde heeft ('Standaard uitvoering' tegenover onbekend zegt niets)
      if (w == null || toonNiet(veld, w) || verborgen.includes(veld) || !gd.some((x, j) => j !== i && x[veld] != null && x[veld] !== w)) continue;
      delen.push(versieWoord(veld, w));
    }
    let hoofd = delen.filter(Boolean).join(" · ");
    let codes = metNaam ? (zelfdeCodes || kies ? "" : codesTekst(v)) : (D.merk === "Honda" && !kies ? m.n : "");
    const cs = [...new Set(v.map(r => codeVan(r.m)))];
    if (!hoofd) {
      if (v.length === 1 && m.sn && D.merk !== "Suzuki") hoofd = "Serienummer " + snTekst(m.sn);
      else if (m.k.fabriek && new Set(vs.map(x => x[0].m.k.fabriek)).size > 1) hoofd = "Gebouwd in " + m.k.fabriek;
      else if (cs.every(isCode)) { hoofd = "Code " + cs[0]; codes = ""; }      // alleen het typeplaatje beslist
      else hoofd = toonNaam(m.n);
    }
    const reeksen = D.merk === "Suzuki" ? snReeksen(v) : [], suz = reeksen.length > 0;     // serienummer 17 okt
    const klein = [!suz && !hoofd.startsWith("Serienummer") && v.length === 1 && m.sn ? "Serienummer " + snTekst(m.sn) : "",
                   codes && codes !== hoofd ? codes : "", v.every(r => r.m.nz) ? "Naam niet bevestigd" : "",
                   m.o === 0 ? "Nog geen onderdelen online" : ""].filter(Boolean);
    return { hoofd, klein, codes, m, kies, alleenCode: hoofd.startsWith("Code "), reeksen, v };
  });
  // Twee versies met precies dezelfde tekst: alleen het typeplaatje beslist - dan de code (Sea-Doo: het modelnummer op de
  // romp; anders het aantal onderdelen) erbij.
  uit.forEach((t, i) => {
    if (uit.filter(x => x.hoofd === t.hoofd).length < 2) return;
    // Suzuki met serienummers (17 okt): het nummer eronder laat het verschil zien (gemarkeerd: blok of P), geen '959 onderdelen'
    if (t.reeksen.length) return;
    const cs = [...new Set(vs[i].map(r => codeVan(r.m)))], sd = D.merk === "Sea-Doo" ? seadooNummers(vs[i]) : "";
    if (cs.every(isCode) && !t.hoofd.includes(cs[0])) { t.dubbel = " · code " + cs[0]; t.alleenCode = true; }
    else if (sd) t.dubbel = " · modelnr. " + sd;
    else if (t.m.o) t.dubbel = " · " + t.m.o.toLocaleString("nl") + " onderdelen";
  });
  for (const t of uit) {
    t.basis = t.dubbel ? t.hoofd : "";              // de tekst zonder de code (alle gelijk = alleen de code verschilt)
    if (t.dubbel) {
      t.hoofd += t.dubbel;
      // de code staat dan al vet: niet nog eens klein eronder (controle2: 'code E90DPLSCB' en daaronder 'E90DPLSCB')
      if (t.codes && t.hoofd.includes(t.codes)) t.klein = t.klein.filter(x => x !== t.codes);
    }
    t.klein = t.klein.join(" · ");
  }
  // Verschillen de versies (vaak) alleen in de code, dan zegt de kaart dat (controle2: een muur van codes zonder uitleg).
  // alleenCode: 'alle' | 'vaak' (minstens de helft) | "".
  const nCode = uit.filter(t => t.alleenCode).length;
  const alleenCode = uit.length < 2 || nCode < 2 ? ""
    : nCode === uit.length && new Set(uit.map(t => t.basis)).size === 1 ? "alle" : 2 * nCode >= uit.length ? "vaak" : "";
  return { teksten: uit, perJaar: jarenVerschillen, alleenCode };
}

// dicht: versies achter 'Kies je versie (n)' (bij meer dan 2 kaarten, en altijd onder 'Kan ook de jouwe zijn').
// dj: KB.doelJaren - het jaar dat de klant noemde (als modeljaar), voor de volgorde van de versies.
function kaartHtml(groep, st, kl, kaartVerschil, enige, dicht, dj) {
  const m0 = groep[0].m, metNaam = !!m0.kn;
  const naam = toonNaam(KB.kaartNaam(m0));
  // De naam als titel als hij geen typeplaatjescode is (Mercury '40 pk EFI 4 cil.', Suzuki 'DF 140') of als er geen pk is
  // (trollingmotor, Sea-Doo '3D RFI'); controle2: acht kaarten met dezelfde titel '40 pk' of alleen '2000'.
  const naamTitel = metNaam || !isCode(KB.normNaam(m0.n)) || m0.pk == null;
  const r1 = naamTitel ? naam : [m0.pk != null ? nl(m0.pk) + " pk" : "", jaren(groep)].filter(Boolean).join(" · ");
  const vs = KB.versies(groep, dj);
  const kop0 = `<div class="r1">${esc(r1 || naam)}</div>${kenmerkenHtml(groep, kaartVerschil, st, kl, naamTitel ? naam : "")}`;
  const r3van = codes => (metNaam ? (codes && !naam.includes(codes) ? "Code " + codes : "") : (naamTitel ? "" : (r1 ? naam : "")));
  const pijl = `<span class="rondje">${ik("verder")}</span>`;
  if (vs.length === 1) {
    const v = vs[0], m = v[0].m, kies = kiesLinks(v);
    const r3 = r3van(kies ? "" : codesTekst(v));
    return `<div class="kaart${enige ? " enige" : ""}"><a class="kop" href="${esc(motorUrl(m))}" data-motor="${m.id}">${kop0}${r3 ? `<div class="r3">${esc(r3)}</div>` : ""}
      ${D.merk === "Suzuki" && snReeksen(v).length ? `<div class="r3 sn"><span class="snlabel">Serienummer</span>${snRij(snReeksen(v))}</div>`
        : MH_MERK[D.merk] && mhEen(v) ? `<div class="r3 sn"><span class="snlabel">Serienummer</span>${mhEen(v)}</div>`
        : (m.sn && v.length === 1 ? `<div class="r3">Serienummer ${esc(snTekst(m.sn))}</div>` : "")}</a>
      ${kies ? kiesHtml(kies) : ""}
      <a class="naar" href="${esc(motorUrl(m))}" data-motor="${m.id}">${m.o === 0 ? "Nog geen onderdelen online" : "Bekijk onderdelen"}${pijl}</a></div>`;
  }
  const r3 = r3van(metNaam && new Set(vs.map(v => codesTekst(v))).size === 1 ? codesTekst(groep) : "");
  const kop = kop0 + (r3 ? `<div class="r3">${esc(r3)}</div>` : "");
  const { teksten, alleenCode } = versieTeksten(vs, metNaam, dj);
  const versie = t => `<a class="versie" href="${esc(motorUrl(t.m))}" data-motor="${t.m.id}"><span><b>${esc(t.hoofd)}</b>${t.klein && t.klein.length ? `<small>${esc(t.klein)}</small>` : ""}</span>${pijl}</a>${t.kies ? kiesHtml(t.kies) : ""}`;
  const EERST = 4;
  // Suzuki met serienummers (17 okt): bovenaan het veld en de tip, daaronder de versies; het veld tekent die lijst opnieuw.
  // Waar het nummer staat, zegt de tip (snTipHtml), niet nog eens onderaan. Tip open op de eerste kaart die de klant ziet.
  // Geen kop 'Kies je versie' boven de versies: de regels (jaar + pijl) spreken voor zich, en zo staat de eerste versie op de
  // telefoon in het eerste scherm (Dieter 17 okt: de versielijst zo snel mogelijk in beeld).
  if (D.merk === "Suzuki" && teksten.some(t => t.reeksen.length)) {
    const sl = m0.id, tipOpen = !dicht && !snTipGetoond;
    if (tipOpen) snTipGetoond = true;
    // dj: het jaar dat de klant koos - de tip gaat over de versies van dat jaar (herstel 17 okt)
    SN_KAART.set(sl, { teksten, ids: new Set(groep.map(r => r.m.id)), model: m0.n, mk: snMarkeer(teksten), dj });
    const lijst = `${snZoekHtml(sl, SN_KAART.get(sl), tipOpen)}<div class="versielijst" data-snlijst="${esc(sl)}">${snLijstGewoon(SN_KAART.get(sl))}</div>`;
    return dicht
      ? `<div class="kaart"><div class="kop">${kop}</div><details class="versies"><summary>Kies je versie (${teksten.length})</summary>${lijst}</details></div>`
      : `<div class="kaart${enige ? " enige" : ""}"><div class="kop">${kop}</div>${lijst}</div>`;
  }
  // Mercury en Honda (18 okt, tests/serienummer_mh): net als Suzuki het veld en de tip bovenaan, daaronder de versies met
  // hun korte reeks; geen kop 'Kies je versie' en geen uitleg onderaan. Beslist het nummer niets: zoals altijd.
  const mi = MH_MERK[D.merk] ? mhInfo(groep, teksten, naam) : null;
  if (mi) {
    const sl = m0.id, tipOpen = !dicht && !snTipGetoond;
    if (tipOpen) snTipGetoond = true;
    SN_KAART.set(sl, mi);
    const lijst = `${mhZoekHtml(sl, mi, tipOpen)}<div class="versielijst" data-snlijst="${esc(sl)}">${mhLijstGewoon(mi)}</div>`;
    return dicht
      ? `<div class="kaart"><div class="kop">${kop}</div><details class="versies"><summary>Kies je versie (${teksten.length})</summary>${lijst}</details></div>`
      : `<div class="kaart${enige ? " enige" : ""}"><div class="kop">${kop}</div>${lijst}</div>`;
  }
  const u = uitlegVoor(vs);
  // De hint over het aankoopjaar staat een keer boven de lijst (controle2: tot 18 keer op een lijst). Hier alleen: het
  // verschil staat alleen op het typeplaatje.
  const inhoud = `${alleenCode ? `<p class="versiehint">${alleenCode === "alle" ? "Het verschil staat alleen" : "Vaak staat het verschil alleen"} op het typeplaatje</p>` : ""}
    ${teksten.slice(0, EERST).map(versie).join("")}
    ${teksten.length > EERST ? `<details><summary>Toon alle ${teksten.length} versies</summary>${teksten.slice(EERST).map(versie).join("")}</details>` : ""}
    ${u ? `<details class="uitleg"><summary>${esc(u[0])}</summary><p>${esc(u[1])}</p></details>` : ""}`;
  return dicht
    ? `<div class="kaart"><div class="kop">${kop}</div><details class="versies"><summary>Kies je versie (${teksten.length})</summary>${inhoud}</details></div>`
    : `<div class="kaart${enige ? " enige" : ""}"><div class="kop">${kop}</div><div class="versiekop">Kies je versie</div>${inhoud}</div>`;
}

// ------------------------------------------------------------------ tip: waar zit het serienummer? (17 okt 2026)
// Dieter 17 okt: "geef hem de tip dat hij een serienummer moet zoeken op de motor. met de locatie erbij. misschien een
// afbeelding erbij". Zijn keuze 'Compact, altijd zichtbaar': kleine tekening links, rechts twee korte regels; open zonder
// klikken, ingeklapt tot een regel zodra de klant typt; alleen open op de eerste kaart die hij ziet of openklapt.
//   1 = het plaatje aan de klem (model + voorstuk + volgnummer).
//   2 = als uitweg ('Plaatje weg? Onder de kap'): een rond plaatje op het motorblok met bouwjaar, volgnummer en maand.
// Plekken uit werkplaatshandboeken en instructieboekjes (tests/serienummer_proef/plekken/plekken.json, nagekeken in
// tip_resultaat.json). De tekening is de eigen lijntekening van tests/serienummer_proef/tekening/svg/ (serienummer_groot_*,
// serienummer_draagbaar_sb; lijn 3, ronde uiteinden, currentColor); niets overgenomen uit handleidingen. Gespiegeld
// (voorkant rechts) = wat je aan stuurboord ziet, zodat plek 1 aan de kant van het klemplaatje staat. Plek 2 per blok:
// hoog, midden of laag. Herstel na de controle (17 okt): de kant van plaatje 2 staat in de bron maar bij een paar reeksen.
// Daarom drie tekens: gevuld goud = aan de kant van de tekening (bron), gestippeld = aan de andere kant (DF 90-140 en
// DF 150-200 vanaf 2011: bakboord), open goud rondje = kant niet bekend (de tekst noemt dan alleen het onderdeel ernaast);
// plek niet bekend = gestippelde omtrek van het blok. Cijfers in de rondjes niet gespiegeld en minstens 16 px (tekening
// 100 px breed op de telefoon, 140 px op de computer).
const SN_TEK = {
  groot: { b: 204,
    motor: '<path d="M4 108H50V166L4 157"/><path d="M42 118V105Q42 101 46 101H64Q70 101 70 107V150L62 160H50"/><path d="M70 113.5H80.5M70 146H95.5"/><circle cx="62" cy="108" r="3.5"/><path d="M168 96C168 107 157 113 131 118L126 166H140L150 175L140 184H98A9 9 0 0 1 98 166C99.5 166 100 165 100 163L88 118C79 114 73 107 73 96Z"/><path d="M84 155H148"/><path d="M120 184L126 197H132L131 184"/><path d="M158 158Q172 175.5 158 193Q144 175.5 158 158Z"/><path d="M81 96V67Q81 63 85 63H155Q159 63 159 67V96"/><path d="M89 63V58Q89 55 92 55H128Q131 55 131 58V63"/><path d="M137 63V96"/><path d="M73 42V22C73 12 81 5 93 5H146C159 5 168 13 168 24V42Z"/><path d="M140 15H156"/><path d="M186 86V34M177 43L186 34L195 43"/>',
    klem: [52.5, 115, 11, 19], nr1: [22, 134], nr2: [44, 76],
    blok: { hoog: [98, 72], midden: [98, 80], laag: [98, 89], achter: [98, 75] }, omtrek: [86, 67, 66, 25] },
  draagbaar: { b: 184,
    motor: '<path d="M4 116H52V172L4 164"/><path d="M40 138V116Q40 112 44 112H62Q67 112 67 117V160L60 168H52"/><path d="M67 121H86.4M67 154H93.5"/><path d="M150 100C150 110 141 115 120 119L117 170H128L136 177L128 184H95A7 7 0 0 1 95 170C96 170 96.5 169.5 96.5 168L86 119C80 115 76 109 76 100Z"/><path d="M86 161H136"/><path d="M110 184L114 194H119L118.5 184"/><path d="M143 166Q154 177 143 188Q132 177 143 166Z"/><path d="M79 106L40 99M80 112L40 105"/><path d="M40 97.5L24 95A3.5 3.5 0 0 0 23 102L39 104.5Z"/><path d="M83 100V74Q83 70 87 70H139Q143 70 143 74V100"/><path d="M90 70V65Q90 62 93 62H122Q125 62 125 65V70"/><path d="M128 70V100"/><path d="M76 48V30C76 20 83 13 94 13H132C143 13 150 20 150 30V48Z"/><path d="M101 13V8H125V13"/><path d="M168 90V36M159 45L168 36L177 45"/>',
    klem: [54.5, 134, 9, 16], steel: [92.5, 128, 9, 16], nr1: [22, 152], nr2: [48, 74],
    blok: { hoog: [101, 77], midden: [101, 85], laag: [101, 93], achter: [101, 82] }, omtrek: [88, 74, 36, 23] },
};
// Cijferrondjes iets groter dan in ontwerp d (herstel 17 okt): de tekening is op de telefoon 100 px breed (was 112) zodat de
// eerste versie in het eerste scherm blijft, en het cijfer blijft dan minstens 16 px.
const SN_GOUD = "#BF9645", SN_NAVY = "#000029", SN_R = 22, SN_F = 34;
// soort: groot of draagbaar; stuurboord: gespiegeld; plek2: hoog, midden, laag of blok; stijl: vol, achter (andere kant,
// gestippeld) of open (kant niet bekend); steel: plaatje 1 net achter de klem (DF 2.5).
function snTekening(soort, stuurboord, plek2, stijl, steel) {
  const M = SN_TEK[soort], sx = x => (stuurboord ? M.b - x : x), f = x => +x.toFixed(1);
  const [kx, ky, kw, kh] = steel && M.steel ? M.steel : M.klem;
  let p2, doel2;
  if (plek2 === "blok") {
    const [x, y, w, h] = M.omtrek;
    p2 = `<rect x="${x}" y="${y}" width="${w}" height="${h}" rx="3" stroke-width="2.5" stroke-dasharray="4 3.5"/>`;
    doel2 = [x, y + h / 2, 0];
  } else {
    const [x, y] = (stijl === "achter" && plek2 === "hoog" ? M.blok.achter : M.blok[plek2]) || M.blok.midden;
    const r = stijl === "achter" ? 9 : stijl === "open" ? 6.5 : 5.5;
    p2 = stijl === "achter" ? `<circle cx="${x}" cy="${y}" r="${r}" fill="#fff" stroke-width="2.5" stroke-dasharray="3.2 3"/>`
      : stijl === "open" ? `<circle cx="${x}" cy="${y}" r="${r}" fill="#fff" stroke="${SN_GOUD}" stroke-width="3.5"/>`
      : `<circle cx="${x}" cy="${y}" r="${r}" fill="${SN_GOUD}" stroke-width="2.5"/>`;
    doel2 = [x, y, r];
  }
  const lijn = ([cx, cy], [px, py, pr]) => {        // van de rand van het cijferrondje naar de rand van het plaatje
    const dx = px - cx, dy = py - cy, l = Math.hypot(dx, dy) || 1;
    return `<path d="M${f(sx(cx + dx / l * SN_R))} ${f(cy + dy / l * SN_R)}L${f(sx(px - dx / l * pr))} ${f(py - dy / l * pr)}" stroke="${SN_NAVY}" stroke-width="2.5"/>`;
  };
  const nr = ([cx, cy], n) => `<circle cx="${sx(cx)}" cy="${cy}" r="${SN_R}" fill="${SN_GOUD}" stroke="${SN_NAVY}" stroke-width="2.5"/>`
    + `<text x="${sx(cx)}" y="${f(cy + SN_F * 0.35)}" text-anchor="middle" font-family="Blinker, Arial, sans-serif" font-size="${SN_F}" font-weight="800" fill="${SN_NAVY}" stroke="none">${n}</text>`;
  return `<svg class="snplek" viewBox="0 0 ${M.b} 200" role="img" aria-label="Tekening: plek 1 is het plaatje aan de klem, plek 2 een rond plaatje op het motorblok onder de kap.">`
    + `<g fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"${stuurboord ? ` transform="translate(${M.b} 0) scale(-1 1)"` : ""}>`
    + M.motor + `<rect x="${kx}" y="${ky}" width="${kw}" height="${kh}" rx="1.5" fill="${SN_GOUD}" stroke-width="2.5"/>${p2}</g>`
    + lijn(M.nr1, [kx, ky + kh / 2, 0]) + lijn(M.nr2, doel2) + nr(M.nr1, 1) + nr(M.nr2, 2) + `</svg>`;
}
// Kant van het klemplaatje per motorblok. Stuurboord is de regel; bakboord zeker bij DF 25A/30A (02504, 03003) en volgens de
// handboektekening bij DF 90-140 tot 2010 (andere bronnen zeggen stuurboord: 'meestal'). Niet nagekeken: 02503 (DF 25
// 2010-2014; de DF 25A begint pas in 2015 met 02504), DF 75 (07501) en DF 200A (20002, 20004): 'meestal'.
// In woorden de kant van de boot, niet links/rechts (controle 17 okt: wie in de boot naar de motor kijkt, heeft stuurboord
// links van zich).
const SN_BB = new Set(["02504", "03003"]), SN_BB_MEESTAL = new Set(["09001", "10001", "11501", "14001"]);
const SN_KANT_ONBEKEND = new Set(["02503", "07501", "20002", "20004"]);
const snKant = b => (SN_BB.has(b) ? "bb" : SN_BB_MEESTAL.has(b) ? "bb_meestal" : SN_KANT_ONBEKEND.has(b) ? "?" : "sb");
const SN_KANT_TEKST = { sb: "rechterkant van de boot", bb: "linkerkant van de boot", bb_meestal: "meestal linkerkant van de boot",
                        "?": "meestal rechterkant van de boot" };
const snEen = a => (new Set(a).size === 1 ? a[0] : null);
// Kant voor de getoonde reeksen: alle dezelfde bekende kant = die kant; anders 'meestal' de kant van de meeste.
function snKaartKant(rs) {
  const per = rs.map(s => snKant(s.blok)), een = snEen(per);
  if (een) return een;
  const bb = per.filter(k => k === "bb" || k === "bb_meestal").length;
  return bb > per.length - bb ? "bb_meestal" : "?";
}
// Plek op het blok per motorblok: kort, aan een onderdeel dat de klant herkent, met de hoogte voor de tekening, en de kant
// van plaatje 2 als de bron die geeft: 'bb' = bakboord (DF 90-140: naast de startmotor bovenaan voorin; DF 150-200 vanaf
// 2011: onder de startmotor, waarschijnlijk - de foto toont de startmotor en de ECU, het oliefilter zit achter de
// stuurboordkap; controle 17 okt), 'klem' = de kant van het klemplaatje (DF 25A/30A, nagekeken), 'voor' = voorkant van het
// blok (DF 25/30 tot 2007), null = niet bekend. De tekst noemt bakboord als 'linkerkant van de boot', los van de klem
// (controle 17 okt: 'aan de andere kant dan 1' stuurde de DF 115 van 2001-2010 naar de verkeerde kant).
// Niet in de lijst (DF 25 02503, DF 50/60 05004/06003, DF 75, DF 200A, DF 250AP-350A): 'ergens op het blok' met de
// gestippelde omtrek; ook als de getoonde blokken verschillende plekken hebben.
const SN_BLOKPLEK = [
  [/^0025[12]$/, "halverwege, naast de carburateur", "midden", null],                         // DF 2.5
  [/^00(40[1-3]|60[1-3])$/, "onderaan, naast de brandstofpomp", "laag", null],                // DF 4-6, DF 4A-6A
  [/^(00801|0099[1-5]|0150[1-4]|02002)$/, "laag, vlak boven de onderkap", "laag", null],      // DF 8 t/m DF 20A
  [/^(02501|03001)$/, "hoog aan de voorkant, onder het vliegwiel", "hoog", "voor"],            // DF 25/30 (3 cil.) tot 2007
  [/^02502$/, "laag, vlak boven de onderkap, naast het kastje met stekkers", "laag", null],    // DF 25 2006-2009
  [/^(02504|03003)$/, "laag, naast het oliefilter", "laag", "klem"],                           // DF 25A/30A
  [/^(0400[1-3]|0500[1-3]|0600[12]|07001)$/, "hoog, bij de inlaatbuizen", "hoog", null],       // DF 40-70 tot 2010, DF 40A-60A
  [/^(0700[23]|0900[23])$/, "halverwege, schuin boven het oliefilter", "midden", null],        // DF 70A-90A
  [/^(09001|10001|1150[1-6]|1400[1-5])$/, "hoog naast de startmotor", "hoog", "bb"],           // DF 90-140, DF 100A-140A
  [/^(15001|17501|20001|2250[13]|25001|30001)$/, "halverwege, net boven het oliefilter", "midden", null],   // DF 150/175 tot 2010, V6
  [/^(1500[2-4]|1750[23]|20003)$/, "halverwege, onder de startmotor", "midden", "bb"],         // DF 150-200 vanaf 2011
];
const snBlokPlek = b => SN_BLOKPLEK.find(([re]) => re.test(b)) || null;
// Dekt reeks s het jaar y? (de motor is van dat jaar, of de generatie dekt het jaar: DF 115 2006 = blok 11501)
const snDekt = (s, y) => (s.gen ? s.van <= y && y <= s.tot : s.m.j === y);
// De keuze per kaart (ook voor de controle in tests/serienummer_inbouw): tekening, kant, plek op het blok en of de 6 cijfers
// genoeg zijn (controle 17 okt: alleen als elke jaarcode op de kaart bij een versie hoort, ook de jaren van een generatie).
// Tekening, kant en plek gaan over de reeksen van het jaar dat de klant koos (controle 17 okt: de kaart DF 25 2014-2022
// bevat ook de DF 25 van 2014, en dan wist de klant van 2018 niet meer waar hij moest kijken); geen reeks van dat jaar:
// die van het tijdvak eromheen; zonder jaar de hele kaart.
function snTipKeuze(teksten, dj) {
  const met = teksten.filter(t => t.reeksen.length), alle = met.flatMap(t => t.reeksen);
  let rs = alle;
  if (dj) {
    const a = dj.jaar != null ? alle.filter(s => snDekt(s, dj.jaar)) : [];
    const b = alle.filter(s => { for (let y = Math.max(dj.van, 1950); y <= Math.min(dj.tot, 2100); y++) if (snDekt(s, y)) return true; return false; });
    rs = a.length ? a : b.length ? b : alle;
  }
  const bl = [...new Set(rs.map(s => s.blok))];
  const kant = snKaartKant(rs), stuurboord = !(kant === "bb" || kant === "bb_meestal");
  const pl = snEen(bl.map(snBlokPlek)), draagbaar = bl.every(b => Number(b) <= 2002), k2 = pl ? pl[3] : null;
  const stijl = !pl ? "blok" : k2 === "bb" ? (stuurboord ? "achter" : "vol") : k2 ? "vol" : "open";
  const perJj = new Map();
  met.forEach((t, i) => { for (const s of t.reeksen) for (const jj of s.jjs) { if (!perJj.has(jj)) perJj.set(jj, new Set()); perJj.get(jj).add(i); } });
  return { blokken: bl, draagbaar, steel: bl.every(b => /^0025/.test(b)), kant, stuurboord, stijl,
           plek: pl ? pl[1] + (k2 === "bb" ? ", aan de linkerkant van de boot" : "") : "",
           hoogte: pl ? pl[2] : "blok", genoeg: [...perJj.values()].every(x => x.size === 1) };
}
function snTipHtml(info, id, open) {
  const k = snTipKeuze(info.teksten, info.dj), soort = k.draagbaar ? "draagbaar" : "groot";
  const twee = (k.plek ? "rond plaatje op het blok, " + k.plek + "." : "rond plaatje ergens op het blok.")
    + " Typ de regel met 6 cijfers, niet het jaartal. " + (k.genoeg ? "Die zijn genoeg." : "Die geven je modeljaar.");
  return `<div class="sntip${open ? " open" : ""}" data-tipopen="${open ? 1 : 0}" data-tip="${soort}_${k.stuurboord ? "sb" : "bb"}_${k.hoogte}${k.stijl === "achter" || k.stijl === "open" ? "_" + k.stijl : ""}">
    <button type="button" class="sntip-knop" data-sntip="1" aria-expanded="${open}" aria-controls="${esc(id)}">${ik("vraag")}Waar zit het serienummer?</button>
    <div class="sntip-samen" id="${esc(id)}">${snTekening(soort, k.stuurboord, k.hoogte, k.stijl, k.steel)}<ol>
      <li><span class="snnr" aria-hidden="true">1</span><b>${k.steel ? "Net achter de klem" : "Aan de klem"}</b>, ${esc(SN_KANT_TEKST[k.kant])}.</li>
      <li><span class="snnr" aria-hidden="true">2</span><b>Plaatje weg? Onder de kap:</b> ${esc(twee)}</li>
    </ol></div></div>`;
}
// Tip open op de eerste kaart die de klant ziet (de eerste kaart met open versies) of zelf openklapt; de rest ingeklapt
// (controle 17 okt: wie drie kaarten openklapte, zag drie keer de tekening). Per lijst opnieuw (tekenLijst).
let snTipGetoond = false;

// ------------------------------------------------------------------ versieregels en het serienummerveld
const PIJL = () => `<span class="rondje">${ik("verder")}</span>`;
// o.reeksen: alleen deze reeksen tonen (die passen bij het getypte nummer); o.eigen: de cijfers van de klant erin;
// o.mk: markering van de kaart; o.typ: wat er getypt is (grijs wat niet meer kan); o.volg: gevonden op alleen het volgnummer
// (welk blok is niet bekend: de link gaat naar de versie zelf). Het jaar 20 px vet met de pijl op een regel, de nummers
// eronder naast elkaar; een versie zonder nummer op een kaart met nummers zegt dat.
function versieRij(t, o = {}) {
  const rs = o.reeksen || t.reeksen || [];
  const m = o.reeksen && !o.volg ? o.reeksen[0].m : t.m;          // precies de motor waar het nummer bij hoort
  const href = `href="${esc(motorUrl(m))}" data-motor="${m.id}"`, kies = t.kies && !o.reeksen ? kiesHtml(t.kies) : "";
  const jouw = / · jouw jaar\b/.test(t.hoofd), kop = snKop(t, o.reeksen);
  const sn = rs.length ? snRij(rs, o.eigen, o.typ, o.mk) : `<small>Serienummer onbekend</small>`;
  return `<a class="versie snv${o.cls || ""}" ${href}><span class="vjaar"><b>${esc(kop)}</b>${jouw ? `<span class="jouw">jouw jaar</span>` : ""}</span>`
    + `<span class="vsn">${t.klein ? `<small>${esc(t.klein)}</small>` : ""}${sn}</span>${PIJL()}</a>${kies}`;
}
// Kop van een versie; past het nummer bij een generatie, dan de jaren van die generatie ('Modeljaar 2001 – 2011').
function snKop(t, reeksen) {
  const kop = t.hoofd.replace(/ · jouw jaar\b/, ""), br = (reeksen || []).find(s => s.bereik);
  if (!br) return kop;
  const j = `${br.bereik[0]} – ${br.bereik[1]}`;
  return /^Modeljaar \d{4}( – \d{4})?/.test(kop) ? kop.replace(/^Modeljaar \d{4}( – \d{4})?/, "Modeljaar " + j) : kop + " · modeljaar " + j;
}
// Voorbeeld van de kaart (in het veld en in de meldingen): het eerste voorstuk, een F eerst.
const snVb = info => {
  const s = info.teksten.flatMap(t => t.reeksen).sort((a, b) => (a.letter !== "F") - (b.letter !== "F") || a.blok.localeCompare(b.blok))[0];
  return s.blok + s.letter;
};
function snZoekHtml(sl, info, tipOpen) {
  const vb = info.teksten.find(t => t.reeksen.length).reeksen[0];
  return `<div class="snzoek">
    <label for="sn-${esc(sl)}">Heb je het serienummer?</label>
    <div class="snveld"><input id="sn-${esc(sl)}" data-snkaart="${esc(sl)}" type="text" autocomplete="off" autocorrect="off"
      autocapitalize="characters" spellcheck="false" enterkeyhint="done" placeholder="bv. ${esc(vb.blok + vb.letter)}-${esc(vb.jj)}1234"
      aria-describedby="snh-${esc(sl)}"><button type="button" class="snwis" data-snwis="1" hidden aria-label="Wis het nummer">${ik("kruis")}</button></div>
    <div class="snuitslag" aria-live="polite"></div>
    ${snTipHtml(info, "snh-" + sl, tipOpen)}</div>`;
}
// Zonder (bruikbaar) nummer: de versies zoals altijd, de waarschijnlijkste vier eerst. Tijdens het typen (typ) blijft de
// volgorde staan; een notatie die niet meer kan, wordt grijs. Onderaan wat een Z is (controle 17 okt: met de oude uitleg
// boven de blokjes was die weg, en wie een tweede motor heeft, ziet 20003F naast 20003Z).
function snLijstGewoon(info, typ) {
  const ts = info.teksten, E = 4, rij = t => versieRij(t, { typ, mk: info.mk });
  const z = ts.some(t => t.reeksen.some(s => s.letter === "Z"));
  return ts.slice(0, E).map(rij).join("")
    + (ts.length > E ? `<details><summary>Toon alle ${ts.length} versies</summary>${ts.slice(E).map(rij).join("")}</details>` : "")
    + (z ? `<p class="snz">Z na het blok = tegengesteld draaiend (de tweede motor), F = normaal draaiend.</p>` : "");
}
// Bouwjaar van het ronde plaatje tegenover het modeljaar van de versie (controle 17 okt: '2016' gelezen als modeljaar). Staat
// het modeljaar er al groot bij ('Modeljaar 2017', 'uit 2022'), dan kort.
const snNoot = (t, mj, metJaar) => (t.bouwjaar && mj && String(t.bouwjaar) !== String(mj)
  ? `${t.bouwjaar} is het bouwjaar. Dat hoeft niet je modeljaar te zijn${metJaar ? `: dit nummer hoort bij modeljaar ${mj}` : ""}.` : "");
// Het nummer past: die versie bovenaan (navy = gevonden, goud = naar de onderdelen), de rest dichtgeklapt. De noot over het
// bouwjaar onder de knop (controle 17 okt: zo staat 'Bekijk onderdelen' op de telefoon hoger in beeld).
function snLijstTreffer(info, hits, eigen, volg, noot) {
  const rest = info.teksten.filter(x => !hits.some(h => h.t === x));
  let boven;
  if (hits.length === 1) {
    const h = hits[0], m = volg ? h.t.m : h.s[0].m;
    boven = `<div class="treffer"><p class="tkop">${ik("vink")}<span>Past bij jouw nummer</span></p>
      <p class="tjaar">${esc(snKop(h.t, h.s))}</p>${snRij(h.s, eigen)}
      <a class="naar" href="${esc(motorUrl(m))}" data-motor="${m.id}">${m.o === 0 ? "Nog geen onderdelen online" : "Bekijk onderdelen"}${PIJL()}</a>${noot ? `<p class="tnoot">${esc(noot)}</p>` : ""}</div>`;
  } else boven = `<div class="treffers">${hits.map(h => versieRij(h.t, { cls: " past", reeksen: h.s, eigen, mk: info.mk, volg })).join("")}</div>`;
  return boven + (rest.length ? `<details class="anders"><summary>Andere versies (${rest.length})</summary>${rest.map(t => versieRij(t, { mk: info.mk })).join("")}</details>` : "");
}
// Uitweg zonder typeplaatje (jury 4, controle 17 okt): een foto via WhatsApp, niet het contactformulier (hCaptcha laat
// aanvragen ongemerkt verdwijnen). Het nummer van de WhatsApp-knop op bouwmeesterwatersport.nl.
const WHATSAPP = "https://wa.me/31853334344";
const snFoto = (info, invoer) => `<p class="snfoto">Geen typeplaatje? <a href="${esc(WHATSAPP + "?text=" + encodeURIComponent(
  `Hallo, welke versie is mijn Suzuki ${toonNaam(info.model)}?${invoer ? " Nummer op de motor: " + invoer + "." : ""} Ik stuur een foto van de motor mee.`))}"
  target="_blank" rel="noopener">Stuur ons een foto van de motor via WhatsApp</a></p>`;
// Hoort het nummer bij een andere motor van dit merk? (De klant zit op de verkeerde kaart, of het jaar klopte niet.)
const SN_CACHE = new Map();
const reeksenVan = m => { if (!SN_CACHE.has(m.id)) SN_CACHE.set(m.id, snReeksen([{ m }])); return SN_CACHE.get(m.id); };
function snElders(t, ids) {
  return D.motoren.filter(m => m.sn && !ids.has(m.id) && reeksenVan(m).some(s => snPast(s, t))).sort((a, b) => (b.j || 0) - (a.j || 0));
}
// Alle motorblokken en letters van het merk (11503, 14004, ...; F, Z, P): vijf cijfers die er een zijn, zijn het begin van
// het hele nummer; een andere letter is een leesfout.
let SN_BLOKKEN = null, SN_LETTERS = null, SN_BLOKKEN_VAN = null;
function snBlokkenZet() {
  if (SN_BLOKKEN_VAN === D) return;
  SN_BLOKKEN_VAN = D;
  const rs = D ? D.motoren.filter(m => m.sn).flatMap(m => reeksenVan(m)) : [];
  SN_BLOKKEN = new Set(rs.map(s => s.blok)); SN_LETTERS = new Set(rs.map(s => s.letter));
}
function snBlokken() { if (!D) return new Set(); snBlokkenZet(); return SN_BLOKKEN; }
function snLetters() { if (!D) return new Set(); snBlokkenZet(); return SN_LETTERS; }
const snOf = w => (w.length > 1 ? w.slice(0, -1).join(", ") + " of " + w[w.length - 1] : w[0]);
// Twee (of meer) versies uit hetzelfde jaar: wat staat er voor het volgnummer? Het blok als dat per versie anders is (14003
// of 14004), anders blok en letter (15003F of 15003P); bij meer dan vier mogelijkheden 'typ de code'.
function snWelk(hits, vb) {
  const bl = hits.map(h => new Set(h.s.map(s => s.blok)));
  const los = bl.every((b, i) => bl.every((o, j) => j === i || [...b].every(x => !o.has(x))));
  const w = [...new Set(los ? bl.flatMap(b => [...b]) : hits.flatMap(h => h.s.filter(s => !hits.some(g => g !== h &&
    g.s.some(o => o.blok === s.blok && o.letter === s.letter))).map(s => s.blok + s.letter)))].sort();
  return w.length && w.length <= 4 ? `Staat er op het plaatje aan de klem ${esc(snOf(w))}?` : `Typ ook de code die ervoor staat, zoals ${esc(vb)}.`;
}
// Alleen het volgnummer (zes cijfers, zonder motorblok ervoor): zoek op de jaarcode binnen de kaart (ook de jaren van een
// generatie). Een versie = 'Past bij jouw nummer'; meer versies uit een jaar = vragen naar het blok, met de uitweg zonder
// typeplaatje; meer versies uit verschillende jaren = 'Kies je modeljaar'; de jaarcode staat niet op deze kaart = dezelfde
// motor in een ander jaar, of vragen naar de code ervoor (ook met de uitweg). Nooit 'kennen we niet'. null: het begin is
// een blok van deze kaart (hele nummer zonder letter).
function snVolg(info, t, gewoon, zeg, invoer) {
  const c = t.cijfers, eigen = c.slice(2, 6), jj = c.slice(0, 2), vb = snVb(info);
  const hits = info.teksten.map(x => ({ t: x, s: x.reeksen.filter(s => snVolgPast(s, c)).map(s => snEcht(s, jj)) })).filter(h => h.s.length);
  const mj = hits.length ? snJaarVan(hits[0].s[0], jj) : null;
  const noot = snNoot(t, mj, hits.length === 1 && !snKop(hits[0].t, hits[0].s).includes(String(mj)));
  if (hits.length === 1) return { lijst: snLijstTreffer(info, hits, eigen, true, noot), melding: "" };
  if (hits.length > 1) {
    const jaren = [...new Set(hits.map(h => snJaarVan(h.s[0], jj)))];
    return { lijst: snLijstTreffer(info, hits, eigen, true), melding: zeg((jaren.length === 1
      ? `Er zijn ${hits.length} versies uit ${esc(jaren[0])}. ${snWelk(hits, vb)}` : `Je nummer past bij ${hits.length} versies. Kies je modeljaar.`)
      + (noot && jaren.length === 1 ? " " + esc(noot) : "")) + snFoto(info, invoer) };
  }
  if (info.teksten.some(x => x.reeksen.some(s => snPast(s, t)))) return null;
  const el = D.motoren.filter(m => m.sn && m.n === info.model && !info.ids.has(m.id))
    .map(m => ({ m, s: reeksenVan(m).filter(s => snVolgPast(s, c)).map(s => snEcht(s, jj)) })).filter(x => x.s.length)
    .sort((a, b) => (a.m.j || 0) - (b.m.j || 0));
  if (!el.length) return { lijst: gewoon, melding: zeg(`Typ ook de code die ervoor staat, zoals ${esc(vb)}.`) + snFoto(info, invoer) };
  // dezelfde motor in een ander jaar (DF 115 2013-2021, nummer 24...: DF 115 uit 2022); twee versies in dat jaar = welk blok
  const jaren = [...new Set(el.map(x => snJaarVan(x.s[0], jj)))], toon = el.slice(0, 3);
  const welk = jaren.length === 1 && toon.length > 1 ? " " + snWelk(toon, vb) : "", noot2 = jaren.length === 1 ? snNoot(t, jaren[0]) : "";
  const jaarTekst = x => (x.s.some(s => s.bereik) ? `${x.s.find(s => s.bereik).bereik.join(" – ")}` : x.m.j);
  return { lijst: gewoon, melding: `<div class="elders"><p class="snmelding">Je nummer past bij een ${esc(toonNaam(info.model))}${jaren.length === 1 ? " uit " + esc(jaren[0]) : ""}.${welk}${noot2 ? " " + esc(noot2) : ""}</p>${toon.map(x =>
    `<a class="versie" href="${esc(motorUrl(x.m))}" data-motor="${x.m.id}"><span><b>${esc(toonNaam(x.m.n))} · modeljaar ${esc(jaarTekst(x))}</b>${snRij(x.s, eigen)}</span>${PIJL()}</a>`).join("")}</div>`
    + (toon.length > 1 ? snFoto(info, invoer) : "") };
}
function snUitkomst(info, t, invoer) {
  const zeg = tekst => `<p class="snmelding">${tekst}</p>`, vb = snVb(info);
  // alleen een jaartal (de eerste regel van het ronde plaatje): geen grijze lijst, maar zeggen welke regel (controle 17 okt)
  const jaartal = !!(t.cijfers && t.cijfers.length === 4 && SN_BOUWJAAR.test(t.cijfers) && ![...snBlokken()].some(b => b.startsWith(t.cijfers)));
  const gewoon = snLijstGewoon(info, t.blok && !t.fout && !jaartal ? t : null);
  if (t.leeg) return { lijst: gewoon, melding: "" };
  if ((t.plaatje && !t.cijfers) || jaartal) return { lijst: gewoon, melding: zeg("Typ de regel met 6 cijfers, niet het jaartal.") };
  if (t.fout === "model") return { lijst: gewoon, melding: zeg("Dat is de modelnaam. Het serienummer begint met vijf cijfers.") };
  if (t.fout === "letter") {
    const l = [...new Set(info.teksten.flatMap(x => x.reeksen).filter(s => s.blok === t.blok).map(s => s.letter))].sort();
    return { lijst: gewoon, melding: zeg(`Na ${esc(t.blok)} staat een letter: ${esc(snOf(l.length ? l : [...snLetters()].sort()))}.`) };
  }
  if (t.fout) return { lijst: gewoon, melding: zeg(`Een serienummer begint met vijf cijfers en een letter, zoals ${esc(vb)}.`) };
  if (t.te) return { lijst: gewoon, melding: zeg("Na het streepje staan zes cijfers.") };
  if (t.cijfers.length === 6) { const v = snVolg(info, t, gewoon, zeg, invoer); if (v) return v; }
  // alleen cijfers, nog geen zes: het begin van het blok of van het volgnummer; tot het een bekend blok is niets zeggen
  else if (t.cijfers && !snBlokken().has(t.cijfers)) return { lijst: gewoon, melding: "" };
  if (t.blok.length < 5) return { lijst: gewoon, melding: "" };
  const jj = t.rest.slice(0, 2);
  const hits = info.teksten.map(x => ({ t: x, s: x.reeksen.filter(s => snPast(s, t)).map(s => snEcht(s, jj)) })).filter(h => h.s.length);
  if (hits.length && t.zeker)
    return { lijst: snLijstTreffer(info, hits, t.rest.slice(2, 6)),
             melding: hits.length > 1 ? zeg(`Je nummer past bij ${hits.length} versies. Kies je modeljaar.`) + snFoto(info, invoer) : "" };
  if (hits.length) return { lijst: gewoon, melding: zeg("Typ het hele nummer.") };
  const el = snElders(t, info.ids);
  // ook hier de uitweg (controle 17 okt: 'kennen we niet' zonder uitweg liet de klant met lege handen staan)
  if (!el.length) return { lijst: gewoon, melding: zeg("Dit nummer kennen we niet. Klopt elk cijfer?") + snFoto(info, invoer) };
  if (!t.zeker) {
    const namen = [...new Set(el.map(m => toonNaam(m.n)))];
    return { lijst: gewoon, melding: zeg(`Dit nummer hoort bij een ${esc(namen.slice(0, 2).join(" of een "))}, niet bij deze motor.`) };
  }
  const jaarTekst = m => { const s = reeksenVan(m).map(x => snEcht(x, jj)).find(x => x.bereik && snPast(x, t)); return s ? s.bereik.join(" – ") : m.j; };
  return { lijst: gewoon, melding: `<div class="elders"><p class="snmelding">Dit nummer hoort bij een andere motor</p>${el.slice(0, 3).map(m =>
    `<a class="versie" href="${esc(motorUrl(m))}" data-motor="${m.id}"><span><b>${esc(toonNaam(m.n))}</b><small>Modeljaar ${esc(jaarTekst(m))}</small></span>${PIJL()}</a>`).join("")}</div>` };
}
function snTipZet(tip, open) {
  tip.classList.toggle("open", open);
  const k = tip.querySelector(".sntip-knop"); if (k) k.setAttribute("aria-expanded", String(open));
}
function snWerkBij(inp) {
  const info = SN_KAART.get(inp.dataset.snkaart), zoek = inp.closest(".snzoek"), kaart = inp.closest(".kaart");
  if (!info || !zoek || !kaart) return;
  SN_INVOER.set(inp.dataset.snkaart, inp.value);
  zoek.querySelector(".snwis").hidden = !inp.value;
  // De tip klapt alleen bij de overgang leeg <-> gevuld in of uit (wie hem tijdens het typen zelf opent, houdt hem open).
  const tip = zoek.querySelector(".sntip"), leeg = String(!inp.value);
  if (tip && zoek.dataset.leeg !== leeg) { snTipZet(tip, !inp.value && tip.dataset.tipopen === "1"); zoek.dataset.leeg = leeg; }
  const u = info.mh ? mhUitkomst(info, inp.value.trim()) : snUitkomst(info, snLees(inp.value), inp.value.trim());   // Mercury/Honda 18 okt
  if (info.mh) zoek.classList.toggle("gevonden", !!u.gevonden);    // Mercury/Honda: nummer gevonden = tip weg
  zoek.querySelector(".snuitslag").innerHTML = u.melding;
  kaart.querySelector("[data-snlijst]").innerHTML = u.lijst;
}
document.addEventListener("input", e => { if (e.target.matches && e.target.matches(".bm-vjm input[data-snkaart]")) snWerkBij(e.target); });
document.addEventListener("click", e => {
  if (!e.target.closest) return;
  const k = e.target.closest(".bm-vjm [data-sntip]");
  if (k) {                                              // 'Waar zit het serienummer?': de tip weer open
    const tip = k.closest(".sntip"), inp = k.closest(".snzoek").querySelector("input");
    snTipZet(tip, true); if (inp && !inp.value) tip.dataset.tipopen = "1";
    return;
  }
  const b = e.target.closest(".bm-vjm [data-snwis]"); if (!b) return;
  const inp = b.closest(".snzoek").querySelector("input"); inp.value = ""; snWerkBij(inp); inp.focus();
});
// Een kaart met dichte versies die de klant openklapt: de tip open als hij er op deze lijst nog geen open zag.
document.addEventListener("toggle", e => {
  const d = e.target;
  if (!d.matches || !d.matches(".bm-vjm details.versies") || !d.open || snTipGetoond) return;
  const tip = d.querySelector(".sntip"), inp = d.querySelector("input[data-snkaart]");
  if (!tip || (inp && inp.value)) return;
  snTipZet(tip, true); tip.dataset.tipopen = "1"; snTipGetoond = true;
}, true);
// Na opnieuw tekenen (filter, terug): het getypte nummer blijft staan.
function snHerstel() {
  for (const inp of app.querySelectorAll("input[data-snkaart]")) {
    const w = SN_INVOER.get(inp.dataset.snkaart); if (!w) continue;
    inp.value = w; snWerkBij(inp);
    const d = inp.closest("details.versies"); if (d) d.open = true;
  }
}

// Tekeningen Mercury en Honda (18 okt 2026; gemaakt door tests/serienummer_mh/maak_tek_mh.py uit de eigen proeftekeningen
// van 17 okt, tests/serienummer_proef/mercury|honda/tekening/svg). [viewBox, spiegel (breedte of 0), lijf, gouden plaatjes,
// cijfers [cx, cy, doel-x, doel-y, n]]; de rondjes tekent mhTekening.
const MH_LIJF = [
  '<path d="M4 116H52V172L4 164"/><path d="M40 138V116Q40 112 44 112H62Q67 112 67 117V160L60 168H52"/><path d="M67 121H86.4M67 154H93.5"/><path d="M150 100C150 110 141 115 120 119L117 170H128L136 177L128 184H95A7 7 0 0 1 95 170C96 170 96.5 169.5 96.5 168L86 119C80 115 76 109 76 100Z"/><path d="M86 161H136"/><path d="M110 184L114 194H119L118.5 184"/><path d="M143 166Q154 177 143 188Q132 177 143 166Z"/><path d="M79 106L40 99M80 112L40 105"/><path d="M40 97.5L24 95A3.5 3.5 0 0 0 23 102L39 104.5Z"/><path d="M83 100V74Q83 70 87 70H139Q143 70 143 74V100"/><path d="M90 70V65Q90 62 93 62H122Q125 62 125 65V70"/><path d="M128 70V100"/><path d="M76 48V30C76 20 83 13 94 13H132C143 13 150 20 150 30V48Z"/><path d="M101 13V8H125V13"/><path d="M168 90V36M159 45L168 36L177 45"/>',
  '<path d="M4 116H52V172L4 164"/><path d="M40 138V116Q40 112 44 112H62Q67 112 67 117V160L60 168H52"/><path d="M67 121H86.4M67 154H93.5"/><path d="M150 100C150 110 141 115 120 119L117 170H128L136 177L128 184H95A7 7 0 0 1 95 170C96 170 96.5 169.5 96.5 168L86 119C80 115 76 109 76 100Z"/><path d="M86 161H136"/><path d="M110 184L114 194H119L118.5 184"/><path d="M143 166Q154 177 143 188Q132 177 143 166Z"/><path d="M79 106L40 99M80 112L40 105"/><path d="M40 97.5L24 95A3.5 3.5 0 0 0 23 102L39 104.5Z"/><path d="M76 100V82C76 72 83 65 94 65H132C143 65 150 72 150 82V100"/><path d="M101 65V60H125V65"/>',
  '<path d="M4 108H50V166L4 157"/><path d="M42 118V105Q42 101 46 101H64Q70 101 70 107V150L62 160H50"/><path d="M70 113.5H80.5M70 146H95.5"/><circle cx="62" cy="108" r="3.5"/><path d="M168 96C168 107 157 113 131 118L126 166H140L150 175L140 184H98A9 9 0 0 1 98 166C99.5 166 100 165 100 163L88 118C79 114 73 107 73 96Z"/><path d="M84 155H148"/><path d="M120 184L126 197H132L131 184"/><path d="M158 158Q172 175.5 158 193Q144 175.5 158 158Z"/><path d="M81 96V67Q81 63 85 63H155Q159 63 159 67V96"/><path d="M89 63V58Q89 55 92 55H128Q131 55 131 58V63"/><path d="M137 63V96"/><path d="M73 42V22C73 12 81 5 93 5H146C159 5 168 13 168 24V42Z"/><path d="M140 15H156"/><path d="M184 86V34M175 43L184 34L193 43"/>',
  '<path d="M4 108H50V166L4 157"/><path d="M42 118V105Q42 101 46 101H64Q70 101 70 107V150L62 160H50"/><path d="M70 113.5H80.5M70 146H95.5"/><circle cx="62" cy="108" r="3.5"/><path d="M168 96C168 107 157 113 131 118L126 166H140L150 175L140 184H98A9 9 0 0 1 98 166C99.5 166 100 165 100 163L88 118C79 114 73 107 73 96Z"/><path d="M84 155H148"/><path d="M120 184L126 197H132L131 184"/><path d="M158 158Q172 175.5 158 193Q144 175.5 158 158Z"/><path d="M73 96V66C73 54 81 47 93 47H146C159 47 168 55 168 66V96"/><path d="M140 57H156"/>',
  '<path d="M4 116H52V172L4 164"/><path d="M40 138V116Q40 112 44 112H62Q67 112 67 117V160L60 168H52"/><path d="M67 121H86.4M67 154H93.5"/><path d="M150 100C150 110 141 115 120 119L117 170H128L136 177L128 184H95A7 7 0 0 1 95 170C96 170 96.5 169.5 96.5 168L86 119C80 115 76 109 76 100Z"/><path d="M86 161H136"/><path d="M110 184L114 194H119L118.5 184"/><path d="M143 166Q154 177 143 188Q132 177 143 166Z"/><path d="M77 94L48 85M78 100L48 91"/><path d="M48 83.5L34 79.5A3.5 3.5 0 0 0 32.5 86.5L47 90.5Z"/><path d="M83 100V74Q83 70 87 70H139Q143 70 143 74V100"/><path d="M90 70V65Q90 62 93 62H122Q125 62 125 65V70"/><path d="M128 70V100"/><path d="M76 48V30C76 20 83 13 94 13H132C143 13 150 20 150 30V48Z"/><path d="M101 13V8H125V13"/><path d="M161 90V36M152 45L161 36L170 45"/>',
  '<path d="M4 116H52V172L4 164"/><path d="M40 138V116Q40 112 44 112H62Q67 112 67 117V160L60 168H52"/><path d="M67 121H86.4M67 154H93.5"/><path d="M150 100C150 110 141 115 120 119L117 170H128L136 177L128 184H95A7 7 0 0 1 95 170C96 170 96.5 169.5 96.5 168L86 119C80 115 76 109 76 100Z"/><path d="M86 161H136"/><path d="M110 184L114 194H119L118.5 184"/><path d="M143 166Q154 177 143 188Q132 177 143 166Z"/><path d="M77 94L48 85M78 100L48 91"/><path d="M48 83.5L34 79.5A3.5 3.5 0 0 0 32.5 86.5L47 90.5Z"/><path d="M76 100V82C76 72 83 65 94 65H132C143 65 150 72 150 82V100"/><path d="M101 65V60H125V65"/>',
  '<path d="M10 34V118H198"/><path d="M80 92H70Q66 92 66 96V106Q66 110 70 110H80"/><path d="M68 106L46 126"/><path d="M40 118Q31 130 40 142Q49 130 40 118Z"/><path d="M16 118V144H24V118"/><path d="M94 60H87Q80 60 80 67V103Q80 110 87 110H94Z"/><path d="M94 70H170Q174 70 174 74V106Q174 110 170 110H94"/><path d="M102 70V62Q102 58 106 58H162Q166 58 166 62V70"/><path d="M118 58V52Q118 42 128 42H142Q152 42 152 52V58"/><path d="M104 78H164"/><path d="M94 96H114A5 5 0 0 1 114 106H94"/><circle cx="183" cy="80" r="7"/><circle cx="181" cy="101" r="4.5"/>',
  '<path d="M58 34V118H198"/><path d="M58 56H53Q49 56 49 60V82Q49 86 53 86H58"/><path d="M49 61C44 52 30 51 25 59C23 63 23 68 24 72L29 120H42L46 86"/><path d="M18 120H50"/><path d="M30 120V126M41 120V126"/><path d="M24 126H41A6.5 6.5 0 0 1 41 139H24"/><path d="M31 139L34 149H39L39 139"/><path d="M17 118Q8 132.5 17 147Q26 132.5 17 118Z"/><path d="M80 60H73Q66 60 66 67V103Q66 110 73 110H80Z"/><path d="M80 70H156Q160 70 160 74V106Q160 110 156 110H80"/><path d="M88 70V62Q88 58 92 58H148Q152 58 152 62V70"/><path d="M104 58V52Q104 42 114 42H128Q138 42 138 52V58"/><path d="M90 78H150"/><path d="M80 96H100A5 5 0 0 1 100 106H80"/><circle cx="169" cy="80" r="7"/><circle cx="167" cy="101" r="4.5"/>',
  '<path d="M50 112H96V30"/><path d="M96 50H102Q106 50 106 54V80Q106 84 102 84H96"/><path d="M106 55L134 48C143 46 150 52 149 61L146 76L139 126H121L113 84H106"/><path d="M133 48.5C137 56 137 67 135 76H146"/><path d="M110 126H152"/><path d="M124 126V132M137 126V132"/><path d="M146 132H126A7 7 0 0 0 126 146H146"/><path d="M131 146L134 157H139L141 146"/><path d="M153 124Q163 139 153 154Q143 139 153 124Z"/>',
  '<path d="M8 30V100H66M114 100H190"/><path d="M66 100V91Q66 87 70 87H110Q114 87 114 91V100"/><path d="M72 87V60Q72 56 76 56H104Q108 56 108 60V87"/><path d="M76 100L80 124M104 100L100 124"/><path d="M60 124H104A8 8 0 0 1 104 140H60Z"/><path d="M84 140L88 152H94L95 140"/><path d="M53 118Q44 132 53 146Q62 132 53 118Z"/><path d="M41 120Q33 132 41 144Q49 132 41 120Z"/><path d="M108 70H128"/><path d="M128 100V54Q128 50 132 50H180Q184 50 184 54V100"/><path d="M136 50V44Q136 40 140 40H172Q176 40 176 44V50"/>',
  '<path d="M80 96H28L38 128H93"/><path d="M120 96H172L162 128H107"/><path d="M71 62V36C71 26 79 19 90 19H110C121 19 129 26 129 36V62Z"/><path d="M90 19V12.5H110V19"/><path d="M72.5 62C73.5 72 83 77 93 80M127.5 62C126.5 72 117 77 107 80"/><path d="M93 80V138M107 80V138"/><path d="M77 138H123"/><path d="M94.5 138L96 146M105.5 138L104 146"/><circle cx="100" cy="152" r="5.5"/><path d="M102.9 156.7C109.9 164.4 106.3 172.0 100.0 174.0C93.7 172.0 90.1 164.4 97.1 156.7"/><path d="M94.5 152.1C84.3 154.4 79.5 147.5 80.9 141.0C85.8 136.5 94.2 137.3 97.4 147.2"/><path d="M102.6 147.2C105.8 137.3 114.2 136.5 119.1 141.0C120.5 147.5 115.7 154.4 105.5 152.1"/><path d="M81 78V108Q81 112 85 112H93"/><path d="M119 78V108Q119 112 115 112H107"/>',
  '<path d="M76 90H24L36 126H90"/><path d="M124 90H176L164 126H110"/><path d="M64 58V30C64 16 74 8 88 8H112C126 8 136 16 136 30V58Z"/><path d="M92 19H108"/><path d="M66 58C67 70 78 76 90 80M134 58C133 70 122 76 110 80"/><path d="M90 80V136M110 80V136"/><path d="M68 136H132"/><path d="M92 136L94.5 146M108 136L105.5 146"/><circle cx="100" cy="153" r="6.5"/><path d="M103.4 158.5C111.9 168.0 107.7 178.0 100.0 180.0C92.3 178.0 88.1 168.0 96.6 158.5"/><path d="M93.5 153.2C81.1 155.8 74.5 147.1 76.6 139.5C82.2 133.9 93.0 135.2 96.9 147.3"/><path d="M103.1 147.3C107.0 135.2 117.8 133.9 123.4 139.5C125.5 147.1 118.9 155.8 106.5 153.2"/><path d="M77 74V105Q77 109 81 109H90"/><path d="M123 74V105Q123 109 119 109H110"/>',
];
const MH_TEK = {
  merc_bb_draagbaar_klem_blok_sb: ["0 0 182 200", 182, 0, '<rect x="54.5" y="134" width="9" height="16" rx="1.5" fill="#BF9645" stroke-width="2.5"/><circle cx="100" cy="92" r="5.5" fill="#BF9645" stroke-width="2.5"/>', [[160, 152, 127.5, 145, 1], [130, 72, 87, 89, 2]]],
  merc_bb_draagbaar_klem_sb: ["0 54 156 146", 156, 1, '<rect x="54.5" y="134" width="9" height="16" rx="1.5" fill="#BF9645" stroke-width="2.5"/>', [[134, 152, 101.5, 145, 1]]],
  merc_bb_groot_klem_blok_sb: ["0 0 196 200", 196, 2, '<rect x="52.5" y="115" width="11" height="19" rx="1.5" fill="#BF9645" stroke-width="2.5"/><circle cx="112" cy="88" r="5.5" fill="#BF9645" stroke-width="2.5"/>', [[172, 131, 143.5, 126, 1], [154, 78, 89.5, 87.5, 2]]],
  merc_bb_groot_klem_sb: ["0 42 172 158", 172, 3, '<rect x="52.5" y="115" width="11" height="19" rx="1.5" fill="#BF9645" stroke-width="2.5"/>', [[148, 131, 119.5, 126, 1]]],
  merc_bb_klein_beugel_blok_sb: ["-26 0 198 200", 146, 4, '<rect x="45" y="104.5" width="17" height="5.5" rx="1.5" fill="#BF9645" stroke-width="2.5"/><circle cx="100" cy="92" r="5.5" fill="#BF9645" stroke-width="2.5"/>', [[154, 98, 101.5, 107, 1], [94, 64, 50.7, 89.3, 2]]],
  merc_bb_klein_beugel_sb: ["-30 54 186 146", 126, 5, '<rect x="45" y="104.5" width="17" height="5.5" rx="1.5" fill="#BF9645" stroke-width="2.5"/>', [[134, 98, 81.5, 107, 1]]],
  merc_mercruiser_motor_binnen_sb: ["6 12 194 148", 0, 6, '<rect x="125" y="45.5" width="20" height="8" rx="1.5" fill="#BF9645" stroke-width="2.5"/><rect x="122" y="96" width="13" height="10" rx="1.5" fill="#BF9645" stroke-width="2.5"/>', [[182, 30, 145, 47.5, 1], [128.5, 142, 128.5, 106, 2]]],
  merc_mercruiser_motor_hek_sb: ["4 12 194 148", 0, 7, '<rect x="111" y="45.5" width="20" height="8" rx="1.5" fill="#BF9645" stroke-width="2.5"/><rect x="108" y="96" width="13" height="10" rx="1.5" fill="#BF9645" stroke-width="2.5"/>', [[178, 32, 131, 47.5, 1], [114.5, 142, 114.5, 106, 2]]],
  merc_mercruiser_spiegelplaat_bb: ["44 9 156 157", 0, 8, '<rect x="96.5" y="44.5" width="9.5" height="5.5" rx="1.5" fill="#BF9645" stroke-width="2.5"/><circle cx="101" cy="72" r="4" fill="#BF9645" stroke-width="2.5"/>', [[122, 27, 103, 44.5, 1], [70, 72, 96.5, 72, 2]]],
  merc_mercruiser_staartstuk_bb: ["44 9 156 157", 0, 8, '<rect x="119" y="90" width="17" height="12" rx="1.5" fill="#BF9645" stroke-width="2.5"/><circle cx="141.5" cy="62" r="4.5" fill="#BF9645" stroke-width="2.5"/>', [[76, 138, 119.5, 101, 1], [180, 38, 146.5, 59.5, 2]]],
  merc_zeus_sb: ["2 16 188 144", 0, 9, '<rect x="86" y="90.5" width="17" height="7" rx="1.5" fill="#BF9645" stroke-width="2.5"/><rect x="80" y="64" width="19" height="11" rx="1.5" fill="#BF9645" stroke-width="2.5"/>', [[152, 126, 103, 95, 1], [36, 40, 80, 66, 2]]],
  honda_draagbaar_bb: ["25 8 150 168", 0, 10, '<rect x="76" y="86" width="10" height="18" rx="1.5" fill="#BF9645" stroke-width="2.5"/>', [[44, 64, 76, 87.5, 1]]],
  honda_draagbaar_beide: ["25 8 150 168", 0, 10, '<rect x="76" y="86" width="10" height="18" rx="1.5" fill="#BF9645" stroke-width="2.5"/><rect x="114" y="86" width="10" height="18" rx="1.5" fill="#BF9645" stroke-width="2.5"/>', [[44, 64, 76, 87.5, 1], [156, 64, 124, 87.5, 1]]],
  honda_draagbaar_boven: ["0 52 160 148", 0, 1, '<rect x="66" y="111.5" width="15" height="7" rx="1.5" fill="#BF9645" stroke-width="2.5"/>', [[40, 77, 69, 111, 1]]],
  honda_draagbaar_boven_of_bb: ["0 52 160 148", 0, 1, '<rect x="66" y="111.5" width="15" height="7" rx="1.5" fill="#BF9645" stroke-width="2.5"/><rect x="54.5" y="134" width="9" height="16" rx="1.5" fill="#BF9645" stroke-width="2.5"/>', [[40, 77, 69, 111, 1], [22, 152, 54.5, 145, 1]]],
  honda_draagbaar_sb: ["25 8 150 168", 0, 10, '<rect x="114" y="86" width="10" height="18" rx="1.5" fill="#BF9645" stroke-width="2.5"/>', [[156, 64, 124, 87.5, 1]]],
  honda_groot_bb: ["21 4 158 180", 0, 11, '<rect x="72" y="82" width="10" height="19" rx="1.5" fill="#BF9645" stroke-width="2.5"/>', [[40, 58, 72, 83.5, 1]]],
  honda_groot_beide: ["21 4 158 180", 0, 11, '<rect x="72" y="82" width="10" height="19" rx="1.5" fill="#BF9645" stroke-width="2.5"/><rect x="118" y="82" width="10" height="19" rx="1.5" fill="#BF9645" stroke-width="2.5"/>', [[40, 58, 72, 83.5, 1], [160, 58, 128, 83.5, 1]]],
  honda_groot_sb: ["21 4 158 180", 0, 11, '<rect x="118" y="82" width="10" height="19" rx="1.5" fill="#BF9645" stroke-width="2.5"/>', [[160, 58, 128, 83.5, 1]]],
};

// ------------------------------------------------------------------ serienummer Mercury en Honda (18 okt 2026)
// Dieter vond de lange reeksen bij 'Kies je versie' bij alle merken onduidelijk. Zelfde aanpak als Suzuki (veld 'Heb je het
// serienummer?', de passende versie bovenaan in navy, per versie het nummer kort, tip met een eigen tekening en een
// WhatsApp-uitweg), met de koppelregels uit het onderzoek (tests/serienummer_proef/mercury_honda_resultaat.json; proefcode
// mercury/mercury_sn.js en honda/honda_serienummer.js, hier overgenomen als MC en HO). Inbouw: tests/serienummer_mh.
//   Mercury: een cijfer, een letter en 6 cijfers (1B227000; oud: alleen cijfers, Mariner van Yamaha: 6E9-100101). De letter
//     is de reeks, het cijfer telt door (0R999999 -> 1R000000). Per versie kort: 't/m 1B226999', '1B227000 t/m 1B417701',
//     'vanaf 1C453840' (cijfer + letter vet). Een modelnummer (1F15201HD) geeft een melding.
//   Honda: het framenummer van het plaatje aan de klem, vier letters en zeven cijfers (BALJ-1512345). Per versie kort:
//     'BALJ-14 _ _ _ _ _'; een open einde loopt tot het volgende begin met dezelfde letters (begrensd einde).
const MH_MERK = { Mercury: true, Honda: true };

// ---- Mercury: getypt nummer en reeksen (mercury_sn.js, 17 okt; getoetst op 57.356 invoeren zonder misser)
const MC = (function () {
  const ONEINDIG = Number.POSITIVE_INFINITY, BLOK = 1000000;
  function schoon(tekst) {
    let s = String(tekst || "").toUpperCase().trim()
      .replace(/^(SERIENUMMER|SERIAL\s*(?:NUMBER|NO\.?)|SER\.?\s*NO\.?|SERIAL|S\s*\/\s*N|SN|NR\.?|NO\.?)\s*[:.#-]?\s+/, "");   // 18 okt: ook 'Ser. No.'
    s = s.replace(/[\s\-‐-―.\/_:,;#]/g, "");
    s = s.replace(/^(SERIENUMMER|SERIALNUMBER|SERIALNO|SERIAL|SERNO|SERNR|SER|SNR|SN|NR|NO)(?=[0-9OI])/, "");
    const m = /^([0-9OI])([A-Z])([0-9OI]*)$/.exec(s);
    if (m && !(m[1] === "O" && m[2] === "I")) s = m[1].replace("O", "0").replace("I", "1") + m[2] + m[3].replace(/O/g, "0").replace(/I/g, "1");
    else if (/^[0-9OI]+$/.test(s) && /[0-9]/.test(s)) s = s.replace(/O/g, "0").replace(/I/g, "1");
    return s;
  }
  function lees(tekst) {
    const s = schoon(tekst);
    if (!s) return { s, leeg: true };
    const t = { s, mc: null, num: null };
    const m = /^(\d)([A-Z])(\d{0,6})$/.exec(s);
    if (m) t.mc = { d: +m[1], L: m[2], cijfers: m[3], compleet: m[3].length === 6 };
    if (/^\d{1,8}$/.test(s)) t.num = parseInt(s, 10);
    // het modelnummer van dezelfde sticker (1F15201HD): 9 tekens met letters achteraan
    t.modelnummer = !t.mc && /^\d[0-9A-Z]{7,9}$/.test(s) && /[A-Z]{1,3}$/.test(s) && /\d{3}/.test(s);
    // 18 okt (controle): cijfer + letter + meer dan 6 cijfers = een cijfer te veel (gaf geen melding; alles werd grijs).
    // Niet bij een Mariner-voorstuk zoals 6E9-100101 (dat streepje staat na 3-4 tekens); koppel kijkt ook of het ergens past.
    t.teLang = /^\d[A-Z]\d{7,}$/.test(s) && !/^\s*[0-9A-Z]{3,4}\s*[-‐-―]/.test(String(tekst || "").toUpperCase());
    return t;
  }
  function grens(ruw, erf) {
    let t = String(ruw || "").trim().toUpperCase();
    const uit = { ruw: String(ruw || "").trim(), raar: [] };
    if (!t) return null;
    if (t === "ALL") return Object.assign(uit, { all: true });
    if (/^9{10,}$/.test(t)) return Object.assign(uit, { open: true });
    if (/^0\s+\d[A-Z]\d{6}$/.test(t)) { uit.raar.push("losse 0"); t = t.replace(/^0\s+/, ""); }
    t = t.replace(/\s+/g, "");
    let m = /^([0-9O])([A-Z])(\d{6,7})$/.exec(t);
    if (m) {
      const d = m[1] === "O" ? 0 : +m[1];
      let lo = +m[3], hi = +m[3];
      if (m[3].length === 7) {                         // 1A0019999: een cijfer te veel - de ruimste lezing
        const lez = [...m[3]].map((_, i) => +(m[3].slice(0, i) + m[3].slice(i + 1)));
        lo = Math.min(...lez); hi = Math.max(...lez);
      }
      return Object.assign(uit, { soort: "mc", k: m[2], d, p: d * BLOK + lo, pHi: d * BLOK + hi, g: [1, d, m[2].charCodeAt(0), lo] });
    }
    if (/^\d{1,9}$/.test(t)) {
      if (erf && erf.pre && t.length === 6) return Object.assign(uit, { soort: "pre", k: erf.k, pre: erf.pre, p: +t });
      const v = parseInt(t, 10);
      return Object.assign(uit, { soort: "num", k: numBlok(v), p: v, g: [0, v] });
    }
    if (erf && erf.pre) {                              // 6F5325148 achter 6F5-301827
      const v = erf.pre.find(x => t.startsWith(x) && /^\d{6,7}$/.test(t.slice(x.length)));
      if (v) return Object.assign(uit, { soort: "pre", k: erf.k, pre: erf.pre, p: +t.slice(v.length).slice(0, 6) });
    }
    if (t.includes("-") || t.includes(".")) {          // 6E9-100101, 680K-300302, E-676-B100461, 225.591500
      const delen = t.split(/[-.]/), laatste = delen.pop(), lm = /^([A-Z]*)(\d+)$/.exec(laatste);
      if (lm) {
        const model = delen.length ? delen[delen.length - 1] : "", k = model + lm[1], pre = [];
        for (let i = 0; i < delen.length; i++) pre.push(delen.slice(i).join("") + lm[1]);
        if (lm[1]) pre.push(lm[1]);
        if (!pre.includes(k)) pre.push(k);
        return Object.assign(uit, { soort: "pre", k, pre: [...new Set(pre)].sort((a, b) => b.length - a.length), p: +lm[2] });
      }
    }
    m = /^([A-Z]{1,4})(\d{5,8})$/.exec(t);             // CEZ000201, F1429422, A266251 (diesel, trolling)
    if (m) return Object.assign(uit, { soort: "pre", k: m[1], pre: [m[1]], p: +m[2] });
    return Object.assign(uit, { soort: "onbekend" });  // 1991E t/m 1992C (Force)
  }
  // Oude nummers van alleen cijfers: het miljoen zegt de fabriek (VS onder 7 miljoen, 7 Canada, 8 Australie, 9 Belgie).
  const NUM_BLOK = [["#VS", 0, 6999999], ["#CA", 7e6, 7999999], ["#AU", 8e6, 8999999], ["#BE", 9e6, 9999999], ["#8", 1e7, ONEINDIG]];
  function numBlok(v) { for (const b of NUM_BLOK) if (v >= b[1] && v <= b[2]) return b[0]; return "#8"; }
  const numGrenzen = k => NUM_BLOK.find(b => b[0] === k);
  const blokEind = g => (g.soort === "mc" ? g.d * BLOK + BLOK - 1 : g.soort === "num" ? numGrenzen(g.k)[2] : ONEINDIG);
  const blokBegin = g => (g.soort === "mc" ? g.d * BLOK : g.soort === "num" ? numGrenzen(g.k)[1] : 0);
  const vglG = (a, b) => { for (let i = 0; i < Math.max(a.length, b.length); i++) { const x = a[i] ?? -1, y = b[i] ?? -1; if (x !== y) return x - y; } return 0; };
  const CACHE = new Map();
  function reeksen(sn) { const k = String(sn || ""); if (!CACHE.has(k)) CACHE.set(k, ontleed(k)); return CACHE.get(k); }
  function ontleed(sn) {
    const uit = [];
    for (let deel of sn.split(/\s*(?:,|<br\s*\/?>)\s*/i)) {
      deel = deel.trim(); if (!deel) continue;
      const r = { tekst: deel, variant: null, all: false, segs: [], zwak: null, a: null, b: null };
      const vm = /\s*\(([A-Z]{1,3})\)\s*$/i.exec(deel);
      if (vm) { r.variant = vm[1].toUpperCase(); deel = deel.slice(0, vm.index).trim(); }
      let links, rechts = null, op = false;
      const up = /^(.*?)\s*&\s*UP$/i.exec(deel);
      if (up) { links = up[1]; op = true; }
      else { const tm = deel.split(/\s+t\/m\s+/i); links = tm[0]; rechts = tm.length > 1 ? tm[1] : null; }
      const lt = links.trim().split(/\s+/);
      const A = grens(lt.length > 1 && !/^0$/.test(lt[0]) ? lt[lt.length - 1] : links);
      let B = rechts == null ? null : grens(rechts, A && A.soort === "pre" ? A : null);
      if (B && B.open) { B = null; op = true; }
      r.a = A; r.b = B;
      if (!A || A.soort === "onbekend") { r.onbekend = true; uit.push(r); continue; }
      if (B && B.soort === "onbekend") { r.segs.push({ k: A.k, lo: A.p, hi: blokEind(A), pre: A.pre, zachtHi: true }); uit.push(r); continue; }
      if (A.all && (op || !B)) { r.all = true; uit.push(r); continue; }
      // 18 okt (controle): geen 'waarschijnlijk' bij 'ALL t/m B' en 'A & Up' - zonder begin of eind is er geen 'ertussen'
      // (9Z123456 of een tikfout in de letter gaf op 106 kaarten 'Past waarschijnlijk'); een andere letter is daar 'buiten'.
      if (A.all && B) {
        r.segs.push({ k: B.k, lo: blokBegin(B), hi: B.pHi ?? B.p, pre: B.pre, zachtLo: true });
        uit.push(r); continue;
      }
      if (op || !B) {
        r.segs.push({ k: A.k, lo: A.p, hi: A.soort === "num" ? blokEind(A) : ONEINDIG, pre: A.pre, zachtHi: true });
        uit.push(r); continue;
      }
      if (A.k === B.k) {
        let lo = A.p, hi = B.pHi ?? B.p, zachtHi = false;
        if (lo > hi) { hi = ONEINDIG; zachtHi = true; }     // begin hoger dan eind: 'vanaf begin'
        r.segs.push({ k: A.k, lo, hi, pre: A.pre || B.pre, zachtHi });
      } else {                                            // andere reeks aan begin en eind: twee stukken
        r.segs.push({ k: A.k, lo: A.p, hi: blokEind(A), pre: A.pre, zachtHi: true });
        r.segs.push({ k: B.k, lo: blokBegin(B), hi: B.pHi ?? B.p, pre: B.pre, zachtLo: true });
        if (A.g && B.g && vglG(A.g, B.g) < 0) r.zwak = { van: A.g, tot: B.g };
      }
      uit.push(r);
    }
    return uit;
  }
  function plekIn(seg, t, compleetNodig) {
    if (seg.k[0] === "#") return t.num == null || numBlok(t.num) !== seg.k ? null : [t.num, t.num];
    if (seg.pre) {
      for (const v of seg.pre) {
        if (!t.s.startsWith(v)) continue;
        const rest = t.s.slice(v.length);
        if (/^\d{1,8}$/.test(rest)) return [+rest, +rest];
        if (!compleetNodig && rest === "") return [0, ONEINDIG];
      }
      if (!compleetNodig && seg.pre.some(v => v.startsWith(t.s))) return [0, ONEINDIG];
      return null;
    }
    if (!t.mc || t.mc.L !== seg.k) return null;
    if (compleetNodig && !t.mc.compleet) return null;
    return [t.mc.d * BLOK + +(t.mc.cijfers.padEnd(6, "0")), t.mc.d * BLOK + +(t.mc.cijfers.padEnd(6, "9"))];
  }
  const raakt = (seg, iv) => iv && iv[0] <= seg.hi && iv[1] >= seg.lo;
  // geenZwak (18 okt, controle): een letter van een eigen productlijn (N International, R Japan, E racing/jet, Q elektrisch)
  // die niet in de reeksen van de kaart voorkomt, is een ander soort motor - dan geen 'waarschijnlijk' (0N300000 op 9.9 HP).
  const LIJN = new Set(["N", "R", "E", "Q"]);
  function past(r, t, geenZwak) {                     // "zeker" | "waarschijnlijk" | "alle" | null
    if (!t || t.leeg) return null;
    if (r.all) return (t.mc && t.mc.compleet) || t.num != null ? "alle" : null;
    if (r.onbekend) return null;
    for (const seg of r.segs) { const iv = plekIn(seg, t, true); if (iv && raakt(seg, iv)) return "zeker"; }
    if (r.zwak && !geenZwak) {
      const g = t.mc && t.mc.compleet ? [1, t.mc.d, t.mc.L.charCodeAt(0), +t.mc.cijfers] : t.num != null && t.s.length >= 6 ? [0, t.num] : null;
      if (g && (!r.zwak.van || vglG(g, r.zwak.van) > 0) && (!r.zwak.tot || vglG(g, r.zwak.tot) < 0)) return "waarschijnlijk";
    }
    return null;
  }
  function kan(r, t, geenZwak) {                      // kan deze reeks nog, met wat er tot nu toe getypt is?
    if (!t || t.leeg || r.all || r.onbekend) return true;
    if (/^\d{1,7}$/.test(t.s) && !(t.s.length === 7 && r.segs.every(s => s.k[0] !== "#"))) return true;
    if (past(r, t, geenZwak)) return true;
    if (r.segs.some(seg => raakt(seg, plekIn(seg, t, false)))) return true;
    if (t.mc && !t.mc.compleet && r.zwak && !geenZwak) {
      const c = t.mc.L.charCodeAt(0), lo = [1, t.mc.d, c, +t.mc.cijfers.padEnd(6, "0")], hi = [1, t.mc.d, c, +t.mc.cijfers.padEnd(6, "9")];
      if ((!r.zwak.van || vglG(hi, r.zwak.van) > 0) && (!r.zwak.tot || vglG(lo, r.zwak.tot) < 0)) return true;
    }
    return false;
  }
  // versies: [{ id, sn: [{ sn, land }] }]. Twee zekere versies: een versie met een zachte grens ('& Up', letterwissel) wijkt
  // voor een versie met harde grenzen die er strakker omheen liggen; twee harde = overlap in de bron (beide tonen).
  function koppel(versies, tekst) {
    const t = lees(tekst), status = new Map(), strak = new Map();
    const rs = versies.map(v => ({ id: v.id, rs: [].concat(v.sn || []).flatMap(x => reeksen(typeof x === "string" ? x : x.sn)) }));
    const RANG = { zeker: 3, alle: 2, waarschijnlijk: 1 };
    const vreemd = !!(t.mc && LIJN.has(t.mc.L) && !rs.some(v => v.rs.some(r => r.segs.some(s => s.k === t.mc.L))));   // 18 okt
    for (const v of rs) {
      let best = null;
      for (const r of v.rs) { const p = past(r, t, vreemd); if (p && (!best || RANG[p] > RANG[best])) best = p; }
      status.set(v.id, best);
      if (best === "zeker") {
        const hard = v.rs.flatMap(r => r.segs.filter(seg => raakt(seg, plekIn(seg, t, true))))
          .map(seg => ({ lo: seg.zachtLo ? -ONEINDIG : seg.lo, hi: seg.zachtHi ? ONEINDIG : seg.hi, zacht: !!(seg.zachtLo || seg.zachtHi) }))
          .sort((a, b) => (a.hi - a.lo) - (b.hi - b.lo) || (a.zacht - b.zacht));
        strak.set(v.id, hard[0]);
      }
    }
    const zekerIds = rs.filter(v => status.get(v.id) === "zeker").map(v => v.id);
    if (zekerIds.length > 1) {
      const weg = zekerIds.filter(id => { const a = strak.get(id); return a.zacht && zekerIds.some(o => {
        const b = strak.get(o); return o !== id && b.lo >= a.lo && b.hi <= a.hi && (b.lo > a.lo || b.hi < a.hi); }); });
      if (weg.length < zekerIds.length) for (const id of weg) status.set(id, "wijkt");
    }
    const ids = s => rs.filter(v => status.get(v.id) === s).map(v => v.id);
    const zeker = ids("zeker"), wsch = ids("waarschijnlijk"), alle = ids("alle");
    let melding;
    const ergens = rs.some(v => v.rs.some(r => r.segs.some(s => plekIn(s, t, true))));
    if (t.leeg) melding = "";
    else if (t.modelnummer) melding = "modelnummer";
    else if (t.teLang && !ergens) melding = "te_lang";                 // 18 okt: 1C2345678
    else if ((t.mc && !t.mc.compleet) || /^\d{1,5}$/.test(t.s) || (!t.mc && t.num == null && !ergens))
      melding = /^[0-9OI]?[A-Z]?\d*$/.test(t.s) || rs.some(v => v.rs.some(r => r.segs.some(s => plekIn(s, t, false)))) ? "half" : "vorm";
    else if (zeker.length === 1) melding = "past";
    else if (zeker.length > 1) melding = "meer";
    else if (wsch.length) melding = "waarschijnlijk";
    else if (alle.length) melding = "alle";
    else melding = "buiten";
    return { t, status, zeker, waarschijnlijk: wsch, alle, melding, vreemd, kan: new Map(rs.map(v => [v.id, v.rs.some(r => kan(r, t, vreemd))])) };
  }
  // Kort schrijven, zoals op de sticker (cijfer + letter vet): de oudste versie in een reeks 't/m 0R833819', de nieuwste
  // 'vanaf 0R833820' (of tot het begin van een latere versie), ertussen 'A t/m B'; per land (Belgie eerst) hooguit twee
  // reeksen, de rest '+1'; 'ALL & Up' = 'alle serienummers'. vol: een kaart met een versie (begin en eind voluit).
  // -> per versie { delen: [{ tekst, html }], meer, tekst } of { reden } als elke versie dezelfde reeks heeft.
  const NL_VARIANT = { E: "elektrische start", M: "handstart", EL: "elektrische start, lange staart", ML: "handstart, lange staart" };
  const LAND_VOLG = { "België": 0, internationaal: 1, VS: 2, Canada: 3, "Australië": 4 };
  const nw = x => `<span class="nw">${x}</span>`;
  function kort(versies, vol) {
    const per = versies.map(v => ({ id: v.id, rs: [].concat(v.sn || []).flatMap(x => {
      const sn = typeof x === "string" ? x : x.sn, land = typeof x === "string" ? null : x.land || null;
      return reeksen(sn).map(r => Object.assign({}, r, { land }));
    }) }));
    const sl = v => [...new Set(v.rs.map(r => r.tekst))].sort().join("|");
    if (!vol && new Set(per.map(sl)).size === 1) return per.map(v => ({ id: v.id, delen: [], meer: 0, tekst: "", reden: "zelfde reeks" }));
    const alleSegs = per.flatMap(v => v.rs.flatMap(r => r.segs.map(s => ({ v, s }))));
    const alleRs = per.flatMap(v => v.rs.filter(r => !r.all).map(r => ({ v, r })));
    const landen = new Set(per.flatMap(v => v.rs.map(r => r.land).filter(Boolean)));
    return per.map(v => {
      const gezien = new Set();
      let rs = v.rs.filter(r => !gezien.has(r.tekst) && gezien.add(r.tekst));
      rs = rs.slice().sort((a, b) => (a.a && b.a && a.a.k === b.a.k ? a.a.p - b.a.p : 0));
      for (let i = 0; i + 1 < rs.length; i++) {          // aansluitende reeksen van hetzelfde land samen
        const x = rs[i], y = rs[i + 1];
        if (x.b && y.a && !y.a.all && x.b.k === y.a.k && x.land === y.land && !x.variant && !y.variant && (x.b.pHi ?? x.b.p) + 1 === y.a.p) {
          rs.splice(i, 2, Object.assign({}, x, { tekst: x.tekst + "+" + y.tekst, b: y.b, segs: x.segs.concat(y.segs) })); i--;
        }
      }
      rs.sort((a, b) => (LAND_VOLG[a.land] ?? 5) - (LAND_VOLG[b.land] ?? 5));
      if (!rs.length) return { id: v.id, delen: [], meer: 0, tekst: "" };
      if (rs.every(r => r.all)) return { id: v.id, delen: [{ tekst: "alle serienummers", html: "alle serienummers" }], meer: 0, tekst: "alle serienummers" };
      const stuk = r => {
        const variant = r.variant ? " (" + (NL_VARIANT[r.variant] || r.variant) + ")" : "";
        if (r.all) return ["alle nummers", "alle nummers"];
        if (r.onbekend || !r.a) return [r.tekst, esc(r.tekst)];
        const A = r.a, B = r.b;
        if (A.all) return ["t/m " + tk(B), nw("t/m " + hk(B))];
        if (!B) {
          const later = vol ? [] : alleSegs.filter(o => o.v !== v && o.s.k === A.k && o.s.lo > A.p && !o.s.zachtLo).map(o => o.s.lo);
          if (later.length) {
            const e = Object.assign({}, A, { p: Math.min(...later) - 1, ruw: "" });
            return [tk(A) + " t/m " + tk(e, A) + variant, nw(hk(A)) + " " + nw("t/m " + hk(e, A)) + esc(variant)];
          }
          return ["vanaf " + tk(A) + variant, nw("vanaf " + hk(A)) + esc(variant)];
        }
        // de oudste op deze kaart: alleen 't/m' (veilig als geen andere versie begint voor het eind van deze reeks)
        const voorEind = o => (o.r.a && o.r.a.g && B.g ? vglG(o.r.a.g, B.g) <= 0 : o.r.segs.some(x => r.segs.some(y => x.k === y.k && x.lo <= y.hi)));
        if (!vol && !alleRs.some(o => o.v !== v && voorEind(o))) return ["t/m " + tk(B) + variant, nw("t/m " + hk(B)) + esc(variant)];
        return [tk(A) + " t/m " + tk(B, A) + variant, nw(hk(A)) + " " + nw("t/m " + hk(B, A)) + esc(variant)];
      };
      const delen = rs.slice(0, 2).map(r => {
        const [x, y] = stuk(r), land = landen.size > 1 && r.land ? r.land : "";
        return { tekst: (land ? land + " " : "") + x, html: (land ? `<small>${esc(land)}</small> ` : "") + y };
      });
      const meer = Math.max(0, rs.length - 2);
      return { id: v.id, delen, meer, tekst: delen.map(x => x.tekst).join(" · ") + (meer ? " +" + meer : "") };
    });
  }
  // een grens zoals op de sticker; bij een Yamaha-voorstuk het eind zonder herhaald voorstuk (6E9-100101 t/m 105013)
  function tk(g, van) {
    if (!g) return "";
    if (g.soort === "mc") return Math.floor(g.p / BLOK) + g.k + String(g.p % BLOK).padStart(6, "0");
    if (g.soort === "pre") return van && van.soort === "pre" && van.k === g.k ? String(g.p).padStart(6, "0") : g.ruw ? g.ruw.replace(/\s+/g, "") : g.k + "-" + String(g.p).padStart(6, "0");
    return g.ruw ? g.ruw.replace(/\s+/g, "").replace(/^0(?=\d{7}$)/, "") : String(g.p);
  }
  function hk(g, van) { const x = tk(g, van); return g && g.soort === "mc" ? `<b>${esc(x.slice(0, 2))}</b>${esc(x.slice(2))}` : esc(x); }
  // het getypte nummer zoals op de sticker (cijfer + letter vet)
  const nummer = t => (t.mc && t.mc.compleet ? `<b>${t.mc.d}${esc(t.mc.L)}</b>${esc(t.mc.cijfers)}` : esc(t.s));
  // 18 okt (controle): volgorde van de versies - het hoogste punt in de g-volgorde (eind van een reeks, begin van een open
  // reeks); null als een reeks geen g heeft (Mariner, diesel, onleesbaar). 'ALL & Up' telt niet mee.
  function volgPunt(v) {
    let best = null;
    for (const x of [].concat(v.sn || [])) for (const r of reeksen(typeof x === "string" ? x : x.sn)) {
      if (r.all) continue;
      const g = r.onbekend || !r.a ? null : r.b ? r.b.g : r.a.g;
      if (!g) return null;
      if (!best || vglG(g, best) > 0) best = g;
    }
    return best;
  }
  return { lees, reeksen, past, koppel, kort, nummer, volgPunt, vgl: vglG };
})();

// ---- Honda: framenummer (honda_serienummer.js, 17 okt; 3.723 van 3.723 nummers vinden hun eigen versie)
const HO = (function () {
  const OPEN = 9999999, RE_REEKS = /^([A-Z]{4})-(\d{7})-(\d{7})$/, LETTER = "[A-HJ-NPR-WYZ]";   // geen I, O, Q, X
  function leesReeks(sn) {
    const m = RE_REEKS.exec(String(sn || "").trim());
    return m ? { p: m[1], van: Number(m[2]), tot: Number(m[3]), open: Number(m[3]) === OPEN } : null;
  }
  const RE_HEEL = new RegExp("^(B" + LETTER + "{3})([0-9OIL]*)$");
  const RE_BINNEN = new RegExp("(?:^|[^A-Z])(B" + LETTER + "{3})\\s*-?\\s*([0-9]{7})(?![0-9])");
  const RE_BEGIN = new RegExp("^B" + LETTER + "{0,2}$");
  function lees(tekst) {
    const ruw = String(tekst || "").toUpperCase().replace(/[‐-―]/g, "-").trim();
    if (!ruw) return { leeg: true };
    const c = ruw.replace(/[\s\-.\/_:,]/g, ""), cijfers = x => x.replace(/O/g, "0").replace(/[IL]/g, "1");
    let m = /^(B75|BF\d{2,3}[LS]?)([0-9]{7})$/.exec(c);      // oude motoren (jaren '70-'80): geen reeksen
    if (m) return { oud: m[1], nr: m[2] };
    m = RE_HEEL.exec(c) || RE_BINNEN.exec(ruw);              // ook het plaatje overgetypt: 'BF15D SHSU BALJ-1512345'
    if (m) { const nr = cijfers(m[2]); return { p: m[1], nr, heel: nr.length === 7, te: nr.length > 7, cijfers: "" }; }
    if (/^BF?P?\d{1,3}[A-Z]{1,4}\d{7}$/.test(c)) return { fout: "motornr" };   // 18 okt: BF20DE-1512345 = het motorblok
    if (/^BF?P?\d/.test(c)) return { fout: "model" };      // BF15D, BFP20
    if (RE_BEGIN.test(c)) return { p: c, nr: "", heel: false, te: false, cijfers: "" };
    if (/^[0-9OI]+$/.test(c) && /\d/.test(c)) { const nr = cijfers(c); return { p: "", nr, heel: false, te: nr.length > 7, cijfers: nr }; }
    return { fout: "vorm" };
  }
  function maakIndex(reeksen) {
    const per = new Map();
    for (const r of reeksen) if (r) { if (!per.has(r.p)) per.set(r.p, new Set()); per.get(r.p).add(r.van); }
    return new Map([...per].map(([p, s]) => [p, [...s].sort((a, b) => a - b)]));
  }
  // begrensd einde: tot het volgende begin met dezelfde letters; een reeks onder 8000001 loopt niet door in blok 8
  // (tegengesteld draaiend: BBHJ-8000001 = BF115D-XCU)
  const BLOK8 = 8000000;
  function einde(r, index) {
    const tot = r.van < BLOK8 ? Math.min(r.tot, BLOK8 - 1) : r.tot, begins = index && index.get(r.p);
    const volg = begins && begins.find(v => v > r.van);
    return volg == null ? tot : Math.min(tot, volg - 1);
  }
  function kan(r, t, index) {
    if (!t || t.leeg || t.fout || t.oud) return true;
    if (t.p && !r.p.startsWith(t.p)) return false;
    if (t.nr === "" || t.te) return true;
    const lo = Number(t.nr.slice(0, 7).padEnd(7, "0")), hi = Number(t.nr.slice(0, 7).padEnd(7, "9"));
    return lo <= einde(r, index) && hi >= r.van;
  }
  const past = (r, p, n, index) => r.p === p && n >= r.van && n <= einde(r, index);
  // versies: [{ reeksen }] van de kaart; alle: [{ m, reeksen }] van het hele merk (voor 'hoort bij een andere motor')
  // -> status: leeg typen model motornr vorm oud te_lang letters past meer tussen elders onbekend
  function koppel(t, versies, alle, index) {
    const uit = (status, x) => Object.assign({ status, treffers: [] }, x || {});
    if (t.leeg) return uit("leeg");
    if (t.fout) return uit(t.fout);
    if (t.oud) return uit("oud");
    if (t.te) return uit("te_lang");
    const voorstukken = [...new Set(versies.flatMap(v => v.reeksen.map(r => r.p)))];
    let p = t.p, aangevuld = false;
    if (!p) {                                                // alleen cijfers: met een voorstuk op de kaart aanvullen
      if (t.nr.length < 7) return uit("typen");
      if (voorstukken.length !== 1) return uit("letters", { voorstukken });
      p = voorstukken[0]; aangevuld = true;
    }
    if (p.length < 4 || t.nr.length < 7) return uit("typen");
    const n = Number(t.nr), extra = { p, nr: t.nr, aangevuld }, hits = [];
    versies.forEach((v, i) => { if (v.reeksen.some(r => past(r, p, n, index))) hits.push(i); });
    if (hits.length) return uit(hits.length === 1 ? "past" : "meer", Object.assign(extra, { treffers: hits }));
    const el = alle.filter(v => v.reeksen.some(r => past(r, p, n, index)));
    if (el.length) return uit("elders", Object.assign(extra, { elders: el.map(v => v.m) }));
    if (voorstukken.includes(p)) {                         // in een gat: de versie die het laatst voor dit nummer begon
      // 18 okt (controle): onder de laagste reeks begon er geen versie voor dit nummer - dan geen 'komt het dichtst in de buurt'
      let best = null;
      versies.forEach((v, i) => v.reeksen.forEach(r => {
        if (r.p !== p || n < r.van) return;
        const d = n - r.van;
        if (!best || d < best.d) best = { i, d };
      }));
      return uit("tussen", Object.assign(extra, { dichtst: best ? best.i : null }));
    }
    if (index.has(p)) return uit("tussen", Object.assign(extra, { dichtst: null }));
    return uit("onbekend", extra);
  }
  // Weergave: begrensde einden (een oude open reeks zegt geen 'en hoger' als er een nieuwere is; blok 8 begrenst niet),
  // een einde op ..0000 telt als ..9999, aansluitende stukken samen; dan 'BALJ-14 _ _ _ _ _', '12 _ of 13 _', '322 t/m 329',
  // 'en hoger' of voluit.
  const netEinde = tot => (tot !== OPEN && tot % 10000 === 0 ? tot - 1 : tot);
  function stukken(reeksen, index) {
    return reeksen.filter(Boolean).map(r => {
      let tot = einde(r, index);
      if (r.open && r.van < BLOK8 && tot >= BLOK8 - 1) tot = OPEN;
      tot = netEinde(tot);
      return { p: r.p, van: r.van, tot, open: tot === OPEN };
    }).sort((a, b) => a.p.localeCompare(b.p) || a.van - b.van);
  }
  function samenvoegen(rs) {
    const uit = [];
    for (const r of rs) {
      const v = uit[uit.length - 1];
      if (v && v.p === r.p && r.van <= v.tot + 2) { v.tot = Math.max(v.tot, r.tot); v.open = v.tot === OPEN; v.delen.push(r); }
      else uit.push(Object.assign({}, r, { delen: [r] }));
    }
    return uit;
  }
  function kortVan(r) {
    for (const k of [6, 5, 4]) {
      const blok = 10 ** k, kop = x => String(x).padStart(7 - k, "0");
      if ((r.van - 1) % blok !== 0) continue;
      const lo = (r.van - 1) / blok;
      if (r.open) return { p: r.p, koppen: [kop(lo)], vrij: k, hoger: true };
      if ((r.tot + 1) % blok !== 0) continue;
      const hi = (r.tot + 1) / blok - 1;
      if (hi - lo + 1 > 3) return { p: r.p, koppen: [kop(lo), kop(hi)], vrij: k, tm: true };
      const koppen = [];
      for (let x = lo; x <= hi; x++) koppen.push(kop(x));
      return { p: r.p, koppen, vrij: k };
    }
    return r.open ? { p: r.p, van: r.van, hoger: true } : { p: r.p, van: r.van, tot: r.tot };
  }
  const netjes = k => !!k.koppen && !k.tm;
  function kort(reeksen, index) {
    const uit = [];
    for (const s of samenvoegen(stukken(reeksen, index))) {
      const k = kortVan(s), los = s.delen.length > 1 ? s.delen.map(kortVan) : null;
      if (!netjes(k) && los && los.every(netjes)) uit.push(...los); else uit.push(k);
    }
    return uit;
  }
  return { leesReeks, lees, maakIndex, einde, kan, past, koppel, kort };
})();
// Generatie van een Honda-versie uit de modelnaam (BF20DK3 -> D; A < D < J), voor de volgorde in de lijst (18 okt).
const hoGen = ms => Math.max(0, ...ms.map(m => { const x = /^BFP?\d+(?:\.\d+)?([A-Z]?)/.exec(String(m.n).toUpperCase()); return x && x[1] ? x[1].charCodeAt(0) : 0; }));
// Per merk een keer: de Honda-reeksen van alle motoren (begrensde einden en 'hoort bij een andere motor').
let HO_ALLE = null, HO_ALLE_VAN = null;
function hoAlle() {
  if (HO_ALLE && HO_ALLE_VAN === D) return HO_ALLE;
  const lijst = D.motoren.map(m => ({ m, reeksen: [HO.leesReeks(m.sn)].filter(Boolean) })).filter(x => x.reeksen.length);
  HO_ALLE = { lijst, index: HO.maakIndex(lijst.flatMap(x => x.reeksen)) }; HO_ALLE_VAN = D;
  return HO_ALLE;
}
// 'BALJ-14 _ _ _ _ _' (Suzuki-schrijfwijze: vast deel vet, open plekken); mk.kop: de cijfers na het streepje licht goud
// (daarin verschillen de versies), mk.p: ook de letters als de kaart meer voorstukken heeft (BF40: BAYL/BAYS/BBDJ).
// Elk stuk een eigen blok, zodat '12 _ of 13 _' op de telefoon kan afbreken.
function hoKortHtml(k, mk, uit) {
  const c = `snn hon${uit ? " uit" : ""}`, m = mk && !uit ? mk : {};
  const p = m.p ? `<mark>${esc(k.p)}</mark>` : esc(k.p), kop = x => (m.kop ? `<mark>${esc(x)}</mark>` : esc(x));
  if (!k.koppen) {
    const z = x => String(x).padStart(7, "0");
    return `<span class="${c}"><b>${p}-</b>${esc(z(k.van))}</span><span class="${c}">${k.hoger ? "en hoger" : `t/m ${esc(z(k.tot))}`}</span>`;
  }
  const vrij = `<span class="vrij" aria-hidden="true">${"<i></i>".repeat(k.vrij)}</span><span class="vh"> en dan ${k.vrij} cijfers</span>`;
  // drie opeenvolgende koppen (12, 13, 14) als '12 _ t/m 14 _': past op de telefoon op een regel (18 okt)
  const tm = k.tm || k.koppen.length === 3, koppen = k.koppen.length === 3 ? [k.koppen[0], k.koppen[2]] : k.koppen;
  return koppen.map((x, i) => `<span class="${c}">${i ? `<span class="sntus">${tm ? "t/m" : "of"}</span><b>${kop(x)}</b>` : `<b>${p}-${kop(x)}</b>`}${vrij}`
    + `${k.hoger && i === koppen.length - 1 ? `<span class="sntus na">en hoger</span>` : ""}</span>`).join("");
}

// ---- tekeningen en tip
// Cijferrondjes zo groot dat het cijfer op de telefoon (Mercury 100 px breed zoals Suzuki, Honda 78 px: de eerste versie
// moet ook na een korte route in het eerste scherm staan; was 84, 18 okt: ruimte voor de noot over het blok) minstens
// 16,7 px is; een rondje dat buiten de tekening zou vallen, schuift naar binnen; het lijntje begint aan de rand van het rondje.
function mhTekening(naam, label) {
  const [vb, sp, lijf, goud, nrs] = MH_TEK[naam], [x0, y0, W, H] = vb.split(" ").map(Number);
  const breed = naam.startsWith("honda") ? 78 : 100;      // breedte op de telefoon (css .snplek)
  const F = Math.max(25, Math.ceil(W * 16.7 / breed)), R = +(F * 0.66).toFixed(1), f = x => +x.toFixed(1);
  let lijnen = "", rondjes = "";
  for (const [x, y, tx, ty, n] of nrs) {
    const cx = Math.min(Math.max(x, x0 + R + 1.5), x0 + W - R - 1.5), cy = Math.min(Math.max(y, y0 + R + 1.5), y0 + H - R - 1.5);
    if (tx != null) {
      const dx = tx - cx, dy = ty - cy, l = Math.hypot(dx, dy) || 1;
      if (l > R + 2) lijnen += `<path d="M${f(cx + dx / l * R)} ${f(cy + dy / l * R)}L${tx} ${ty}" stroke="${SN_NAVY}" stroke-width="2.5" stroke-linecap="round"/>`;
    }
    rondjes += `<circle cx="${f(cx)}" cy="${f(cy)}" r="${R}" fill="${SN_GOUD}" stroke="${SN_NAVY}" stroke-width="2.5"/>`
      + `<text x="${f(cx)}" y="${f(cy + F * 0.35)}" text-anchor="middle" font-family="Blinker, Arial, sans-serif" font-size="${F}" font-weight="800" fill="${SN_NAVY}" stroke="none">${n}</text>`;
  }
  return `<svg class="snplek" viewBox="${vb}" role="img" aria-label="${esc(label)}">`
    + `<g fill="none" stroke="currentColor" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"${sp ? ` transform="translate(${sp} 0) scale(-1 1)"` : ""}>`
    + MH_LIJF[lijf] + goud + `</g>` + lijnen + rondjes + `</svg>`;
}
// Mercury: plekken uit tests/serienummer_proef/mercury/plekken_mercury.json en tekening/tekeningen.json (werkplaatshandboeken
// en Mercury-boekjes); kant in woorden van de boot (zoals Suzuki). Tekening per soort kaart (mercury_tekening.js): buitenboord
// < 8 pk de sticker bovenop de beugel, 8-25 pk de helmstoktekening, groter of onbekend de klem; '_blok' (tweede plek laag op het
// blok) bij tweetakt/OptiMax en bij een viertakt met alleen oude nummers. Zonder tekening (plek niet nagekeken: diesel,
// SportJet (opdracht 18 okt), Force, elektrisch, Sears, trolling): een korte algemene regel.
const MC_KLEM = ["Aan de klem", ", rechterkant van de boot: sticker net onder de kap."];
const MC_BEUGEL = ["Bovenop de beugel", ": kantel de motor, dan zie je de sticker."];
const MC_BLOK = ["Onder de kap", ": laag op het motorblok, rechterkant van de boot."];
// 18 okt (controle): MerCruiser-motoren en staartstukken delen de letters (0B..0W) - een staartstuknummer paste in de
// motorkaart. Daarom per soort: veld = de vraag boven het veld, tref = de regel onder 'Bekijk onderdelen', buiten = erbij als
// het nummer niet past. Mercury telt over alle modellen door: het nummer kiest de versie, niet het model (tref standaard).
const MC_TREF = "Klopt het model? Het nummer kiest alleen de versie.";
// Buitenboord (18 okt, controle): de regel uit het onderzoek dat het serienummer niet het modelnummer erboven is.
const MC_BB_NOOT = "Typ het Serial Number, niet het modelnummer.";   // kort: tweetakt 115 pk eerste versie op 814 van 844
const MC_TIP = {
  merc_bb_groot_klem_sb: { regels: [MC_KLEM], noot: MC_BB_NOOT },
  merc_bb_groot_klem_blok_sb: { regels: [MC_KLEM, MC_BLOK], noot: MC_BB_NOOT },
  merc_bb_draagbaar_klem_sb: { regels: [MC_KLEM], noot: MC_BB_NOOT },
  merc_bb_draagbaar_klem_blok_sb: { regels: [MC_KLEM, MC_BLOK], noot: MC_BB_NOOT },
  merc_bb_klein_beugel_sb: { regels: [MC_BEUGEL], noot: MC_BB_NOOT },
  merc_bb_klein_beugel_blok_sb: { regels: [MC_BEUGEL, MC_BLOK], noot: MC_BB_NOOT },
  merc_mercruiser_motor_hek_sb: { knop: "Waar zit het motornummer?", regels: [["Op de motor", ": sticker op de motorkap of bovenop het luchtfilter."],
    ["Op het blok", ": plaatje aan de rechterkant van de boot, bij de startmotor."]], noot: "Het staartstuk en de spiegelplaat hebben een eigen nummer.",
    veld: "Heb je het motornummer?", tref: "Is dit het nummer van de motor? Het staartstuk heeft een eigen nummer.",
    buiten: "Het staartstuk heeft een eigen nummer: typ het nummer van de motor." },
  merc_mercruiser_staartstuk_bb: { knop: "Waar zit het nummer van het staartstuk?", regels: [["Op het staartstuk", ", linkerkant van de boot."],
    ["Bravo", ": ook ingeslagen achter het achterdekseltje."]], noot: "Typ het nummer van het staartstuk, niet het motornummer.",
    veld: "Heb je het nummer van het staartstuk?", tref: "Is dit het nummer van het staartstuk? De motor heeft een eigen nummer.",
    buiten: "De motor heeft een eigen nummer: typ het nummer van het staartstuk." },
  // 18 okt (controle, MerCruiser 350/377 MAG OMM p.21-22): bij Bravo is het nummer ingeslagen in de U-boutplaat
  merc_mercruiser_spiegelplaat_bb: { knop: "Waar zit het nummer van de spiegelplaat?", regels: [["Bovenop de spiegelplaat", ": sticker (Alpha) of ingeslagen in de U-boutplaat (Bravo)."],
    ["Op het gimbalhuis", ": ingeslagen, buiten tegen de spiegel."]],
    veld: "Heb je het nummer van de spiegelplaat?", tref: "Is dit het nummer van de spiegelplaat? Motor en staartstuk hebben een eigen nummer.",
    buiten: "Motor en staartstuk hebben een eigen nummer: typ het nummer van de spiegelplaat." },
  merc_zeus_sb: { knop: "Waar zit het nummer van de aandrijving?", regels: [["Onderaan de aandrijving", ", in de boot: sticker en ingeslagen nummer."],
    ["Op de transmissie", ": plaatje bovenop de aandrijving."]] },
};
MC_TIP.merc_mercruiser_motor_binnen_sb = MC_TIP.merc_mercruiser_motor_hek_sb;
const mcEerste = sn => { const s = String(sn || "").toUpperCase().trim(); return !s || /^ALL\b/.test(s) ? "" : s.split(/\s+(?:T\/M|&)\s+|\s+/)[0].replace(/^O(?=[A-Z]\d)/, "0"); };
// Soort van de kaart (18 okt, controle): de soort van de meeste motoren met een nummer, Sears/Force/elektrisch alleen als er
// niets anders is; bij gelijke stand die van de eerste motor (zoals eerst). Was: alleen de eerste motor - via 'Weet ik niet'
// stond in '9,9 pk' de Sears eerst en zag de klant geen tekening, terwijl 9 van de 10 motoren de klem-blok-tekening hebben.
function mcSoort(ms) {
  const K = D.knoppen1 || [], soortVan = m => (m.p && m.p[0] ? m.p[0][0] : -1), tel = new Map();
  const metNr = ms.filter(m => mcEerste(m.sn));
  for (const m of metNr.length ? metNr : ms) tel.set(soortVan(m), (tel.get(soortVan(m)) || 0) + 1);
  const apart = i => K[i] && K[i].kop === "Buitenboordmotor" && /Elektrisch|Force|Sears/.test(K[i].tekst || "");
  let kand = [...tel].filter(([i]) => !apart(i));
  if (!kand.length) kand = [...tel];
  const eerste = soortVan(ms[0]);
  kand.sort((a, b) => b[1] - a[1] || (b[0] === eerste) - (a[0] === eerste));
  return K[kand[0][0]] || {};
}
function mcTip(groep) {
  const ms = groep.map(r => r.m), k = mcSoort(ms);
  const soort = k.kop + " / " + k.tekst, metNr = ms.filter(m => mcEerste(m.sn));
  let naam = null;
  if (k.kop === "Buitenboordmotor" && !/Elektrisch|Force|Sears/.test(k.tekst || "")) {
    const pks = ms.map(m => m.pk).filter(p => typeof p === "number"), pk = pks.length ? Math.max(...pks) : null;
    const maat = pk === null || pk > 25 ? "groot_klem" : pk < 8 ? "klein_beugel" : "draagbaar_klem";
    const mariner = metNr.length > 0 && metNr.every(m => /^[0-9A-Z]{3,4}-|^E-/.test(mcEerste(m.sn)));
    const oud = m => /^\d{5,8}$/.test(mcEerste(m.sn)) || /^0[A-Z]\d{6}/.test(mcEerste(m.sn));
    const blok = !mariner && (/Tweetakt|OptiMax/.test(k.tekst || "") || (metNr.length > 0 && metNr.every(oud)));
    naam = "merc_bb_" + maat + (blok ? "_blok" : "") + "_sb";
  } else if (soort === "Hekaandrijving / Engines - Gas") naam = "merc_mercruiser_motor_hek_sb";
  else if (soort === "Binnenboordmotor / Benzine") naam = "merc_mercruiser_motor_binnen_sb";
  else if (k.kop === "Revisiemotor") naam = ms.every(m => /inboard/i.test(m.n)) ? "merc_mercruiser_motor_binnen_sb" : "merc_mercruiser_motor_hek_sb";
  else if (soort === "Hekaandrijving / Drives") naam = "merc_mercruiser_staartstuk_bb";
  else if (soort === "Hekaandrijving / Transom Assemblies") naam = "merc_mercruiser_spiegelplaat_bb";
  else if (k.kop === "Zeus-pod") naam = "merc_zeus_sb";
  if (naam && MC_TIP[naam]) return Object.assign({ naam, knop: "Waar zit het serienummer?", label: "Tekening: waar het serienummer zit.",
                                                    veld: "Heb je het serienummer?", tref: MC_TREF }, MC_TIP[naam]);
  const pomp = k.kop === "Jetaandrijving" && ms.every(m => /JET DRIVE\)|PUMP/i.test(m.n) && !/POWERHEAD/i.test(m.n));
  return { naam: null, knop: pomp ? "Waar zit het pompnummer?" : "Waar zit het serienummer?", regels: [], veld: "Heb je het serienummer?", tref: MC_TREF,
           noot: (/Diesel/.test(soort) ? "Op de motor zit een plaatje of sticker met het motornummer." : pomp ? "Op de pomp zit een sticker of plaatje met het pompnummer."
             : "Op de motor zit een sticker of plaatje met het serienummer.") + " Typ het nummer zoals het er staat." };
}
// Voorbeeld voor het veld: het begin van de nieuwste reeks op de kaart (cijfer + letter eerst).
function mcVoorbeeld(ms) {
  const nrs = ms.map(m => mcEerste(m.sn)).filter(Boolean), cl = nrs.filter(n => /^\d[A-Z]\d{6}$/.test(n));
  return (cl.length ? cl : nrs).sort((x, y) => (x[0] === y[0] ? x.localeCompare(y) : x[0] - y[0])).pop() || "1B227000";
}
// Honda: alleen plek 1, het framenummer aan de klem (het motornummer op het blok is een ander nummer). Kant per voorstuk
// uit tests/serienummer_proef/honda/plekken_honda.json (Owner's Manuals per generatie); tekening per kaart zoals
// honda/tekening/kaarten_per_tekening.js (achteraanzicht: links in de tekening = linkerkant van de boot).
const HO_PLEK = {};
for (const [klein, kant, lijst] of [
  [1, "?", "BAEB BAEL BAES BZBF BZBJ BZBK BZBL BABL BABS BABU BAAL BAAS BAAU"], [1, "draaibus", "BABC BAVJ"],
  [1, "bb", "BACC BADC BAEC BAAJ BABJ BALJ BAMJ"], [1, "beide", "BADL BADS"], [1, "voorkant", "BACL BACS BACU BZBC"],
  [0, "sb", "BAJL BAJS BAJU BAWL BAWS BAPU BLAG BSAG BANU BLAF BSAF BAYL BAYS BAYU BAZJ BAZL BAZS BAZU BBFJ BBAL BBAU BBBJ BBBL "
    + "BBBU BBAJ BBCJ BBMJ BZBD BZBG BZBE BZBH BBHJ BARJ BASJ BANJ BAPJ BBWJ BBUJ BBTJ"],
  [0, "bb", "BATJ BAUJ BBDJ BBEJ BBJJ BBRJ BBPJ BBNJ BBYJ"], [0, "beide", "BAJJ BAKJ BAEJ BAFJ BAGJ BAHJ"]])
  for (const p of lijst.split(" ")) HO_PLEK[p] = [klein, kant];
function hoTekening(voorstukken) {
  const info = voorstukken.map(p => HO_PLEK[p] || [0, "?"]), kanten = new Set(info.map(x => x[1]));
  const grootte = info.every(x => x[0]) ? "draagbaar" : "groot", alleen = (...ks) => [...kanten].every(x => ks.includes(x));
  const bf5a = voorstukken.some(p => p === "BADL" || p === "BADS");
  if (alleen("bb")) return "honda_" + grootte + "_bb";
  if (alleen("sb")) return "honda_" + grootte + "_sb";
  if (alleen("draaibus", "voorkant")) return "honda_draagbaar_boven";
  if (grootte === "draagbaar" && alleen("draaibus", "voorkant", "bb", "beide") && (bf5a || kanten.has("voorkant") || kanten.has("draaibus"))
      && (!kanten.has("beide") || bf5a)) return "honda_draagbaar_boven_of_bb";
  return "honda_" + grootte + "_beide";
}
// 18 okt (controle): BF8A (BACL/BACS/BACU/BZBC, 'voorkant') heeft het plaatje voorop de klem onder de kap, niet bovenop de
// draaibus (Owner's Manual BF8A p.69); 'boven_of_bb' viel eerst onder /_bb$/ en zei dan alleen 'linkerkant'. De noot over het
// motorblok staat in het onderzoek (Honda-tiptekst): klanten typen anders het motornummer.
// Een regel, zodat de tip op de telefoon niet hoger wordt (BF15/BF90 na een korte route: eerste versie net in beeld).
const HO_NOOT = "Niet het nummer op het blok.";
function hoTip(voorstukken) {
  const naam = hoTekening(voorstukken), plaat = "metalen plaatje met 4 letters en 7 cijfers.";
  const kanten = new Set(voorstukken.map(p => (HO_PLEK[p] || [0, "?"])[1]));
  const voorop = kanten.has("voorkant") && !kanten.has("draaibus") && !kanten.has("beide");
  const regel = /boven_of_bb$/.test(naam) ? (voorop ? ["Aan de klem", ": voorop (vlak onder de kap) of aan de linkerkant van de boot: " + plaat]
                                                    : ["Bovenop de draaibus", " (vlak onder de kap) of aan de klem, linkerkant van de boot: " + plaat])
    : /boven$/.test(naam) ? (voorop ? ["Aan de voorkant van de klem", " (kant van de boot), vlak onder de kap: " + plaat]
                                    : ["Bovenop de draaibus", ", vlak onder de kap: " + plaat])
    : /_bb$/.test(naam) ? ["Aan de klem", ", linkerkant van de boot: " + plaat]
    : /_sb$/.test(naam) ? ["Aan de klem", ", rechterkant van de boot: " + plaat]
    : ["Aan de klem", " (kijk aan beide kanten): " + plaat];
  return { naam, knop: "Waar zit het serienummer?", label: "Tekening: waar het framenummer zit.", regels: [regel], noot: HO_NOOT };
}
// Een tekening per soort een keer opbouwen (18 okt, controle: de Mercury/Honda-lijst tekende merkbaar trager).
const MH_TEK_KLAAR = new Map();
const mhTekeningKlaar = (naam, label) => {
  const k = naam + "|" + label;
  if (!MH_TEK_KLAAR.has(k)) MH_TEK_KLAAR.set(k, mhTekening(naam, label));
  return MH_TEK_KLAAR.get(k);
};
function mhTipHtml(info, id, open) {
  const T = info.tip;
  const ol = T.regels.length ? `<ol>${T.regels.map((r, i) => `<li>${T.naam ? `<span class="snnr" aria-hidden="true">${T.naam.startsWith("honda") ? 1 : i + 1}</span>` : ""}<b>${esc(r[0])}</b>${esc(r[1])}</li>`).join("")}</ol>` : "";
  return `<div class="sntip${open ? " open" : ""}${T.naam ? "" : " zonder"}" data-tipopen="${open ? 1 : 0}" data-tip="${esc(T.naam || "algemeen")}">
    <button type="button" class="sntip-knop" data-sntip="1" aria-expanded="${open}" aria-controls="${esc(id)}">${ik("vraag")}${esc(T.knop)}</button>
    <div class="sntip-samen" id="${esc(id)}">${T.naam ? mhTekeningKlaar(T.naam, T.label) : ""}${ol}${T.noot ? `<p class="snnoot">${esc(T.noot)}</p>` : ""}</div></div>`;
}

// ---- kaart, versieregels en het veld
// De kaart krijgt het veld als minstens twee versies een nummer hebben en het nummer iets beslist (Mercury: niet als elke
// versie dezelfde reeks heeft of alleen 'ALL'/onleesbaar; Honda: de 9 oude kaarten zonder reeks vallen hier al af).
function mhInfo(groep, teksten, naam) {
  const m0 = groep[0].m, ms = teksten.map(t => t.v.map(r => r.m).filter(m => m.sn));
  if (ms.filter(x => x.length).length < 2) return null;
  const info = { mh: D.merk, teksten, ms, naam, ids: new Set(groep.map(r => r.m.id)), model: m0.n };
  if (D.merk === "Mercury") {
    const versies = ms.map((x, i) => ({ id: i, sn: x.map(m => ({ sn: m.sn, land: m.k.fabriek || null })) }));
    const kort = MC.kort(versies);
    if (kort.some(k => k.reden) || !versies.some(v => v.sn.some(x => MC.reeksen(x.sn).some(r => r.segs.length)))) return null;
    Object.assign(info, { versies, kort, vb: mcVoorbeeld(ms.flat()), tip: mcTip(groep) });
  } else {
    const A = hoAlle(), rs = ms.map(x => x.map(m => HO.leesReeks(m.sn)).filter(Boolean));
    if (rs.filter(x => x.length).length < 2) return null;
    const p = [...new Set(rs.flat().map(r => r.p))].sort();
    Object.assign(info, { rs, kort: rs.map(x => HO.kort(x, A.index)), mk: { kop: true, p: p.length > 1 }, p, tip: hoTip(p) });
  }
  // Volgorde (18 okt, controle): verschillen de jaren niet (Honda nooit, Mercury meestal niet), dan de nieuwste reeks bovenaan
  // - eerst stond die vaak achter 'Toon alle n versies' en las de lijst door elkaar. Mercury: het hoogste punt in de g-volgorde
  // (MC.volgPunt), Honda: de generatie (A, D, J uit de modelnaam) en dan het begin van de reeks. Versies zonder bruikbaar
  // nummer achteraan. Verschillen de jaren wel, dan de volgorde van KB.versies (het jaar van de klant eerst).
  info.volg = teksten.map((t, i) => i);
  if (new Set(teksten.map(t => Math.max(...t.v.map(r => r.m.j || 0)))).size === 1) {
    const punt = info.mh === "Mercury" ? info.versies.map(MC.volgPunt)
      : info.rs.map((x, i) => (x.length ? [hoGen(ms[i]), Math.max(...x.map(r => r.van))] : null));
    info.volg.sort((a, b) => (punt[a] == null) - (punt[b] == null) || (punt[a] && punt[b] ? MC.vgl(punt[b], punt[a]) : 0) || a - b);
  }
  if (info.mh === "Honda") {
    // voorbeeld in het veld: de nieuwste reeks van de bovenste versie (was: over alle voorstukken, gaf BBBU uit ca. 1999)
    // binnen het begrensde einde van die reeks (BZBC-1500001 t/m 1502587: niet 1512345)
    const top = info.rs[info.volg.find(i => info.rs[i].length)], nieuw = top.slice().sort((a, b) => b.open - a.open || b.van - a.van)[0];
    const ruimte = HO.einde(nieuw, hoAlle().index) - nieuw.van;
    info.vb = nieuw.p + "-" + String(nieuw.van + Math.min(12344, Math.max(0, Math.floor(ruimte / 2)))).padStart(7, "0");
  }
  // Kop per versie: zei de oude regel alleen 'Serienummer ...' (of 'Code ...'), dan wordt de korte reeks de kop; anders
  // ('Gebouwd in VS') blijft de kop en staat de reeks eronder. ' · 805 onderdelen' (twee gelijke koppen) is niet meer nodig
  // als de reeksen verschillen.
  const sl = i => ms[i].map(m => m.sn).sort().join("|"), basis = t => (t.dubbel ? t.basis : t.hoofd);
  const landen = info.mh === "Mercury" && info.kort.some(k => k.delen.some(d => d.html.startsWith("<small>")));
  info.regel = teksten.map((t, i) => {
    const uniek = !teksten.some((x, j) => j !== i && basis(x) === basis(t) && sl(j) === sl(i));
    let kop = t.dubbel && uniek ? t.basis : t.hoofd;
    const delen = String(t.klein || "").split(" · ").filter(x => x && !/^Serienummer /.test(x));
    if (t.dubbel && uniek && t.codes && !delen.includes(t.codes)) delen.unshift(t.codes);
    if (/^(Serienummer|Code) /.test(kop) || (/^Gebouwd in /.test(kop) && landen)) {
      const rest = kop.split(" · ").slice(1).join(" · "); if (rest) delen.unshift(rest); kop = null;
    }
    return { kop, klein: [...new Set(delen)].join(" · ") };
  });
  return info;
}
// Korte reeks(en) van een versie; uit = grijs (kan niet meer bij wat er getypt is).
function mhSnHtml(info, i, uit) {
  if (info.mh === "Mercury") {
    const k = info.kort[i];
    return (k.delen || []).map(d => `<span class="snn mcn${uit ? " uit" : ""}">${d.html}</span>`).join("") + (k.meer ? `<span class="snmeer">+${k.meer}</span>` : "");
  }
  return info.kort[i].map(k => hoKortHtml(k, info.mk, uit)).join("");
}
// Kaart met een versie: de korte reeks voluit (er valt niets te kiezen, dus geen veld).
function mhEen(v) {
  const ms = v.map(r => r.m).filter(m => m.sn);
  if (!ms.length) return "";
  if (D.merk === "Mercury") {
    const k = MC.kort([{ id: 0, sn: ms.map(m => ({ sn: m.sn, land: m.k.fabriek || null })) }], true)[0];
    return k.delen.length ? `<span class="snrij">${k.delen.map(d => `<span class="snn mcn">${d.html}</span>`).join("")}${k.meer ? `<span class="snmeer">+${k.meer}</span>` : ""}</span>` : "";
  }
  const rs = ms.map(m => HO.leesReeks(m.sn)).filter(Boolean);
  return rs.length ? `<span class="snrij">${HO.kort(rs, hoAlle().index).map(k => hoKortHtml(k, null)).join("")}</span>` : "";
}
// Versieregel zoals bij Suzuki (kop 20 px met de pijl, eronder klein); o.uit: grijs, o.cls: ' past', o.m: precies de motor
// waar het nummer bij hoort (dan geen 'Kies je code').
function mhRij(info, i, o = {}) {
  const t = info.teksten[i], m = o.m || t.m, r = info.regel[i], kies = t.kies && !o.m ? kiesHtml(t.kies) : "";
  const sn = info.ms[i].length ? mhSnHtml(info, i, o.uit) : `<small>Serienummer onbekend</small>`;
  const kop = r.kop == null ? `<span class="vkop">${sn}</span>` : `<b>${esc(r.kop)}</b>`;
  const onder = (r.klein ? `<small>${esc(r.klein)}</small>` : "") + (r.kop == null ? "" : `<span class="snrij">${sn}</span>`);
  return `<a class="versie snv mhv${o.cls || ""}" href="${esc(motorUrl(m))}" data-motor="${m.id}"><span class="vjaar">${kop}</span>`
    + (onder ? `<span class="vsn">${onder}</span>` : "") + `${PIJL()}</a>${kies}`;
}
function mhLijstGewoon(info, kan) {
  const n = info.teksten.length, E = 4, rij = i => mhRij(info, i, { uit: kan ? !kan(i) : false }), alle = info.volg;   // 18 okt: info.volg
  return alle.slice(0, E).map(rij).join("")
    + (n > E ? `<details><summary>Toon alle ${n} versies</summary>${alle.slice(E).map(rij).join("")}</details>` : "");
}
// Het nummer past: die versie bovenaan in navy met 'Bekijk onderdelen' (zoals Suzuki), de rest dichtgeklapt; meer versies:
// die bovenaan met een navy streep.
// 18 okt (controle): de rest en meer treffers in de volgorde van de lijst (info.volg); Mercury: onder de knop de regel van de
// soort (tip.tref: het nummer kiest de versie, niet het model; MerCruiser: motor- of staartstuknummer) - onder de knop, zoals
// de Suzuki-noot, zodat 'Bekijk onderdelen' op de telefoon even hoog blijft.
function mhLijstTreffer(info, hits, nr, kop) {
  const rest = info.volg.filter(i => !hits.some(h => h.i === i));
  hits = hits.slice().sort((a, b) => info.volg.indexOf(a.i) - info.volg.indexOf(b.i));
  let boven;
  if (hits.length === 1) {
    const { i, m } = hits[0], r = info.regel[i], noot = info.tip.tref || "";
    const sub = r.kop || (info.mh === "Honda" ? m.n : ""), reeks = info.mh === "Mercury" && !r.kop ? info.kort[i].tekst : "";
    boven = `<div class="treffer"><p class="tkop">${ik("vink")}<span>${esc(kop || "Past bij jouw nummer")}</span></p>
      <p class="tnr">${nr}${sub ? `<span class="tsub">${esc(sub)}</span>` : ""}</p>${reeks ? `<p class="tbereik">Reeks ${esc(reeks)}</p>` : ""}
      <a class="naar" href="${esc(motorUrl(m))}" data-motor="${m.id}">${m.o === 0 ? "Nog geen onderdelen online" : "Bekijk onderdelen"}${PIJL()}</a>${noot ? `<p class="tnoot">${esc(noot)}</p>` : ""}</div>`;
  } else boven = `<div class="treffers">${hits.map(h => mhRij(info, h.i, { cls: " past", m: h.m })).join("")}</div>`;
  return boven + (rest.length ? `<details class="anders"><summary>Andere versies (${rest.length})</summary>${rest.map(i => mhRij(info, i)).join("")}</details>` : "");
}
// Uitweg (zoals Suzuki): een foto via WhatsApp, niet het contactformulier.
const mhFoto = (info, invoer) => `<p class="snfoto">Twijfel je? <a href="${esc(WHATSAPP + "?text=" + encodeURIComponent(
  `Hallo, welke versie is mijn ${D.merk} ${info.naam}?${invoer ? " Nummer op de motor: " + invoer + "." : ""} Ik stuur een foto van de motor mee.`))}"
  target="_blank" rel="noopener">Stuur ons een foto van de motor via WhatsApp</a></p>`;
const mhZeg = x => `<p class="snmelding">${x}</p>`;
function mcUitkomst(info, invoer) {
  const k = MC.koppel(info.versies, invoer), t = k.t, kan = i => k.kan.get(i) !== false, vb = esc(info.vb);
  const gewoon = (melding, metKan) => ({ lijst: mhLijstGewoon(info, metKan ? kan : null), melding: melding || "" });
  if (t.leeg) return gewoon();
  if (k.melding === "modelnummer") return gewoon(mhZeg(`Dat is het modelnummer. Typ het nummer bij Serial Number, zoals ${vb}.`));
  if (k.melding === "half") return gewoon("", true);
  if (k.melding === "vorm") return gewoon(mhZeg(`Typ het serienummer zoals het op de sticker staat, zoals ${vb}.`));
  // 18 okt (controle): een cijfer te veel gaf geen melding en alles grijs
  if (k.melding === "te_lang") return gewoon(mhZeg(`Na het cijfer en de letter staan 6 cijfers, zoals ${/^\d[A-Z]\d{6}$/.test(info.vb) ? vb : "1B227000"}. Klopt elk cijfer?`));
  const nr = `<span class="snn mcn">${MC.nummer(t)}</span>`;
  const motor = (i, st) => info.ms[i].find(m => MC.reeksen(m.sn).some(r => MC.past(r, t) === st)) || info.ms[i][0];
  const hits = (ids, st) => ids.map(i => ({ i, m: motor(i, st) }));
  if (k.zeker.length === 1) return { lijst: mhLijstTreffer(info, hits(k.zeker, "zeker"), nr), melding: "" };
  if (k.zeker.length > 1)
    return { lijst: mhLijstTreffer(info, hits(k.zeker, "zeker"), nr), melding: mhZeg(`Je nummer past bij ${k.zeker.length} versies. Kijk naar het verschil.`) + mhFoto(info, invoer) };
  // waarschijnlijk: een andere reeks (letter) die in de oude doorlopende volgorde ertussen valt; niet zeker, dus de uitweg erbij
  if (k.waarschijnlijk.length === 1) return { lijst: mhLijstTreffer(info, hits(k.waarschijnlijk, "waarschijnlijk"), nr, "Past waarschijnlijk bij jouw nummer"), melding: mhFoto(info, invoer) };
  if (k.waarschijnlijk.length > 1)
    return { lijst: mhLijstTreffer(info, hits(k.waarschijnlijk, "waarschijnlijk"), nr), melding: mhZeg(`Je nummer past waarschijnlijk bij ${k.waarschijnlijk.length} versies.`) + mhFoto(info, invoer) };
  if (k.alle.length === 1) return { lijst: mhLijstTreffer(info, hits(k.alle, "alle"), nr), melding: "" };
  if (k.alle.length > 1) return { lijst: mhLijstTreffer(info, hits(k.alle, "alle"), nr), melding: mhZeg(`Je nummer past bij ${k.alle.length} versies.`) + mhFoto(info, invoer) };
  // zes cijfers zonder cijfer + letter ervoor (en geen oude cijferreeks op deze kaart)
  if (/^\d{6}$/.test(t.s) && /^\d[A-Z]/.test(info.vb)) return gewoon(mhZeg(`Typ ook het cijfer en de letter die ervoor staan, zoals ${esc(info.vb.slice(0, 2))}.`));
  // Mercury telt over alle modellen door (0G..., 1B...): een nummer buiten deze kaart zegt niet welke motor het wel is.
  // MerCruiser (18 okt): erbij dat motor en staartstuk elk een eigen nummer hebben (tip.buiten).
  return gewoon(mhZeg("Dit nummer hoort niet bij deze motor. Klopt elk cijfer?" + (info.tip.buiten ? " " + esc(info.tip.buiten) : "")) + mhFoto(info, invoer), true);
}
function hoUitkomst(info, invoer) {
  const A = hoAlle(), t = HO.lees(invoer), vb = esc(info.vb);
  const kan = i => !info.rs[i].length || info.rs[i].some(r => HO.kan(r, t, A.index));
  const gewoon = (melding, metKan) => ({ lijst: mhLijstGewoon(info, metKan ? kan : null), melding: melding || "" });
  const k = HO.koppel(t, info.rs.map(rs => ({ reeksen: rs })), A.lijst, A.index);
  const nr = k.p ? `<span class="snn mcn"><b>${esc(k.p)}</b>-${esc(k.nr)}</span>` : "";
  const motor = i => info.ms[i].find(m => { const r = HO.leesReeks(m.sn); return r && HO.past(r, k.p, Number(k.nr), A.index); }) || info.ms[i][0];
  switch (k.status) {
    case "leeg": return gewoon();
    case "typen": return gewoon("", true);
    case "model": return gewoon(mhZeg(`Dat is de modelnaam. Het framenummer begint met B en drie letters, zoals ${vb}.`));
    // 18 okt (controle): BF20DE-1512345 (model + letters + 7 cijfers) is het nummer van het motorblok, niet de modelnaam
    case "motornr": return gewoon(mhZeg(`Dat lijkt het motornummer. Neem het plaatje aan de klem: dat begint met B en drie letters, zoals ${vb}.`));
    case "vorm": return gewoon(mhZeg(`Een framenummer is vier letters en zeven cijfers, zoals ${vb}.`));
    case "te_lang": return gewoon(mhZeg("Na de vier letters staan zeven cijfers."));
    case "oud": return gewoon(mhZeg("Dat is een nummer van een oude Honda (jaren '70-'80). Daarvoor hebben we geen nummerlijst.") + mhFoto(info, invoer));
    case "letters": return gewoon(mhZeg(k.voorstukken.length <= 4 ? `Typ ook de vier letters die ervoor staan: ${esc(snOf(k.voorstukken))}?`
      : `Typ ook de vier letters die ervoor staan, zoals ${esc(k.voorstukken[0])}.`), true);
    case "past": return { lijst: mhLijstTreffer(info, [{ i: k.treffers[0], m: motor(k.treffers[0]) }], nr), melding: "" };
    case "meer": return { lijst: mhLijstTreffer(info, k.treffers.map(i => ({ i, m: motor(i) })), nr),
                          melding: mhZeg(`Je nummer past bij ${k.treffers.length} versies.`) + mhFoto(info, invoer) };
    case "tussen": {                                       // in een gat tussen twee reeksen: de versie eronder als 'kan ook'
      if (k.dichtst == null) return gewoon(mhZeg("Je nummer staat niet in onze lijst. Klopt elk cijfer?") + mhFoto(info, invoer), true);
      const rest = info.volg.filter(i => i !== k.dichtst);
      return { lijst: `<div class="treffers">${mhRij(info, k.dichtst, { cls: " past" })}</div>`
        + (rest.length ? `<details class="anders"><summary>Andere versies (${rest.length})</summary>${rest.map(i => mhRij(info, i)).join("")}</details>` : ""),
               melding: mhZeg("Je nummer staat niet in onze lijst. Deze versie komt het dichtst in de buurt.") + mhFoto(info, invoer) };
    }
    case "elders": {
      // 18 okt (controle): per kaart een keer, eerst de kaarten met dezelfde uitvoering als deze (SHU bij SHU), dan dezelfde
      // staartlengte (eerste letter); een ander model heet zo ('hoort bij een BF15'), niet 'een andere uitvoering'.
      const deze = String(KB.kaartNaam(info.teksten[0].m)), model = deze.split(" ")[0], uitv = deze.split(" ")[1] || "";
      const perKaart = new Map();
      for (const m of k.elders) if (!info.ids.has(m.id)) { const n = String(KB.kaartNaam(m)); if (!perKaart.has(n)) perKaart.set(n, m); }
      const score = n => { const u = n.split(" ")[1] || ""; return u === uitv ? 0 : u && u[0] === uitv[0] ? 1 : 2; };
      const ms = [...perKaart].sort((a, b) => score(a[0]) - score(b[0])).slice(0, 3).map(x => x[1]);
      if (!ms.length) return gewoon(mhZeg("Je nummer staat niet in onze lijst. Klopt elk cijfer?") + mhFoto(info, invoer), true);
      const modellen = [...new Set(ms.map(m => String(KB.kaartNaam(m)).split(" ")[0]))];
      const welk = modellen.every(x => x === model) ? "een andere uitvoering" : modellen.length === 1 ? "een " + toonNaam(modellen[0]) : "een andere motor";
      // uitvoeringen delen vaak een reeks (SHU, LHU, LHSU): 'een andere uitvoering', met waar het nummer wel staat
      return { lijst: mhLijstGewoon(info, kan), melding: `<div class="elders"><p class="snmelding">Dit nummer hoort bij ${esc(welk)}</p>${ms.map(m =>
        `<a class="versie" href="${esc(motorUrl(m))}" data-motor="${m.id}"><span><b>${esc(toonNaam(KB.kaartNaam(m)))}</b><small>${esc(m.n)}</small></span>${PIJL()}</a>`).join("")}</div>` + mhFoto(info, invoer) };
    }
    default: return gewoon(mhZeg("Dit nummer kennen we niet. Neem het nummer van het plaatje aan de klem (begint met B), niet dat van het motorblok.") + mhFoto(info, invoer), true);
  }
}
// gevonden: een versie past (navy blok); snWerkBij zet dan de tip weg, zodat 'Bekijk onderdelen' op de telefoon in beeld
// blijft (18 okt: BF15 na een korte route viel de knop er anders net onder).
function mhUitkomst(info, invoer) {
  const u = info.mh === "Mercury" ? mcUitkomst(info, invoer) : hoUitkomst(info, invoer);
  u.gevonden = u.lijst.includes('<div class="treffer">');
  return u;
}
function mhZoekHtml(sl, info, tipOpen) {
  return `<div class="snzoek">
    <label for="sn-${esc(sl)}">${esc(info.tip.veld || "Heb je het serienummer?")}</label>
    <div class="snveld"><input id="sn-${esc(sl)}" data-snkaart="${esc(sl)}" type="text" autocomplete="off" autocorrect="off"
      autocapitalize="characters" spellcheck="false" enterkeyhint="done" placeholder="bv. ${esc(info.vb)}"
      aria-describedby="snh-${esc(sl)}"><button type="button" class="snwis" data-snwis="1" hidden aria-label="Wis het nummer">${ik("kruis")}</button></div>
    <div class="snuitslag" aria-live="polite"></div>
    ${mhTipHtml(info, "snh-" + sl, tipOpen)}</div>`;
}

function filtersHtml(groepen) {
  // Knoppen met 0 kaarten niet tonen (controle2: tik gaf 'Geen motor past'), behalve als ze gekozen zijn.
  const zicht = g => g.ws.filter(w => (g.tel.get(w) || 0) > 0 || (S.filters[g.veld] && S.filters[g.veld].has(w)));
  groepen = groepen.filter(g => g.actief || zicht(g).length);
  const blok = g => {
    const V = VELDEN[g.veld], set = S.filters[g.veld] || new Set();
    const ws = V.volgorde ? zicht(g).sort((a, b) => V.volgorde.indexOf(a) - V.volgorde.indexOf(b))
             : zicht(g).sort((a, b) => (parseFloat(a.replace(",", ".")) - parseFloat(b.replace(",", "."))) || a.localeCompare(b, "nl"));
    for (const w of set) if (!ws.includes(w)) ws.push(w);
    return `<div class="fgroep"><h3>${esc(V.titel)}</h3><div class="fknoppen">${ws.map(w =>
      `<button class="fk${set.has(w) ? " aan" : ""}" data-filter="${g.veld}" data-waarde="${esc(w)}" aria-pressed="${set.has(w)}">${ikoonVoor(g.veld, w)}<span>${esc(label(g.veld, w))}</span><span class="n">${(g.tel.get(w) || 0).toLocaleString("nl")}</span></button>`).join("")}</div></div>`;
  };
  // Volgorde: gekozen groepen, dan groepen die de kaarten echt splitsen, dan de rest (klanttest v3:
  // groepen met alleen 0 duwden Kleur en Bouwjaar achter 'Meer kenmerken').
  groepen = groepen.slice().sort((a, b) => (b.actief - a.actief) || (b.nuttig - a.nuttig));
  const open = groepen.slice(0, OPEN_GROEPEN), dicht = groepen.slice(OPEN_GROEPEN);
  return open.map(blok).join("") + (dicht.length
    ? (S.meer ? dicht.map(blok).join("") : `<button class="stil" style="margin:8px 0 0" data-actie="meerkenm">Meer kenmerken (${dicht.length})</button>`) : "");
}

// Uitleg van de modelcode onder de filters (Dieter 16 okt: "voor elk merk apart de model afkortingen uitgelegd"),
// uit modelcodes.js (maak_modelcodes.py; gecontroleerd in officiele bronnen en tegen onze data). De Yamaha-uitleg
// gaat over buitenboordmotoren en blijft weg bij een lijst met alleen waterscooters.
// rijen = de motoren op de lijst die passen (controle2: een 'kan ook'-motor zonder soort haalde de uitleg op elke
// waterscooterlijst terug); rijen zonder soort tellen niet mee.
function codesHtml(rijen) {
  const M = (window.MODELCODES || {})[D.merk];
  if (!M) return "";
  const met = rijen.filter(r => (r.m.s || []).length);
  if (D.merk === "Yamaha" && met.length && met.every(r => (r.m.s || []).includes("Waterscooter (WaveRunner)"))) return "";
  const vb = M.voorbeeld;
  return `<div class="codes"><h3>Wat betekent de code?</h3>
    <p class="codes-vb">Voorbeeld: <b>${esc(vb.naam)}</b></p>
    <ul class="codes-delen">${vb.delen.map(([d, t]) => `<li><b>${esc(d)}</b><span>${esc(t)}</span></li>`).join("")}</ul>
    <dl class="codes-lijst">${M.codes.map(([c, t, p]) => `<div><dt>${esc(c)}</dt><dd>${esc(t)}${p ? `<small>${esc(p)}</small>` : ""}</dd></div>`).join("")}</dl></div>`;
}

function tekenLijst(rijen) {
  app.classList.add("lijstscherm");
  SN_KAART.clear(); snTipGetoond = false;                // serienummer (17 okt): per lijst opnieuw
  const kl = KB.klassen(rijen);
  const groepen = KB.filterGroepen(D, S, rijen, kl, KB.velden(D, S, ALLE_VELDEN));
  // Kaarten en volgorde uit logica.js (controle2 17 okt: KB.lijstKaarten, zodat de tests meten wat hier staat): per pk
  // (kleinste eerst) met een kopje als er meer pk's zijn; daarbinnen het dichtstbijzijnde jaar in de kaart (zonder jaar
  // de nieuwste eerst), Europa eerst, minst onbekend. Een motor die alleen door het jaar niet zeker is, staat als lagere
  // versie in de zekere kaart met dezelfde naam; 'Kan ook' begint met de naam of tegel die de klant koos.
  const { gZ, gO, dj, ookDichtbij } = KB.lijstKaarten(D, S, rijen, kl);
  // Waterscooter met een gekozen romp (controle 17 okt: 'Kan ook de jouwe zijn (91)' op elke lijst): onder 'Kan ook' de
  // kaarten met de gekozen naam of romp (KB: ookDichtbij); de andere waterscooters achter 'Toon andere waterscooters'. Zijn er
  // geen met die naam of romp, dan heet het blok 'Andere waterscooters'. Weg gaat er niets.
  const dicht = ookDichtbij != null && ookDichtbij > 0 && !S.toonAndere ? ookDichtbij : null;   // null = alles zoals voorheen
  const ookTitel = ookDichtbij === 0 ? `Andere waterscooters (${gO.length.toLocaleString("nl")})`
    : `Kan ook de jouwe zijn (${(dicht != null ? dicht : gO.length).toLocaleString("nl")})`;
  const ookN = dicht != null ? dicht : gO.length;
  const zeker = gZ.flat();
  // Welke kenmerken komen op de kaart: twee bekende waarden tussen de getoonde kaarten (woord), of een kaart die het
  // bij al zijn motoren niet weet tegenover een die het wel weet (grijze regel). Ook na 'Weet ik niet' (juist dan);
  // alleen een gekozen filter staat al als chip boven de lijst.
  const verschilt = { woord: new Set(), onbekend: new Set() };
  const basisG = gZ.length ? gZ : gO;
  for (const v of KAART_VELDEN) {
    if (S.filters[v] && S.filters[v].size) continue;
    const bekend = new Set(basisG.map(g => KB.gedeeld(g)[v]).filter(w => w != null));
    if (bekend.size > 1) verschilt.woord.add(v);
    if (KB.KAART_ZICHT.includes(v) && basisG.some(g => g.some(r => r.m.k[v] != null))
        && basisG.some(g => g.every(r => r.m.k[v] == null && !KB.nvt(r.m, v)))) verschilt.onbekend.add(v);
  }
  const toon = S.toon || 20, toonOok = S.toonOok || 20;
  const meerPk = new Set(gZ.map(g => g[0].m.pk)).size > 1;
  const lijstHtml = (gs, st) => {
    let uit = "", huidig, open = false;
    for (const g of gs) {
      const pk = g[0].m.pk;
      if (meerPk && st === "zeker" && pk !== huidig) {
        if (open) uit += "</div>";
        uit += `<h2 class="pkkop">${pk != null ? esc(nl(pk)) + " pk" : "Vermogen onbekend"}</h2><div class="lijst">`;
        open = true; huidig = pk;
      }
      // Bij meer dan 2 kaarten eerst de kaart kiezen, dan de versie (versies dichtgeklapt: korte lijst).
      uit += kaartHtml(g, st, kl, verschilt, gZ.length === 1 && st === "zeker", st !== "zeker" || gZ.length > 2, dj);
    }
    if (open) uit += "</div>";
    return meerPk && st === "zeker" ? uit : `<div class="lijst">${uit}</div>`;
  };
  // 'waterscooters' als de lijst alleen waterscooters heeft.
  const [een, veel] = [motorenWoord(zeker, 1), motorenWoord(zeker, 2)];
  const kop = gZ.length === 1 ? `1 ${een} past` : gZ.length ? `${gZ.length.toLocaleString("nl")} ${veel} passen` : `Geen ${een} past op al je keuzes`;
  // De hint over het modeljaar een keer boven de lijst (controle2: stond op elke kaart, tot 18 keer). Zonder jaar: het
  // modeljaar is vaak een jaar voor het aankoopjaar. Met een los jaar J en versies van J en J-1 in een kaart: kijk ook bij
  // J-1 (die staat als tweede). Na een tijdvak of '2013 of later' niets.
  const perJaar = g => new Set(g.map(r => r.m.j).filter(j => j != null)).size > 1;
  const jaarHint = !dj ? (gZ.some(perJaar) ? "Het modeljaar is vaak een jaar vóór je aankoopjaar" : "")
    : dj.jaar != null && gZ.some(g => g.some(r => r.m.j === dj.jaar) && g.some(r => r.m.j === dj.jaar - 1))
      ? `Gekocht in ${dj.jaar}? Kijk ook bij modeljaar ${dj.jaar - 1}` : "";
  // Niets over: per gekozen kenmerk laten zien wat het weghalen ervan oplevert.
  let geen = "";
  if (!gZ.length) {
    const opties = [];
    for (const [veld, set] of Object.entries(S.filters)) for (const w of set) {
      const f = {}; for (const [v, s] of Object.entries(S.filters)) f[v] = new Set(s); f[veld].delete(w);
      const n = KB.telKaarten(rijen.filter(r => KB.toets(r, f, kl, null) === "zeker"));
      if (n) opties.push(`<button class="knop" data-filter="${veld}" data-waarde="${esc(w)}">Zonder ${esc(label(veld, w).toLowerCase())} (${n})</button>`);
    }
    geen = opties.length ? `<div class="geen">${opties.join("")}</div>` : "";
  }
  const aantalF = Object.values(S.filters).reduce((n, s) => n + s.size, 0);
  const filters = filtersHtml(groepen), codes = codesHtml(zeker.length ? zeker : gO.flat());
  zetTitel(kop + " – Vind je motor");
  app.innerHTML = `${navHtml(true)}
    <div class="resultaat${filters || codes ? "" : " zonder-zijbalk"}">
      <aside class="zijbalk" aria-label="Kenmerken">${filters ? `<h2>Kenmerken</h2>${filters}` : ""}${codes}</aside>
      <section>
        <h2 class="bm-vjm-vraag teller" tabindex="-1" aria-live="polite">${esc(kop)}</h2>
        ${jaarHint && gZ.length ? `<p class="hint lijsthint">${esc(jaarHint)}</p>` : ""}
        ${filters || codes ? `<button class="kenm-knop" data-actie="lade">${ik("filter")}${filters ? "Kenmerken" : "Wat betekent de code?"}${aantalF ? ` (${aantalF})` : ""}</button>` : ""}
        ${geen}
        ${gZ.length ? lijstHtml(gZ.slice(0, toon), "zeker") : ""}
        ${gZ.length > toon ? `<div class="midden"><button class="knop" data-actie="meer">Toon ${Math.min(20, gZ.length - toon)} meer</button></div>` : ""}
        ${gO.length ? `<details class="ookjouw"${gZ.length ? "" : " open"}><summary>${esc(ookTitel)}</summary>
          ${lijstHtml(gO.slice(0, Math.min(toonOok, ookN)), "misschien")}
          ${ookN > toonOok ? `<div class="midden"><button class="knop" data-actie="meerook">Toon ${Math.min(20, ookN - toonOok)} meer</button></div>`
            : dicht != null && gO.length > dicht ? `<div class="midden"><button class="knop" data-actie="andere" data-n="${dicht}">Toon andere waterscooters (${(gO.length - dicht).toLocaleString("nl")})</button></div>` : ""}
        </details>` : ""}
      </section>
    </div>`;
  lade.innerHTML = `<div class="ladekop"><h2 id="bm-vjm-ladetitel">Kenmerken</h2><button data-actie="sluit">Sluiten${ik("kruis")}</button></div>
    <div class="ladeinhoud">${filters}${codes}</div>
    <div class="ladevoet">${aantalF ? `<button class="knop" data-actie="wis">Wis alles</button>` : ""}
      <button class="knop hoofd" data-actie="sluit">${gZ.length === 1 ? `Toon 1 ${een}` : `Toon ${gZ.length.toLocaleString("nl")} ${veel}`}</button></div>`;
  snHerstel();                                           // het getypte serienummer blijft staan na een filter of terug
}
function openLade(focusSel, plek) {
  lade.hidden = false; document.body.style.overflow = "hidden";
  const inhoud = lade.querySelector(".ladeinhoud"); if (inhoud && plek) inhoud.scrollTop = plek;
  const k = (focusSel && lade.querySelector(focusSel)) || lade.querySelector("button"); if (k) k.focus({ preventScroll: true });
}
function sluitLade() { if (!lade.hidden) { lade.hidden = true; document.body.style.overflow = ""; } }

// ------------------------------------------------------------------ tikken
document.addEventListener("click", async e => {
  const b = e.target.closest("button, a"); if (!b) return;
  if (!wortel.contains(b) && !lade.contains(b)) return;   // alleen tikken in de zoeker
  const d = b.dataset;
  if (b.tagName === "A") {
    if (d.motor && D) {
      const m = D.motoren.find(x => x.id === d.motor);
      if (m) { onthoud(m); if (INGEBED && window.bmScannerKiesMotor) { e.preventDefault(); kiesInScanner(m); } }
    } else if (d.laatste && INGEBED && window.bmScannerKiesMotor) {
      const l = laatste();
      if (l) { e.preventDefault(); window.bmScannerKiesMotor({ id: l.id, brand: l.merk_rij || l.merk, model_name: l.n }); }
    }
    return;
  }
  if (Date.now() - getekendOp < 300 && !lade.contains(b)) { e.preventDefault(); return; }   // geen doortikken
  if (d.merk) {
    try { D = await laad(d.merk); } catch (err) { return toonFout(); }
    return verder(KB.nieuweStaat(d.merk));
  }
  if (d.terug) return terugNaar(d.terug);
  const n = kopie();
  for (const k of ["soort", "kop1", "pkk", "groep2", "dec2", "cc", "jaar"]) if (d[k] !== undefined) { n[k] = d[k]; return verder(n); }   // 18 okt: geen dec/jaar2
  if (d.k1 !== undefined) { n.k1 = Number(d.k1); return verder(n); }
  if (d.k2 !== undefined) {
    n.k2 = d.k2.includes(",") ? d.k2.split(",").map(Number) : Number(d.k2);
    if (d.k2tekst) n.k2tekst = d.k2tekst;
    return verder(n);
  }
  if (d.weetniet) {
    const w = d.weetniet; n[w] = null;
    if (w === "kop1") { n.k1 = null; if (D.merk === "Honda") n.pkk = null; }
    return verder(n);
  }
  if (d.zie) { n.filters[d.zie] = new Set([d.waarde]); n.gevraagd[d.zie] = 1; return verder(n); }
  if (d.zieniet) { n.gevraagd[d.zieniet] = 1; return verder(n); }
  if (d.filter) {
    const set = n.filters[d.filter] || (n.filters[d.filter] = new Set());
    set.has(d.waarde) ? set.delete(d.waarde) : set.add(d.waarde);
    // Op een 'wat zie je'-vraag: een antwoord weghalen = die vraag opnieuw (niet naar de lijst springen).
    if (scherm === "ziet") { delete n.gevraagd[d.filter]; return verder(n); }
    n.lijst = true; n.meer = S.meer;
    const sel = `[data-filter="${d.filter}"][data-waarde="${CSS.escape(d.waarde)}"]`;
    const open = !lade.hidden, inhoud = lade.querySelector(".ladeinhoud"), plek = inhoud ? inhoud.scrollTop : 0;
    const zij = b.closest(".zijbalk"), zplek = zij ? zij.scrollTop : 0;
    vervang(n);
    if (open) openLade(sel, plek);
    if (zij) { const z = app.querySelector(".zijbalk"); if (z) { z.scrollTop = zplek; const k = z.querySelector(sel); if (k) k.focus({ preventScroll: true }); } }
    return;
  }
  switch (d.actie) {
    case "terug": return location.hash.startsWith("#vjm=") ? history.back() : stapTerug();
    case "opnieuw": return verder(KB.nieuweStaat());
    case "lijst": n.lijst = true; return verder(n);
    case "wis": { n.filters = {}; const open = !lade.hidden; vervang(n); if (open) openLade(); return; }
    case "meerkenm": { S.meer = true; const open = !lade.hidden; teken(false); if (open) openLade(); return; }
    case "meer": S.toon = (S.toon || 20) + 20; return teken(false);
    case "meerook": S.toonOok = (S.toonOok || 20) + 20; teken(false); { const det = app.querySelector("details.ookjouw"); if (det) det.open = true; } return;
    // waterscooter (17 okt): de andere waterscooters onder 'Kan ook' (20 erbij na die met de gekozen naam of romp)
    case "andere": S.toonAndere = true; S.toonOok = Number(d.n || 0) + 20; teken(false); { const det = app.querySelector("details.ookjouw"); if (det) det.open = true; } return;
    case "lade": return openLade();
    case "sluit": return sluitLade();
  }
});
document.addEventListener("keydown", e => { if (e.key === "Escape") sluitLade(); });

(async () => {
  const s = KB.uitHash(location.hash) || (START_MERK ? KB.nieuweStaat(START_MERK) : null);
  if (s && s.merk) { try { D = await laad(s.merk); S = s; } catch (e) { return toonFout(); } }
  teken(false);
})();
if (!INGEBED) window.addEventListener("error", () => toonFout());

// ------------------------------------------------------------------ samen met de scanner (thema)
// Motor kiezen = de scanner laadt hem (onderdelen + klikbare tekeningen) op dezelfde pagina.
function kiesInScanner(m) {
  window.bmScannerKiesMotor({ id: m.id, brand: m.merk_rij || D.merk, model_name: m.n, model_year: m.j || undefined });
}
// Wat de scanner meldt: een foto (zoeker niet meer nodig: weg) of een gekozen motor (zoeker blijft gewoon
// staan, niet inklappen - Dieter 16 okt: "dit mag gewoon standaard er staan zonder dropdown").
window.vindJeMotor = {
  melding(wat) {
    sluitLade();
    if (wat === "foto") wortel.hidden = true;
  },
};
(window.vindJeMotorWacht || []).forEach(([wat, m]) => window.vindJeMotor.melding(wat, m));
window.vindJeMotorWacht = [];
})();
